var firstload = true;
// Store selected addon products (products that can be added together with main product)
var selectedAddonProducts = [];

/**
 * Merge cart attributes via Shopify Ajax Cart API (/cart/update.js).
 * Keeps CartJS.cart in sync and fires the same jQuery events as CartJS.
 */
function jscUpdateCartAttributes(partialAttributes) {
   var base = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
   var url = String(base).replace(/\/?$/, '') + '/update.js';
   $(document).trigger('cart.requestStarted', [{}]);
   return fetch(url, {
      method: 'POST',
      headers: {
         'Content-Type': 'application/json',
         Accept: 'application/json',
      },
      body: JSON.stringify({ attributes: partialAttributes }),
   })
      .then(function (res) {
         if (!res.ok) {
            throw new Error(res.statusText || 'Cart update failed');
         }
         return res.json();
      })
      .then(function (cart) {
         if (typeof CartJS !== 'undefined' && CartJS.cart) {
            CartJS.cart = cart;
         }
         $(document).trigger('cart.requestComplete', [cart]);
         document.dispatchEvent(
            new CustomEvent('theme:cart:change', {
               detail: { cart: cart },
               bubbles: true,
            })
         );
         return cart;
      })
      .catch(function (err) {
         console.error('jscUpdateCartAttributes', err);
         $(document).trigger('cart.requestComplete', [typeof CartJS !== 'undefined' ? CartJS.cart : {}]);
         throw err;
      });
}

var jscGwpSyncInProgress = false;

function jscGetGwpConfig() {
   return window.theme && window.theme.gwp ? window.theme.gwp : null;
}

function jscFindGwpLineItem(cart, cfg) {
   if (!cart || !cart.items || !cfg) return null;
   for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (item.properties && item.properties._GWP === 'true') return item;
      if (cfg.variantId && item.variant_id === cfg.variantId) return item;
   }
   return null;
}

function jscCartHasQualifyingItem(cart, cfg) {
   if (!cart || !cart.items || !cfg) return false;
   for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (item.properties && item.properties._GWP === 'true') continue;
      if (cfg.qualifyingProductId && item.product_id === cfg.qualifyingProductId) return true;
      if (
         cfg.qualifyingCollectionProductIds &&
         cfg.qualifyingCollectionProductIds.length &&
         cfg.qualifyingCollectionProductIds.indexOf(item.product_id) !== -1
      ) {
         return true;
      }
   }
   return false;
}

function jscGwpDispatchCartUpdate(cart) {
   if (typeof CartJS !== 'undefined' && CartJS.cart) {
      CartJS.cart = cart;
   }
   $(document).trigger('cart.requestComplete', [cart]);
   document.dispatchEvent(
      new CustomEvent('theme:cart:change', {
         detail: { cart: cart },
         bubbles: true,
      })
   );
}

function jscGwpCartRequest(url, body) {
   $(document).trigger('cart.requestStarted', [{}]);
   return fetch(url, {
      method: 'POST',
      headers: {
         'Content-Type': 'application/json',
         Accept: 'application/json',
      },
      body: JSON.stringify(body),
   })
      .then(function (res) {
         if (!res.ok) {
            throw new Error(res.statusText || 'GWP cart update failed');
         }
         return res.json();
      })
      .then(function (cart) {
         jscGwpDispatchCartUpdate(cart);
         return cart;
      })
      .catch(function (err) {
         console.error('jscGwpCartRequest', err);
         $(document).trigger('cart.requestComplete', [typeof CartJS !== 'undefined' ? CartJS.cart : {}]);
         throw err;
      });
}

function jscGwpAddItem(cfg) {
   var base = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';
   var url = String(base).replace(/\/?$/, '') + '.js';
   return jscGwpCartRequest(url, {
      items: [
         {
            id: cfg.variantId,
            quantity: 1,
            properties: { _GWP: 'true' },
         },
      ],
   });
}

function jscGwpRemoveItem(lineKey) {
   var base = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
   var url = String(base).replace(/\/?$/, '') + '/change.js';
   return jscGwpCartRequest(url, { id: lineKey, quantity: 0 });
}

function jscGwpSetQuantity(lineKey, quantity) {
   var base = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
   var url = String(base).replace(/\/?$/, '') + '/change.js';
   return jscGwpCartRequest(url, { id: lineKey, quantity: quantity });
}

function jscSyncGwpCart(cart) {
   if (jscGwpSyncInProgress) return;
   var cfg = jscGetGwpConfig();
   if (!cfg || !cfg.enabled || !cfg.variantId) return;

   var gwpLine = jscFindGwpLineItem(cart, cfg);
   var shouldHaveGwp = cfg.customerQualified && jscCartHasQualifyingItem(cart, cfg);

   if (!shouldHaveGwp) {
      if (gwpLine) {
         jscGwpSyncInProgress = true;
         jscGwpRemoveItem(gwpLine.key)
            .catch(function () {})
            .finally(function () {
               jscGwpSyncInProgress = false;
            });
      }
      return;
   }

   if (!gwpLine) {
      jscGwpSyncInProgress = true;
      jscGwpAddItem(cfg)
         .catch(function () {})
         .finally(function () {
            jscGwpSyncInProgress = false;
         });
      return;
   }

   if (gwpLine.quantity > 1) {
      jscGwpSyncInProgress = true;
      jscGwpSetQuantity(gwpLine.key, 1)
         .catch(function () {})
         .finally(function () {
            jscGwpSyncInProgress = false;
         });
   }
}

/** IANA timezone for delivery cutoff and “tomorrow” (override before DOM ready if needed). */
var jscDeliveryCartAttrTimeZone =
   typeof window !== 'undefined' && window.JSC_DELIVERY_CART_ATTR_TIMEZONE
      ? window.JSC_DELIVERY_CART_ATTR_TIMEZONE
      : 'Asia/Singapore';

var jscStaleDeliveryCartAttrKeys = [
   'Delivery-Location-Id',
   'Delivery-Date',
   'Delivery-Time',
   'Delivery-Slot-Id',
   'Checkout-Method',
];

var jscStaleDeliveryAttrClearInFlight = false;

function jscFormatYmdInTimeZone(date, timeZone) {
   return new Intl.DateTimeFormat('en-CA', {
      timeZone: timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
   }).format(date);
}

/** Next calendar date (YYYY-MM-DD) after `fromDate` in `timeZone`. */
function jscTomorrowYmdFrom(fromDate, timeZone) {
   var base = jscFormatYmdInTimeZone(fromDate, timeZone);
   var probe = new Date(fromDate.getTime());
   for (var h = 1; h <= 48; h++) {
      probe.setTime(fromDate.getTime() + h * 3600000);
      var ymd = jscFormatYmdInTimeZone(probe, timeZone);
      if (ymd !== base) {
         return ymd;
      }
   }
   return base;
}

function jscNormalizeDeliveryYmd(raw) {
   if (!raw || typeof raw !== 'string') {
      return '';
   }
   var m = raw.trim().match(/^(\d{4})[\/\-](\d{1,2})[\/\-](\d{1,2})/);
   if (!m) {
      return '';
   }
   return m[1] + '-' + String(m[2]).padStart(2, '0') + '-' + String(m[3]).padStart(2, '0');
}

function jscCurrentHourInTimeZone(timeZone) {
   var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: timeZone,
      hour: 'numeric',
      hour12: false,
   }).formatToParts(new Date());
   for (var i = 0; i < parts.length; i++) {
      if (parts[i].type === 'hour') {
         return parseInt(parts[i].value, 10);
      }
   }
   return 0;
}

/**
 * After 4pm store time, a cart still holding “tomorrow” delivery is past same-day cutoff — clear slot attrs.
 * Does not clear same-day or later dates, or pickup carts.
 */
function jscShouldClearStaleNextDayDeliveryAttrs(attrs) {
   if (!attrs || attrs['Checkout-Method'] !== 'delivery') {
      return false;
   }
   var deliveryYmd = jscNormalizeDeliveryYmd(attrs['Delivery-Date']);
   if (!deliveryYmd) {
      return false;
   }
   var tomorrowYmd = jscTomorrowYmdFrom(new Date(), jscDeliveryCartAttrTimeZone);
   if (deliveryYmd !== tomorrowYmd) {
      return false;
   }
   return jscCurrentHourInTimeZone(jscDeliveryCartAttrTimeZone) >= 16;
}

function jscEmptyDeliverySlotCartAttributes() {
   var out = {};
   for (var i = 0; i < jscStaleDeliveryCartAttrKeys.length; i++) {
      out[jscStaleDeliveryCartAttrKeys[i]] = '';
   }
   return out;
}

/**
 * @param {object} cart — object with `attributes` from /cart.js
 * @returns {Promise}
 */
function jscClearStaleNextDayDeliveryCartAttributes(cart) {
   if (jscStaleDeliveryAttrClearInFlight) {
      return Promise.resolve();
   }
   if (!cart || !cart.attributes || !jscShouldClearStaleNextDayDeliveryAttrs(cart.attributes)) {
      return Promise.resolve();
   }
   jscStaleDeliveryAttrClearInFlight = true;
   return jscUpdateCartAttributes(jscEmptyDeliverySlotCartAttributes())
      .catch(function () {})
      .finally(function () {
         jscStaleDeliveryAttrClearInFlight = false;
      });
}

function jscFetchCartAndClearStaleDeliveryAttrs() {
   var base = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
   var url = String(base).replace(/\/?$/, '') + '.js';
   return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (res) {
         if (!res.ok) {
            throw new Error(res.statusText);
         }
         return res.json();
      })
      .then(function (cart) {
         return jscClearStaleNextDayDeliveryCartAttributes(cart);
      })
      .catch(function () {});
}

var jscStaleDeliveryDebounceTimer;
function jscScheduleStaleDeliveryClearFromCartEvent(cart) {
   clearTimeout(jscStaleDeliveryDebounceTimer);
   jscStaleDeliveryDebounceTimer = setTimeout(function () {
      jscClearStaleNextDayDeliveryCartAttributes(cart);
   }, 80);
}

/**
 * Pushes current gift message / gift card values from the cart page DOM to the cart via Ajax.
 * Called when the customer clicks Checkout (see form.cart submit handler). Gift message is not
 * saved on input/blur to avoid overlapping /cart/update.js requests.
 * Resolves immediately when those fields are not on the page.
 */
function jscSyncGiftCartAttributesFromDom() {
   var $giftMsg = $('#jsc-gift-message');
   var $giftCard = $('#jsc-gift-card');
   if (!$giftMsg.length && !$giftCard.length) {
      return Promise.resolve();
   }
   var attrs = {};
   if ($giftMsg.length) {
      attrs['_Gift Message'] = $giftMsg.val().trim();
   }
   if ($giftCard.length) {
      attrs['_Gift card'] = $giftCard.is(':checked') ? 'Yes' : 'No';
   }
   return jscUpdateCartAttributes(attrs);
}

/** Full-screen overlay while cart → checkout prep runs (gift attributes, delivery cleanup). */
function jscShowCartCheckoutPrepOverlay() {
   jscHideCartCheckoutPrepOverlay();
   var el = document.createElement('div');
   el.className = 'jsc-cart-checkout-prep-overlay';
   el.setAttribute('role', 'status');
   el.setAttribute('aria-live', 'polite');
   el.innerHTML =
      '<div class="jsc-cart-checkout-prep-spinner" aria-hidden="true"></div>' +
      '<p class="jsc-cart-checkout-prep-text">Preparing checkout…</p>';
   document.body.appendChild(el);
}

function jscHideCartCheckoutPrepOverlay() {
   document.querySelectorAll('.jsc-cart-checkout-prep-overlay').forEach(function (node) {
      if (node.parentNode) {
         node.parentNode.removeChild(node);
      }
   });
}

$(function () {
   console.log('Hello World');
   onclickfirstvariant();
   cartJSEvent();
   document.addEventListener('theme:cart:change', function (ev) {
      var c = ev.detail && ev.detail.cart;
      if (c) {
         jscScheduleStaleDeliveryClearFromCartEvent(c);
         jscSyncGwpCart(c);
      }
   });
   jscFetchCartAndClearStaleDeliveryAttrs();
   initBundleSelectSize();
   initBundleProductQuantityInput();
   initEventBundleData(true);
   initEventBundleProductQuantityInput();
   initEventFlavourFilterTabs();
   
   // Update event bundle buttons after a short delay to ensure DOM is ready
   setTimeout(function() {
      updateEventBundleAddButtons();
   }, 100);
   removeBundleProd();
   checkAnnouncmentBarSticky();
   calculatedDescHeight();
   calculatedDescHeightNormalGrid();
   syncProductGridHeights();
   syncProductGridHeights480();
   checkInput();
   changeTextWhenSwitchRadioButton();
   initCollectionHoverUnderline();
   calculateBoutiqueDescHeight();
   initAccordionHoverUnderline();
   initAccordionSmoothScroll();
   initListCollectionsGridCarousel();
   initComplementarySectionHeight();
   initBundleAddOnSectionHeight();
   initAddonToggle();
   initProductImageDrawer();
   // initReadMore();
   // adjustElementsBasedOnScreenWidth();
   // Start - Seal Subcription Fake variant
   var timer = setInterval(function() {
      if ($('.sealsubs-container').length > 0) {
         $('.jsc-product-page-loading').remove();
         clearInterval(timer);
      }
   }, 100);
   // End - Seal Subcription Fake variant

   $(window).resize(function() {
      console.log("Resize detected");
      // adjustElementsBasedOnScreenWidth();
      checkAnnouncmentBarSticky();
      calculatedDescHeight();
      calculatedDescHeightNormalGrid();
      syncProductGridHeights();
      syncProductGridHeights480();
      calculateBoutiqueDescHeight();
   });

   $('#jsc-gift-card').on('change', function() {
      jscUpdateCartAttributes({
         '_Gift card': $(this).is(':checked') ? 'Yes' : 'No',
      }).catch(function () {});
   });

   var jscAllowCartCheckoutSubmit = false;

   /**
    * Cart checkout runs from the visible `.fake-checkout-button` (avoids Zapiet / other scripts
    * racing the real submit). Prep completes, then the hidden `button[name="checkout"]` is clicked.
    */
   $(document).on('click', 'form.cart .fake-checkout-button', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var fakeBtn = this;
      if (fakeBtn.getAttribute('data-jsc-checkout-prep-in-flight') === 'true') {
         return;
      }
      fakeBtn.setAttribute('data-jsc-checkout-prep-in-flight', 'true');

      var form = fakeBtn.closest('form.cart');
      if (!form) {
         fakeBtn.removeAttribute('data-jsc-checkout-prep-in-flight');
         return;
      }

      var realBtn = form.querySelector('button[type="submit"][name="checkout"]');
      if (!realBtn) {
         fakeBtn.removeAttribute('data-jsc-checkout-prep-in-flight');
         return;
      }

      var hasGiftFields =
         document.getElementById('jsc-gift-message') || document.getElementById('jsc-gift-card');

      jscShowCartCheckoutPrepOverlay();

      var prep = Promise.resolve();
      if (hasGiftFields) {
         prep = prep.then(function () {
            return jscSyncGiftCartAttributesFromDom();
         });
      }
      prep = prep.then(function () {
         return jscFetchCartAndClearStaleDeliveryAttrs();
      });

      prep
         .then(function () {
            jscHideCartCheckoutPrepOverlay();
            jscAllowCartCheckoutSubmit = true;
            realBtn.click();
         })
         .catch(function (err) {
            jscHideCartCheckoutPrepOverlay();
            console.error('jscCartCheckoutPrep', err);
            window.alert(
               'We could not save your cart details before checkout. Please check your connection and try again.'
            );
         })
         .finally(function () {
            fakeBtn.removeAttribute('data-jsc-checkout-prep-in-flight');
         });
   });

   $(document).on('keydown', 'form.cart .fake-checkout-button', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
         e.preventDefault();
         $(this).trigger('click');
      }
   });

   $(document).on('submit', 'form.cart', function (e) {
      if (jscAllowCartCheckoutSubmit) {
         jscAllowCartCheckoutSubmit = false;
         return;
      }
      var orig = e.originalEvent;
      var sub = orig && orig.submitter;
      if (!sub || sub.getAttribute('name') !== 'checkout') {
         return;
      }
      e.preventDefault();
   });

   // Bind to all newsletter input fields
   $(document).on('keyup change', '[data-newsletter-field]', function () {
      checkInput();
   });
  
});
var overMaxBundleMsg = "You have reached your bundle limit. Kindly adjust the quantity if you wish to add more flavours.";
var inCompleteBundleMsg = "Almost there! Add more flavour to complete your bundle.";
var completeBundleMsg = "Bundle Completed!";

// Event Bundle Messages
var overMaxEventBundleMsg = "You have reached your event bundle limit. Kindly adjust the quantity if you wish to add more flavours.";
var inCompleteEventBundleMsg = "Almost there! Add more flavour to complete your event bundle.";
var completeEventBundleMsg = "Event Bundle Completed!";

cartJSEvent = () => {
   $(document).on('cart.requestStarted', function(event, cart) {
     var $html = `<div class="jsc-page-loading">
                   <div class="jsc-spinner-container">
                     <div class="jsc-spinner"></div>
                   </div>
                 </div>`;
     $('body').prepend($html);
   });

   $(document).on('cart.requestComplete', function(event, cart) {
      document.dispatchEvent(new CustomEvent('theme:cart:change', {
         detail: {
            cart: cart
         },
         bubbles: true
      }));
   if($('.cart__template').length > 0){
      removeBundleProd();
   }else{
      reloadBundleCart();
      console.log("cart", cart,  event);
   }
   
   // Update max attributes for addon quantity selectors when cart changes
   updateAddonQuantityMaxValues();
   });
 }

updateTotalQuantityBundle = () => {
   var totalQuantity = 0;
   $('.jsc-summary-flavour').each(function() {
      var quantity = parseInt($(this).find('.jsc-summary-flavour-quantity').text(), 10) || 0;
      totalQuantity += quantity;
   });

   $('.jsc-flavour-bundle-current-total').text(totalQuantity);

   $('.js-quantity-wrapper .quantity__input[data-quantity-input-bundle]').each(function() {
      $(this).attr('data-current-total-prd', totalQuantity);
   });
}

updateTotalPremiumPrice = () => {
   var totalPremiumPrice = 0;
   var totalPremiumProd = 0;
   var premiumPricing = 0;
   var flavQuantity = 0;
   var isDataOriPriceBundle = $('.jsc-bundle-data').attr('data-based-on-ori-price');
   var currentBundleTotalPrice = parseFloat($('.jsc-bundle-data').attr('data-bundle-price'));

   $('.jsc-summary-flavour').each(function() {
      if(isDataOriPriceBundle == 'true'){
         // For bundles based on original price, each flavour has its own premium price
         premiumPricing = parseFloat($(this).attr('data-price-added')) || 0;
         flavQuantity = parseInt($(this).find('.jsc-summary-flavour-quantity').attr('data-flav-quantity'), 10) || 0;
         totalPremiumProd += flavQuantity;
         // Accumulate: quantity * price per unit for this flavour
         totalPremiumPrice += flavQuantity * premiumPricing;
      }else{
         // For standard bundles, check if this is a premium product
         var isPremiumProd = $(this).attr('data-product-premium');
         if (isPremiumProd == "true") {
            flavQuantity = parseInt($(this).find('.jsc-summary-flavour-quantity').attr('data-flav-quantity'), 10) || 0;
            totalPremiumProd += flavQuantity;
         }
      }
   });

   // For standard bundles, calculate premium price after loop using the standard premium price
   if(isDataOriPriceBundle != 'true'){
      var standardPremiumPrice = parseFloat($('.jsc-bundle-data').attr('data-premium-flavour-price')) || 0;
      totalPremiumPrice = totalPremiumProd * standardPremiumPrice;
   }

   // Add premium price to bundle total only once, after the loop
   currentBundleTotalPrice = parseFloat($('.jsc-bundle-data').attr('data-bundle-price')) + totalPremiumPrice;

   $('.jsc-premium-flavour-total-price .jsc-summary-price').text('+$' + totalPremiumPrice.toFixed(2));
   $('.jsc-summary-total-price .jsc-summary-price').text('$' + currentBundleTotalPrice.toFixed(2));

   $('.jsc-bundle-data').attr('data-total-premium-flavour', totalPremiumProd);
   $('.jsc-bundle-data').attr('data-bundle-total-price', currentBundleTotalPrice.toFixed(2));
}

checkBundleStatus = () => {
   var currentTotalProduct = parseInt($('.jsc-flavour-bundle-current-total').text());
   var bundleMaxQty = parseInt($('.jsc-flavour-bundle-max').text());
   var bundleBasePrice = parseFloat($('.jsc-bundle-data').attr('data-bundle-price'));

   var completeBundleMessage = completeBundleMsg + "&nbsp;&nbsp;&nbsp;&nbsp;Flat Price: $" + bundleBasePrice;

   if(currentTotalProduct >= bundleMaxQty) {
      $('.jsc-flavour-summary-bundle-msg').html(completeBundleMessage);
      $('.jsc-atc-bundle').removeAttr('disabled');
   } else {
      $('.jsc-flavour-summary-bundle-msg').text(inCompleteBundleMsg);
      $('.jsc-atc-bundle').attr('disabled', true);
   }
}

showBundlePrompt = (message) => {
   var $modal = $(`
      <div class="prompt-bundle-overlay">
         <div class="prompt-bundle-modal">
            <div class="prompt-bundle-modal-content">${message}</div>
            <div class="dismiss-prompt">Got it!</div>
         </div>
      </div>
   `);

   $('body').append($modal);

   $modal.find('.dismiss-prompt').on('click', () => {
      // clearTimeout(autoCloseTimeout); // Cancel auto-close on user interaction
      $modal.fadeOut(300, () => $modal.remove());
   });

   // var autoCloseTimeout = setTimeout(() => {
   //    $modal.fadeOut(300, () => $modal.remove());
   // }, 5000); 
}

initBundleProductQuantityInput = () => {
   $(document).on('click', '.js-quantity-wrapper [data-decrease-quantity-bundle]', function () {
      var $wrapper = $(this).closest('.js-quantity-wrapper');
      var $outerProdGrid = $(this). closest('.product-grid-item');
      var $prodSelectedQTYElement = $outerProdGrid.find('.jsc-bundle-product-selected-qty span');
      console.log("$outerProdGrid", $outerProdGrid);
      var $input = $wrapper.find('[data-quantity-input-bundle]');
      var productID = $input.attr('data-prod-id');
      var varID = $input.attr('data-var-id');
      var currentValue = parseInt($input.val(), 10) || 0;
      var atcbutton = $wrapper.closest('.product__block__quantity').find('.jsc-atc-flavour');

      if (currentValue > 1) {
         $input.val(currentValue - 1);
         var $summaryFlavour = $(`.jsc-summary-flavour[data-product-id="${productID}"], .jsc-summary-flavour[data-var-id="${varID}"]`);
         $summaryFlavour.find('.jsc-summary-flavour-quantity').text(`${currentValue - 1}x`).attr('data-flav-quantity', currentValue - 1);
         $outerProdGrid.addClass('jsc-flavour-selected');
         $prodSelectedQTYElement.text(`${currentValue - 1}`);
      } else if (currentValue === 1) {
         $input.val(currentValue - 1);
         $(`.jsc-summary-flavour[data-product-id="${productID}"], .jsc-summary-flavour[data-var-id="${varID}"]`).remove();
         $prodSelectedQTYElement.text(`${currentValue - 1}`);
         $wrapper.hide();
         atcbutton.css('display', 'inline-block');
         $outerProdGrid.removeClass('jsc-flavour-selected');
      }

      updateTotalQuantityBundle();
      updateTotalPremiumPrice();
      checkBundleStatus();
   });

   $(document).on('click', '.js-quantity-wrapper [data-increase-quantity-bundle]', function () {
      var $wrapper = $(this).closest('.js-quantity-wrapper');
      var $outerProdGrid = $(this).closest('.product-grid-item');
      var $prodSelectedQTYElement = $outerProdGrid.find('.jsc-bundle-product-selected-qty span');
      console.log("$outerProdGrid", $outerProdGrid, $prodSelectedQTYElement);
      var $input = $wrapper.find('[data-quantity-input-bundle]');
      var productID = $input.attr('data-prod-id');
      var varID = $input.attr('data-var-id');
      var productPrice = parseInt($input.attr('data-prod-price'));
      var productTitle = $input.attr('data-prod-title');
      var currentValue = parseInt($input.val(), 10) || 0;
      var isPremiumFlavour = false;
      var bundleMaxQty = parseInt($('.jsc-bundle-data').attr('data-bundle-max'), 10);
      var totalCurrentProd = parseInt($input.attr('data-current-total-prd'), 10);
      var prodInventory =  parseInt($input.attr('data-prod-inventory'), 10);
      var premiumPrice = parseInt($input.attr('data-premium-price'), 10);
      var isBundleProductBasedOriPrice = $input.attr('data-bundle-based-on-oriprice');
      var updateTotalCurrentProd = 0;
      
      $input.val(currentValue + 1);
      updateTotalCurrentProd = totalCurrentProd + 1;
      if(isBundleProductBasedOriPrice == 'true'){
         if(premiumPrice > 0) {
            isPremiumFlavour = true;
         }
      }else{
         if(productPrice > 0) {
            isPremiumFlavour = true;
         }
      }
      if ((currentValue + 1) > prodInventory){
         $input.val(currentValue);
         showBundlePrompt(`This product has only ${prodInventory} remaining. Kindly adjust your quantity`);
      }else{
         if (updateTotalCurrentProd > bundleMaxQty) {
            $input.val(currentValue);
            showBundlePrompt(overMaxBundleMsg);
         }else{
            var $summaryFlavour = $(`.jsc-summary-flavour[data-product-id="${productID}"]`);
            if ($summaryFlavour.length > 0) {
               $summaryFlavour.find('.jsc-summary-flavour-quantity').text(`${currentValue + 1}x`).attr('data-flav-quantity', currentValue + 1);
               $prodSelectedQTYElement.text(`${currentValue + 1}`);
            } else {
               var newFlavourHTML = `
                  <div class="jsc-summary-flavour" data-product-id="${productID}" data-var-id="${varID}" data-product-premium="${isPremiumFlavour}" data-based-on-ori-price="${isBundleProductBasedOriPrice}" data-price-added="${premiumPrice}">
                     <span class="jsc-summary-flavour-quantity" data-flav-quantity="${currentValue + 1}">${currentValue + 1}x</span>
                     <span class="jsc-summary-flavour-name">${productTitle}</span>
                     <span class="jsc-summary-flavour-remove" onclick="removeFlavourBundle(this, ${productID})">x</span>
                  </div>
               `;
               $('.jsc-summary-flavour-product').append(newFlavourHTML);
               $prodSelectedQTYElement.text(`${currentValue + 1}`);
            }
      
            updateTotalQuantityBundle();
            updateTotalPremiumPrice();
            checkBundleStatus();
      
            if ($input.val() >= 1) {
               // $wrapper.addClass('jsc-flavour-selected');
               $outerProdGrid.addClass('jsc-flavour-selected');
            }
         }
      }

   });

   $(document).on('input', '.js-quantity-wrapper [data-quantity-input-bundle]', function () {
      var $wrapper = $(this).closest('.js-quantity-wrapper');
      var $outerProdGrid = $(this). closest('.product-grid-item');
      var $prodSelectedQTYElement = $outerProdGrid.find('.jsc-bundle-product-selected-qty span');
      var $input = $(this);
      var productID = $input.attr('data-prod-id');
      var varID = $input.attr('data-var-id');
      var productPrice = parseInt($input.attr('data-prod-price'));
      var currentValue = parseInt($input.val(), 10) || 0;
      var atcbutton = $wrapper.closest('.product__block__quantity').find('.jsc-atc-flavour');
      var premiumPrice = parseInt($input.attr('data-premium-price'), 10);
      var isisBundleProductBasedOriPrice = $input.attr('data-bundle-based-on-oriprice');
      var isPremiumFlavour = false;
   
      if ($input.val() === '') {
         currentValue = 0;
      } else {
         $input.val(currentValue);
      }
      if(isisBundleProductBasedOriPrice == 'true'){
         if(premiumPrice > 0) {
            isPremiumFlavour = true;
         }
      }else{
         if(productPrice > 0) {
            isPremiumFlavour = true;
         }
      }
      

      if (currentValue > 0) {
         var $summaryFlavour = $(`.jsc-summary-flavour[data-product-id="${productID}"]`);
         if ($summaryFlavour.length > 0) {
            $summaryFlavour.find('.jsc-summary-flavour-quantity').text(`${currentValue}x`).attr('data-flav-quantity', currentValue);
            $prodSelectedQTYElement.text(`${currentValue}`);
         } else {
            var productTitle = $input.attr('data-prod-title');
            var newFlavourHTML = `
               <div class="jsc-summary-flavour" data-product-id="${productID}" data-var-id="${varID}" data-product-premium="${isPremiumFlavour}" data-based-on-ori-price="${isBundleProductBasedOriPrice}" data-price-added="${premiumPrice}">
                  <span class="jsc-summary-flavour-quantity" data-flav-quantity="${currentValue}">${currentValue}x</span>
                  <span class="jsc-summary-flavour-name">${productTitle}</span>
                  <span class="jsc-summary-flavour-remove">x</span>
               </div>
            `;
            $('.jsc-summary-flavour-product').append(newFlavourHTML);
            $prodSelectedQTYElement.text(`${currentValue}`);
         }
         $outerProdGrid.addClass('jsc-flavour-selected');
      } else {
         $('.jsc-summary-flavour').each(function () {
            var $summaryFlavour = $(this);
            var summaryFlavourID = $(this).attr('data-product-id');
            if (summaryFlavourID == productID) {
               $summaryFlavour.remove();
            }
         });
         $outerProdGrid.removeClass('jsc-flavour-selected');
      }
   
      updateTotalQuantityBundle();
      updateTotalPremiumPrice();
      checkBundleStatus();
   });
   
   $(document).on('blur', '.js-quantity-wrapper [data-quantity-input-bundle]', function () {
      var $input = $(this);
      var $wrapper = $(this).closest('.js-quantity-wrapper');
      var $outerProdGrid = $(this). closest('.product-grid-item');
      var $prodSelectedQTYElement = $outerProdGrid.find('.jsc-bundle-product-selected-qty span');
      var productID = $input.attr('data-prod-id');
      var productPrice = parseInt($input.attr('data-prod-price'));
      var currentValue = parseInt($input.val(), 10) || 0;
      var atcbutton = $wrapper.closest('.product__block__quantity').find('.jsc-atc-flavour');
      var totalCurrentProd = parseInt($input.attr('data-current-total-prd'), 10);
      var bundleMaxQty = parseInt($('.jsc-bundle-data').attr('data-bundle-max'), 10);
      var prodInventory =  parseInt($input.attr('data-prod-inventory'), 10);
      var updateTotalCurrentProd = 0;

      updateTotalCurrentProd = (totalCurrentProd - currentValue) + currentValue;

      if (currentValue > prodInventory){
         $input.val(currentValue);
         showBundlePrompt(`This product has only ${prodInventory} remaining. Kindly adjust your quantity`);
      }else{
         if (updateTotalCurrentProd > bundleMaxQty) {
            $input.val(currentValue);
            showBundlePrompt(overMaxBundleMsg);
         }else{
            if (currentValue > bundleMaxQty) {
               $input.val(currentValue);
               showBundlePrompt(overMaxBundleMsg);
            }else{
               if ($input.val() === '' || currentValue == 0) {
                  $input.val(0); 
                  $wrapper.hide();
                  atcbutton.css('display', 'inline-block');
                  $('.jsc-summary-flavour').each(function () {
                     var $summaryFlavour = $(this);
                     var summaryFlavourID = $(this).attr('data-product-id');
                     if (summaryFlavourID == productID) {
                        $summaryFlavour.remove();
                     }
                  });
               }
         
               if (currentValue >= 1) {
                  $outerProdGrid.addClass('jsc-flavour-selected');
               } else {
                  $outerProdGrid.removeClass('jsc-flavour-selected');
               }
            }

         }
      }

   });
}

initBundleSelectSize = () => {
   var checkedRadio = $('.jsc-bundle-product-section .product__block__variants').find('input[type="radio"]:checked');
   if (checkedRadio.length) {
      var radioValue = checkedRadio.val();
      var radioID = checkedRadio.attr('id');
      var mainBundleProductPrice = checkedRadio.attr('data-var-price');

      var match = radioValue.match(/\d+/);
      var number = match ? parseInt(match[0], 10) : null;

      if (number !== null) {
         $('.jsc-flavour-summary-bundle-type .jsc-flavour-bundle-max').text(number);
      }
      if (radioID != '') {
         $('.jsc-bundle-data').attr('data-variant-id', radioID);
         $('.jsc-bundle-data').attr('data-bundle-max', number);
      }

      if (mainBundleProductPrice) {
         var price = parseFloat(mainBundleProductPrice);
         $('.jsc-bundle-data').attr('data-bundle-price', price.toFixed(2));
         $('.jsc-summary-total-price .jsc-summary-price').text('$'+price.toFixed(2));
      }
   }

   $('.jsc-bundle-product-section .product__block__variants').on('change', 'input[type="radio"]', function() {
      var checkedRadio = $(this);
      var radioValue = checkedRadio.val();
      var radioID = checkedRadio.attr('id');
      var mainBundleProductPrice = checkedRadio.attr('data-var-price');
      var bindID = radioID + '-' + Date.now();

      var match = radioValue.match(/\d+/);
      var number = match ? parseInt(match[0], 10) : null;

      console.log("checkedRadio", checkedRadio);

      if (number !== null) {
         $('.jsc-flavour-summary-bundle-type .jsc-flavour-bundle-max').text(number);
      }
      
      if (radioID != '') { 
         $('.jsc-bundle-data').attr('data-variant-id', radioID);
         $('.jsc-bundle-data').attr('data-bundle-max', number);
      }

      if (mainBundleProductPrice) {
         var price = parseFloat(mainBundleProductPrice);
         $('.jsc-bundle-data').attr('data-bundle-price', price.toFixed(2));
         $('.jsc-summary-total-price .jsc-summary-price').text('$'+ price.toFixed(2));
      }
      updateTotalQuantityBundle();
      updateTotalPremiumPrice();
      checkBundleStatus();

      $('.radio__button').each(function() {
         var radio = $(this).find('input[type="radio"]');
         var dot = $(this).find('.jsc-dot');
         dot.removeClass('jsc-white'); 
         if (radio.is(':checked')) {
            dot.addClass('jsc-white');
         } else {
            dot.removeClass('jsc-white');
         }
      });
 
   });
}

addFlavourBundle = (button) => {
   var $button = $(button);
   var flavourQtyWrapper = $button.closest('.product__block__quantity').find('.js-quantity-wrapper');
   var flavourQtySelectorInput = $button.closest('.product__block__quantity').find('.js-quantity-wrapper input[data-quantity-input-bundle]');
   var flavourQtyPlusButton = $button.closest('.product__block__quantity').find('.js-quantity-wrapper .quantity__button[data-increase-quantity-bundle]');
   var totalCurrentProd = parseInt(flavourQtySelectorInput.attr('data-current-total-prd'),10) || 0;
   var bundleMaxQty = parseInt($('.jsc-bundle-data').attr('data-bundle-max'),10);
   var updateTotalCurrentProd = 0;
   updateTotalCurrentProd = totalCurrentProd + 1;
   console.log("totalCurrentProd", totalCurrentProd);
   if(updateTotalCurrentProd <= bundleMaxQty){
      $(flavourQtyWrapper).css('display', 'flex');
      $button.hide();
      flavourQtyPlusButton.click();
   }else{
      showBundlePrompt(overMaxBundleMsg);
   }

}

removeFlavourBundle = (button, product_id) => {
   var $button = $(button);
   $('.js-quantity-wrapper.jsc-flavour-selected input').each(function () {
      var $input = $(this);
      var prodId = parseInt($input.attr('data-prod-id'));
      
      if (prodId == product_id) {
         console.log(`Match found for product_id: ${product_id}`);
         $input.val(0);
         var thisBlock = $input.closest('.product__block__quantity');
         var $wrapper = $input.closest('.js-quantity-wrapper');
         $wrapper.hide();
         $wrapper.removeClass('jsc-flavour-selected');
         thisBlock.find('.jsc-atc-flavour').css('display', 'inline-block');
         $('.jsc-summary-flavour').each(function () {
            var $summaryFlavour = $(this);
            var summaryFlavourID = $(this).attr('data-product-id');
            if (summaryFlavourID == product_id) {
               $summaryFlavour.remove();
            }
         });
         updateTotalQuantityBundle();
         updateTotalPremiumPrice();
         checkBundleStatus();
         // console.trace();
      }
  });
}

addBundleToCart = (button) => {
   var $button = $(button);
   var mainProdVarID = $('.jsc-bundle-data').attr('data-variant-id');
   var bindID = mainProdVarID + '-' + Date.now();
   var bundleMaxQty = parseInt($('.jsc-bundle-data').attr('data-bundle-max'), 10);
   var bundleTotalPrice = parseInt($('.jsc-bundle-data').attr('data-bundle-total-price'));
   var bundleCurrentQty = parseInt($('.jsc-flavour-bundle-current-total:first').text(), 10);

   if(bundleCurrentQty == 0 ){
      showBundlePrompt(`Please select ${bundleMaxQty} flavour`);
   }
   else if(bundleCurrentQty == bundleMaxQty){
      // $('.jsc-atc-bundle').attr('disabled', true);
      $button.attr('disabled', true);
      $button.addClass('loading');
      var atcButtonText = $button.find('.jsc-bundle-atc-text');
      var loaderButton =  $button.find('.btn-state-loading');
      atcButtonText.hide();
      console.log("atcButtonText, loaderButton", atcButtonText, loaderButton);
      var jsonObjMain = [];
      var itemMain = {};
      var $objMain = {};
      var variantIDs = [];
      var variantQuantities = [];
      var variantTitle = [];
      // Add bundle main product
      var mainProdID = parseInt($('.jsc-bundle-data').attr('data-variant-id'), 10);
      $('.jsc-summary-flavour').each(function() {
         var $flavour = $(this);
         var flavourID = parseInt($flavour.attr('data-var-id'), 10);
         var flavName = $flavour.find('.jsc-summary-flavour-name').text();
         var flavQuantityText = $flavour.find('.jsc-summary-flavour-quantity').text();
         var flavQuantity = parseInt($flavour.find('.jsc-summary-flavour-quantity').text().replace('x', '').trim(), 10);
         $objMain[flavName] = flavQuantityText;

         variantIDs.push(flavourID);
         variantQuantities.push(flavQuantity);
         variantTitle.push(flavName);
      });

      // Assign collected data as comma-separated strings
      $objMain['_variant_ids'] = variantIDs.join(',');
      $objMain['_variant_qty'] = variantQuantities.join(',');
      $objMain['_variant_title'] = variantTitle.join(',');
      console.log("objMain", $objMain);
      $objMain['_BindID'] = bindID;
      $objMain['_Bundle Product'] = 'main';
      itemMain["id"] = mainProdID;
      itemMain["quantity"] = 1;
      itemMain["properties"] = $objMain;
      jsonObjMain.push(itemMain);
      console.log("jsonObjMain", jsonObjMain);
      CartJS.addItems(jsonObjMain, {
         "success": function(data, textStatus, jqXHR) {
            console.log('Success in adding main items', jqXHR);
         },
         "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error occurred while adding items:", errorThrown, jqXHR);

         }
      });

      // Add bundle child product
      var jsonObjChild = [];
      $('.jsc-summary-flavour').each(function() {
         var $flavour = $(this);
         var flavourID = parseInt($flavour.attr('data-var-id'), 10);
         var flavQuantity = parseInt($flavour.find('.jsc-summary-flavour-quantity').attr('data-flav-quantity'), 10);
         var itemChild = {};
         var $objChild = {};

         $objChild['_BindID'] = bindID;
         $objChild['_Bundle Product'] = 'child';
         itemChild["id"] = flavourID;
         itemChild["quantity"] = flavQuantity;
         itemChild["properties"] = $objChild;
         jsonObjChild.push(itemChild);
         console.log("jsonObjChild", jsonObjChild);
      });
      CartJS.addItems(jsonObjChild, {
         "success": function(data, textStatus, jqXHR) {
            console.log('Success in adding child items');
         },
         "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error occurred while adding items:", errorThrown, jqXHR);
         }
      });
      

   }else if(bundleCurrentQty > bundleMaxQty){
      showBundlePrompt(`Please adjust your quantity to select ${bundleMaxQty} party cups.`);
   }else if(bundleCurrentQty < bundleMaxQty){
      showBundlePrompt(`Please select ${bundleMaxQty} flavour`);
   }
}

reloadBundleCart  = () => {
   var cartDrawer = $('.drawer.cart__drawer[data-drawer="drawer-cart"]');
   var jscAtcBundleButton = $('.jsc-atc-bundle');
   console.log('cartDrawer', cartDrawer, jscAtcBundleButton);
   if (cartDrawer.length > 0) {
      document.dispatchEvent(new CustomEvent('theme:cart:reload', {
         bubbles: true
      }));
      cartDrawer[0].dispatchEvent(new CustomEvent('theme:drawer:open', {
         bubbles: false
      }));

      if(jscAtcBundleButton.length > 0){
         jscAtcBundleButton.attr('disabled', false);
         jscAtcBundleButton.removeClass('loading');
         var atcButtonText = jscAtcBundleButton.find('.jsc-bundle-atc-text');
         atcButtonText.css('display', 'inline-block');
      }
   }

}

removeBundleProd = () => {
   if ($('.jsc-remove-bundle-prod').length > 0) {
      console.log("run remove bundle", $('.jsc-remove-bundle-prod').length, $('.jsc-remove-bundle-prod').val());
      var jsonObj = {};
      $('.checkout-button').attr('disabled', true);
      $('.jsc-remove-bundle-prod').each(function () {
         var values = $(this).val();
         var ids = values.split(',');
         
         ids.forEach(varID => {
            jsonObj[varID] = 0;
         });
      });
      CartJS.updateItemQuantitiesById(jsonObj);
      if($('.cart__template').length > 0){
         document.dispatchEvent(new CustomEvent('theme:cart:reload', {
            bubbles: true
         }));
      }
   }
}

// Event Bundle Functions
updateTotalQuantityEventBundle = () => {
   // Count the number of different flavors selected by checking input values
   var selectedFlavorsCount = 0;
   var totalQuantity = 0;
   
   $('.js-quantity-wrapper-event input[data-quantity-input-event-bundle]').each(function() {
      var currentValue = parseInt($(this).val(), 10) || 0;
      if (currentValue > 0) {
         selectedFlavorsCount++;
         totalQuantity += currentValue;
      }
   });

   // Get settings
   var showMaxFlavorCount = $('.jsc-event-bundle-data').attr('data-show-max-flavor-count') === 'true';
   var showTotalQuantity = $('.jsc-event-bundle-data').attr('data-show-total-quantity') === 'true';
   var eventBundleMaxQty = parseInt($('.jsc-event-bundle-data').attr('data-max-flavors'), 10);
   var eventBundleMaxTotalQty = parseInt($('.jsc-event-bundle-data').attr('data-max-total-quantity'), 10);
   
   // Determine what to display in current/max format
   var currentValue = '';
   var maxValue = '';
   
   if (showTotalQuantity) {
      // Show total quantity with max total quantity (e.g., "20/20")
      currentValue = totalQuantity.toString();
      maxValue = eventBundleMaxTotalQty.toString();
   } else if (showMaxFlavorCount) {
      // Show flavor count with max flavors (e.g., "2/4")
      currentValue = selectedFlavorsCount.toString();
      maxValue = eventBundleMaxQty.toString();
   } else {
      // Show only flavor count (e.g., "2")
      currentValue = selectedFlavorsCount.toString();
      maxValue = '';
   }
   
   // Update the display
   $('.jsc-flavour-bundle-current-total').text(currentValue);
   if (maxValue) {
      $('.jsc-flavour-bundle-max').text(maxValue);
   }

   $('.js-quantity-wrapper-event .quantity__input[data-quantity-input-event-bundle]').each(function() {
      $(this).attr('data-current-total-prd', selectedFlavorsCount);
   });
   
   // Update the selected tier variant based on total quantity
   updateSelectedTierVariant(totalQuantity);

   updateEventBundleOverlayFooter();
}

// Function to get tier variant price based on total quantity
getTierVariantPrice = (totalQuantity) => {
   var eventBundleData = $('.jsc-event-bundle-data');
   var enableTierSelection = eventBundleData.attr('data-enable-tier-selection') === 'true';
   
   // If tier selection is disabled, use the default price
   if (!enableTierSelection) {
      return parseFloat(eventBundleData.attr('data-event-bundle-price'));
   }
   
   // Get tier data
   var tier1Min = parseInt(eventBundleData.attr('data-tier-1-min'), 10) || 0;
   var tier1Max = parseInt(eventBundleData.attr('data-tier-1-max'), 10) || 0;
   var tier1Price = parseFloat(eventBundleData.attr('data-tier-1-price').replace('$', '')) || 0;
   
   var tier2Min = parseInt(eventBundleData.attr('data-tier-2-min'), 10) || 0;
   var tier2Max = parseInt(eventBundleData.attr('data-tier-2-max'), 10) || 0;
   var tier2Price = parseFloat(eventBundleData.attr('data-tier-2-price').replace('$', '')) || 0;
   
   var tier3Min = parseInt(eventBundleData.attr('data-tier-3-min'), 10) || 0;
   var tier3Max = parseInt(eventBundleData.attr('data-tier-3-max'), 10) || 0;
   var tier3Price = parseFloat(eventBundleData.attr('data-tier-3-price').replace('$', '')) || 0;
   
   // Debug tier selection
   console.log('=== TIER SELECTION DEBUG ===');
   console.log('Total Quantity:', totalQuantity);
   console.log('Tier 1:', { min: tier1Min, max: tier1Max, price: tier1Price });
   console.log('Tier 2:', { min: tier2Min, max: tier2Max, price: tier2Price });
   console.log('Tier 3:', { min: tier3Min, max: tier3Max, price: tier3Price });
   
   // Determine which tier the total quantity falls into
   if (totalQuantity >= tier1Min && totalQuantity <= tier1Max && tier1Price > 0) {
      console.log('Selected Tier 1, Price:', tier1Price);
      return tier1Price;
   } else if (totalQuantity >= tier2Min && totalQuantity <= tier2Max && tier2Price > 0) {
      console.log('Selected Tier 2, Price:', tier2Price);
      return tier2Price;
   } else if (totalQuantity >= tier3Min && totalQuantity <= tier3Max && tier3Price > 0) {
      console.log('Selected Tier 3, Price:', tier3Price);
      return tier3Price;
   }
   
   // Fallback to default price if no tier matches
   var defaultPrice = parseFloat(eventBundleData.attr('data-event-bundle-price'));
   console.log('No tier matched, using default price:', defaultPrice);
   return defaultPrice;
}

updateTotalEventBundlePrice = () => {
   var totalFlavorPrice = 0;
   var totalQuantity = 0;
   
   // Calculate total flavor price and quantity
   $('.jsc-summary-flavour').each(function() {
      var flavQuantity = parseInt($(this).find('.jsc-summary-flavour-quantity').attr('data-flav-quantity'), 10);
      var flavPrice = parseFloat($(this).attr('data-flav-price'));
      totalFlavorPrice += (flavQuantity * flavPrice);
      totalQuantity += flavQuantity;
      console.log("flavQuantity * flavPrice", flavQuantity, flavPrice);
   });

   var eventBundleData = $('.jsc-event-bundle-data');

   if (totalQuantity === 0) {
      eventBundleData.attr('data-event-bundle-total-price', '0.00');
      $('.jsc-bundle-isEventBundlePrd .jsc-summary-total-price .jsc-summary-price').text('$0');
      $('.jsc-bundle-isEventBundlePrd .jsc-summary-price-details .jsc-summary-price').text('$0');
      updateSelectedTierVariant(totalQuantity);
      updateEventBundleOverlayFooter();
      return;
   }

   // Get the appropriate tier variant price based on total quantity
   var tierVariantPrice = getTierVariantPrice(totalQuantity);
   
   // Ensure we always have a main product price (fallback to default if tier price is 0)
   var defaultMainPrice = parseFloat(eventBundleData.attr('data-event-bundle-price')) || 0;
   var mainProductPrice = tierVariantPrice > 0 ? tierVariantPrice : defaultMainPrice;
   
   // Calculate total price: main product price + flavor prices
   var totalEventBundlePrice = mainProductPrice + totalFlavorPrice;

   // Update display - update all price display elements
   $('.jsc-bundle-isEventBundlePrd .jsc-summary-total-price .jsc-summary-price').text('$' + totalEventBundlePrice.toFixed(2));
   $('.jsc-bundle-isEventBundlePrd .jsc-summary-price-details .jsc-summary-price').text('$' + totalEventBundlePrice.toFixed(2));
   eventBundleData.attr('data-event-bundle-total-price', totalEventBundlePrice.toFixed(2));
   
   // Update tier variant selection
   updateSelectedTierVariant(totalQuantity);
   updateEventBundleOverlayFooter();

   $('.jsc-summary-flavour').each(function(index) {
      var $flavor = $(this);
      var flavQuantity = parseInt($flavor.find('.jsc-summary-flavour-quantity').attr('data-flav-quantity'), 10);
      var flavPrice = parseFloat($flavor.attr('data-flav-price'));
      var flavName = $flavor.find('.jsc-summary-flavour-name').text();
      var subtotal = flavQuantity * flavPrice;
      
      console.log(`Flavor ${index + 1}:`, {
         name: flavName,
         quantity: flavQuantity,
         price: flavPrice,
         subtotal: subtotal
      });
   });
   
   // Debug tier data
   // console.log('--- Tier Data ---');
   // console.log('Tier 1:', {
   //    min: eventBundleData.attr('data-tier-1-min'),
   //    max: eventBundleData.attr('data-tier-1-max'),
   //    price: eventBundleData.attr('data-tier-1-price')
   // });
   // console.log('Tier 2:', {
   //    min: eventBundleData.attr('data-tier-2-min'),
   //    max: eventBundleData.attr('data-tier-2-max'),
   //    price: eventBundleData.attr('data-tier-2-price')
   // });
   // console.log('Tier 3:', {
   //    min: eventBundleData.attr('data-tier-3-min'),
   //    max: eventBundleData.attr('data-tier-3-max'),
   //    price: eventBundleData.attr('data-tier-3-price')
   // });
   // console.log('=== END DEBUG ===');
}

showEventBundleMinReachedPopup = () => {
   var $popup = $('.jsc-bundle-isEventBundlePrd .jsc-event-bundle-min-popup');
   if (!$popup.length) return;

   clearTimeout($popup.data('hideTimeout'));
   $popup.addClass('is-visible').attr('aria-hidden', 'false');

   $popup.data('hideTimeout', setTimeout(function () {
      $popup.removeClass('is-visible').attr('aria-hidden', 'true');
   }, 4000));
}

checkEventBundleStatus = () => {
   // Count the number of different flavors and total quantity selected
   var currentSelectedFlavors = 0;
   var currentTotalQuantity = 0;
   $('.js-quantity-wrapper-event input[data-quantity-input-event-bundle]').each(function() {
      var currentValue = parseInt($(this).val(), 10) || 0;
      if (currentValue > 0) {
         currentSelectedFlavors++;
         currentTotalQuantity += currentValue;
      }
   });
   
   var $eventBundleData = $('.jsc-event-bundle-data');
   var eventBundleMaxQty = parseInt($eventBundleData.attr('data-max-flavors'));
   var eventBundleMinTotalQty = parseInt($eventBundleData.attr('data-min-total-quantity'));
   var eventBundleMaxTotalQty = parseInt($eventBundleData.attr('data-max-total-quantity'));
   var wasBelowMin = $eventBundleData.attr('data-below-min') !== 'false';
   var $remaining_cups = eventBundleMinTotalQty - currentTotalQuantity;
   
   // Get the current total price (which includes tier variant price + flavor prices)
   var currentTotalPrice = parseFloat($eventBundleData.attr('data-event-bundle-total-price')) || 0;

   //var completeEventBundleMessage = completeEventBundleMsg + "&nbsp;&nbsp;&nbsp;&nbsp;Total Price: $" + currentTotalPrice.toFixed(2);
   var completeEventBundleMessage = completeEventBundleMsg;
   //var minQuantityMessage = `Please select a minimum of ${eventBundleMinTotalQty} cups`;
   var minQuantityMessage = `Add ${$remaining_cups} more cups to continue — min. ${eventBundleMinTotalQty}`;

   // Check if minimum total quantity is met
   if(currentTotalQuantity < eventBundleMinTotalQty) {
      $eventBundleData.attr('data-below-min', 'true');
      $('.jsc-flavour-summary-bundle-msg').text(minQuantityMessage);
      $('.jsc-atc-event-bundle').attr('disabled', true);
   } else {
      if (wasBelowMin) {
         showEventBundleMinReachedPopup();
      }
      $eventBundleData.attr('data-below-min', 'false');

      if (currentTotalQuantity >= eventBundleMaxTotalQty || currentSelectedFlavors >= eventBundleMaxQty) {
         // If maximum limits are reached, show complete message
         $('.jsc-flavour-summary-bundle-msg').html(completeEventBundleMessage);
         $('.jsc-atc-event-bundle').removeAttr('disabled');
      } else {
         // If minimum is met but not at maximum, show incomplete message but allow add to cart
         $('.jsc-flavour-summary-bundle-msg').text(inCompleteEventBundleMsg);
         $('.jsc-atc-event-bundle').removeAttr('disabled');
      }
   }
}

initEventBundleData = (firstload) => {
   // Initialize event bundle data from the hidden input
   var eventBundleData = $('.jsc-event-bundle-data');
   if (eventBundleData.length > 0) {
      var maxFlavors = parseInt(eventBundleData.attr('data-max-flavors'), 10);
      var maxTotalQuantity = parseInt(eventBundleData.attr('data-max-total-quantity'), 10);
      var showMaxFlavorCount = eventBundleData.attr('data-show-max-flavor-count') === 'true';
      var showTotalQuantity = eventBundleData.attr('data-show-total-quantity') === 'true';
      
      // Initialize the display based on settings
      var currentValue = '0';
      var maxValue = '';
      
      if (showTotalQuantity) {
         // Show total quantity with max total quantity (e.g., "0/20")
         currentValue = '0';
         maxValue = maxTotalQuantity.toString();
      } else if (showMaxFlavorCount) {
         // Show flavor count with max flavors (e.g., "0/4")
         currentValue = '0';
         maxValue = maxFlavors.toString();
      } else {
         // Show only flavor count (e.g., "0")
         currentValue = '0';
         maxValue = '';
      }
      
      // Update the display
      $('.jsc-flavour-bundle-current-total').text(currentValue);
      if (maxValue) {
         $('.jsc-flavour-bundle-max').text(maxValue);
      }
      
      // Set the base price
      //eventBundleData.attr('data-event-bundle-total-price', basePrice.toFixed(2));
      
      // Update the total price display
      // $('.jsc-summary-total-price .jsc-summary-price').text('$' + basePrice.toFixed(2));
      // if (firstload && window.innerWidth > 767) {
      //    $('.jsc-summary-total-price .jsc-summary-price').text('From $' + basePrice.toFixed(2));
      // }

      // Start at $0 until flavours are selected
      eventBundleData.attr('data-event-bundle-total-price', '0.00');
      $('.jsc-bundle-isEventBundlePrd .jsc-summary-total-price .jsc-summary-price').text('$0');
      updateEventBundleOverlayFooter();
      // Set initial message - show minimum quantity message since no items are selected
      var eventBundleMinTotalQty = parseInt(eventBundleData.attr('data-min-total-quantity'), 10);
      var minQuantityMessage = `Please select a minimum of ${eventBundleMinTotalQty} cups`;
      $('.jsc-flavour-summary-bundle-msg').text(minQuantityMessage);
      
      // Disable the add to cart button initially
      $('.jsc-atc-event-bundle').attr('disabled', true);
      eventBundleData.attr('data-below-min', 'true');
      
      // Pre-select flavors if preselected quantities are set
      var preselectedQuantities = eventBundleData.attr('data-preselected-quantities');
      if (preselectedQuantities && preselectedQuantities.trim() !== '') {
         // Wait a bit for DOM to be fully ready
         setTimeout(function() {
            preselectEventBundleFlavors(preselectedQuantities);
         }, 200);
      }
   }
}

// Pre-select the first 4 flavors with specified quantities on page load
preselectEventBundleFlavors = (quantitiesString) => {
   // Early return if input is empty, null, undefined, or just whitespace
   if (!quantitiesString || quantitiesString.trim() === '') {
      return; // No quantities provided, skip pre-selection
   }
   
   // Parse the comma-separated quantities
   var quantities = quantitiesString.split(',').map(function(qty) {
      return parseInt(qty.trim(), 10) || 0;
   }).filter(function(qty) {
      return qty > 0; // Only include positive quantities
   });
   
   // Early return if no valid quantities after parsing
   if (quantities.length === 0) {
      return; // No valid quantities to pre-select
   }
   
   // Get all available flavor inputs (only available ones, not sold out)
   var $availableInputs = $('.js-quantity-wrapper-event input[data-quantity-input-event-bundle]').filter(function() {
      var $wrapper = $(this).closest('.js-quantity-wrapper-event');
      var $quantityBlock = $wrapper.closest('.product__block__quantity');
      return !$quantityBlock.hasClass('jsc-out-of-stock');
   });
   
   // Pre-select up to 4 flavors (or the number of quantities provided)
   var maxFlavorsToSelect = Math.min(quantities.length, 4, $availableInputs.length);
   
   for (var i = 0; i < maxFlavorsToSelect; i++) {
      var $input = $availableInputs.eq(i);
      var quantity = quantities[i];
      
      if (quantity > 0 && $input.length > 0) {
         var $wrapper = $input.closest('.js-quantity-wrapper-event');
         var $outerProdGrid = $input.closest('.product-grid-item');
         var $prodSelectedQTYElement = $outerProdGrid.find('.jsc-bundle-product-selected-qty span');
         var productID = $input.attr('data-prod-id');
         var varID = $input.attr('data-var-id');
         var productTitle = $input.attr('data-prod-title');
         var productPrice = parseFloat($input.attr('data-prod-price'));
         var prodInventory = parseInt($input.attr('data-prod-inventory'), 10);
         var ignoreInventoryCap = $input.attr('data-ignore-inventory-cap') === 'true';
         var atcbutton = $wrapper.closest('.product__block__quantity').find('.jsc-atc-event-flavour');
         
         // Ensure quantity doesn't exceed inventory (unless Continue selling / untracked)
         var finalQuantity = ignoreInventoryCap ? quantity : Math.min(quantity, prodInventory);
         
         if (finalQuantity > 0) {
            // Set the input value
            $input.val(finalQuantity);
            
            // Show the quantity wrapper and hide the add button
            $wrapper.css('display', 'flex');
            atcbutton.hide();
            $outerProdGrid.addClass('jsc-event-flavour-selected');
            
            // Update the selected quantity display
            $prodSelectedQTYElement.text(finalQuantity);
            
            // Add or update the summary flavor
            var $summaryFlavour = $(`.jsc-summary-flavour[data-product-id="${productID}"]`);
            if ($summaryFlavour.length > 0) {
               $summaryFlavour.find('.jsc-summary-flavour-quantity').text(`${finalQuantity}x`).attr('data-flav-quantity', finalQuantity);
            } else {
               var newFlavourHTML = `
                  <div class="jsc-summary-flavour" data-product-id="${productID}" data-var-id="${varID}" data-flav-price="${productPrice}">
                     <span class="jsc-summary-flavour-quantity" data-flav-quantity="${finalQuantity}">${finalQuantity}x</span>
                     <span class="jsc-summary-flavour-name">${productTitle}</span>
                     <span class="jsc-summary-flavour-remove" onclick="removeEventFlavourBundle(this, ${productID})">x</span>
                  </div>
               `;
               $('.jsc-summary-flavour-product').append(newFlavourHTML);
            }
         }
      }
   }
   
   // Update all totals and status after pre-selecting
   updateTotalQuantityEventBundle();
   updateTotalEventBundlePrice();
   checkEventBundleStatus();
   updateEventBundleAddButtons();
   updateMainButtonText();
}

// Function to determine which tier variant should be used based on total quantity
getTierVariantId = (totalQuantity) => {
   var eventBundleData = $('.jsc-event-bundle-data');
   var enableTierSelection = eventBundleData.attr('data-enable-tier-selection') === 'true';
   
   // If tier selection is disabled, use the default variant
   if (!enableTierSelection) {
      return eventBundleData.attr('data-variant-id');
   }
   
   // Get tier data
   var tier1Min = parseInt(eventBundleData.attr('data-tier-1-min'), 10) || 0;
   var tier1Max = parseInt(eventBundleData.attr('data-tier-1-max'), 10) || 0;
   var tier1VariantId = eventBundleData.attr('data-tier-1-variant-id');
   
   var tier2Min = parseInt(eventBundleData.attr('data-tier-2-min'), 10) || 0;
   var tier2Max = parseInt(eventBundleData.attr('data-tier-2-max'), 10) || 0;
   var tier2VariantId = eventBundleData.attr('data-tier-2-variant-id');
   
   var tier3Min = parseInt(eventBundleData.attr('data-tier-3-min'), 10) || 0;
   var tier3Max = parseInt(eventBundleData.attr('data-tier-3-max'), 10) || 0;
   var tier3VariantId = eventBundleData.attr('data-tier-3-variant-id');
   
   // Determine which tier the total quantity falls into
   if (totalQuantity >= tier1Min && totalQuantity <= tier1Max && tier1VariantId && tier1VariantId.trim() !== '') {
      return tier1VariantId;
   } else if (totalQuantity >= tier2Min && totalQuantity <= tier2Max && tier2VariantId && tier2VariantId.trim() !== '') {
      return tier2VariantId;
   } else if (totalQuantity >= tier3Min && totalQuantity <= tier3Max && tier3VariantId && tier3VariantId.trim() !== '') {
      return tier3VariantId;
   }
   
   // Fallback to default variant if no tier matches
   return eventBundleData.attr('data-variant-id');
}

// Function to update the selected tier variant in the data attributes
updateSelectedTierVariant = (totalQuantity) => {
   var eventBundleData = $('.jsc-event-bundle-data');
   var selectedVariantId = getTierVariantId(totalQuantity);
   
   // Update the data-variant-id attribute
   eventBundleData.attr('data-variant-id', selectedVariantId);
   
   // Determine which tier is selected for visual feedback
   var enableTierSelection = eventBundleData.attr('data-enable-tier-selection') === 'true';
   if (enableTierSelection) {
      var tier1Min = parseInt(eventBundleData.attr('data-tier-1-min'), 10) || 0;
      var tier1Max = parseInt(eventBundleData.attr('data-tier-1-max'), 10) || 0;
      var tier2Min = parseInt(eventBundleData.attr('data-tier-2-min'), 10) || 0;
      var tier2Max = parseInt(eventBundleData.attr('data-tier-2-max'), 10) || 0;
      var tier3Min = parseInt(eventBundleData.attr('data-tier-3-min'), 10) || 0;
      var tier3Max = parseInt(eventBundleData.attr('data-tier-3-max'), 10) || 0;
      
      var selectedTier = '';
      if (totalQuantity >= tier1Min && totalQuantity <= tier1Max) {
         selectedTier = 'Tier 1 (Medium)';
      } else if (totalQuantity >= tier2Min && totalQuantity <= tier2Max) {
         selectedTier = 'Tier 2 (Large)';
      } else if (totalQuantity >= tier3Min && totalQuantity <= tier3Max) {
         selectedTier = 'Tier 3 (Extra Large)';
      } else {
         selectedTier = 'Default';
      }
      
      // Update tier display if element exists
      // var $tierDisplay = $('.jsc-selected-tier-display');
      // if ($tierDisplay.length > 0) {
      //    $tierDisplay.text(selectedTier);
      // }
      
      console.log('Selected tier:', selectedTier, 'Variant ID:', selectedVariantId, 'for total quantity:', totalQuantity);
   }
}

initEventFlavourFilterTabs = () => {
   $(document).on('click', '.prod-bundle-event .jsc-select-flavour-filter-tab', function() {
      var $tab = $(this);
      var filter = $tab.data('filter');
      var $section = $tab.closest('.prod-bundle-event');
      var $tabs = $tab.closest('.jsc-select-flavour-filter-tabs');

      $tabs.find('.jsc-select-flavour-filter-tab').removeClass('is-active').attr('aria-selected', 'false');
      $tab.addClass('is-active').attr('aria-selected', 'true');

      if (filter === 'premium') {
         $section.addClass('is-filter-premium-flavours');
      } else {
         $section.removeClass('is-filter-premium-flavours');
      }
   });
};

initEventBundleProductQuantityInput = () => {
   $(document).on('click', '.js-quantity-wrapper-event [data-decrease-quantity-event-bundle]', function () {
      var $wrapper = $(this).closest('.js-quantity-wrapper-event');
      var $outerProdGrid = $(this).closest('.product-grid-item');
      var $prodSelectedQTYElement = $outerProdGrid.find('.jsc-bundle-product-selected-qty span');
      var $input = $wrapper.find('[data-quantity-input-event-bundle]');
      var productID = $input.attr('data-prod-id');
      var varID = $input.attr('data-var-id');
      var currentValue = parseInt($input.val(), 10) || 0;
      var atcbutton = $wrapper.closest('.product__block__quantity').find('.jsc-atc-event-flavour');
      var quantityIncrement = parseInt($('.jsc-event-bundle-data').attr('data-quantity-increment'), 10) || 5;

      if (currentValue > quantityIncrement) {
         $input.val(currentValue - quantityIncrement);
         var $summaryFlavour = $(`.jsc-summary-flavour[data-product-id="${productID}"], .jsc-summary-flavour[data-var-id="${varID}"]`);
         $summaryFlavour.find('.jsc-summary-flavour-quantity').text(`${currentValue - quantityIncrement}x`).attr('data-flav-quantity', currentValue - quantityIncrement);
         if ($input.val() >= quantityIncrement) {
            $outerProdGrid.addClass('jsc-event-flavour-selected');
         }
         $prodSelectedQTYElement.text(`${currentValue - quantityIncrement}`);
      } else if (currentValue <= quantityIncrement) {
         $input.val(0);
         $(`.jsc-summary-flavour[data-product-id="${productID}"], .jsc-summary-flavour[data-var-id="${varID}"]`).remove();
         $prodSelectedQTYElement.text('0');
         $wrapper.hide();
         atcbutton.css('display', 'inline-block');
         $outerProdGrid.removeClass('jsc-event-flavour-selected');
      }

      updateTotalQuantityEventBundle();
      updateTotalEventBundlePrice();
      checkEventBundleStatus();
      updateEventBundleAddButtons();
      updateMainButtonText();
   });

   $(document).on('click', '.js-quantity-wrapper-event [data-increase-quantity-event-bundle]', function () {
      var $wrapper = $(this).closest('.js-quantity-wrapper-event');
      var $outerProdGrid = $(this).closest('.product-grid-item');
      var $prodSelectedQTYElement = $outerProdGrid.find('.jsc-bundle-product-selected-qty span');
      var $input = $wrapper.find('[data-quantity-input-event-bundle]');
      var productID = $input.attr('data-prod-id');
      var varID = $input.attr('data-var-id');
      var productPrice = parseFloat($input.attr('data-prod-price'));
      var productTitle = $input.attr('data-prod-title');
      var currentValue = parseInt($input.val(), 10) || 0;
      var eventBundleMaxQty = parseInt($('.jsc-event-bundle-data').attr('data-max-flavors'), 10);
      var eventBundleMaxTotalQty = parseInt($('.jsc-event-bundle-data').attr('data-max-total-quantity'), 10);
      var prodInventory = parseInt($input.attr('data-prod-inventory'), 10);
      var ignoreInventoryCap = $input.attr('data-ignore-inventory-cap') === 'true';
      var quantityIncrement = parseInt($('.jsc-event-bundle-data').attr('data-quantity-increment'), 10) || 5;
      
      // Count current total quantity across all flavors
      var currentTotalQuantity = 0;
      $('.js-quantity-wrapper-event input[data-quantity-input-event-bundle]').each(function() {
         var qty = parseInt($(this).val(), 10) || 0;
         currentTotalQuantity += qty;
      });
      
      $input.val(currentValue + quantityIncrement);
      
      if (!ignoreInventoryCap && (currentValue + quantityIncrement) > prodInventory){
         $input.val(currentValue);
         showBundlePrompt(`This product has only ${prodInventory} remaining. Kindly adjust your quantity`);
      }else{
         // Check if adding more would exceed max total quantity
         if ((currentTotalQuantity + quantityIncrement) > eventBundleMaxTotalQty) {
            $input.val(currentValue);
            showBundlePrompt(`You have reached the maximum total quantity of ${eventBundleMaxTotalQty} items.`);
         }else{
            var $summaryFlavour = $(`.jsc-summary-flavour[data-product-id="${productID}"]`);
            if ($summaryFlavour.length > 0) {
               $summaryFlavour.find('.jsc-summary-flavour-quantity').text(`${currentValue + quantityIncrement}x`).attr('data-flav-quantity', currentValue + quantityIncrement);
               $prodSelectedQTYElement.text(`${currentValue + quantityIncrement}`);
            } else {
               var newFlavourHTML = `
                  <div class="jsc-summary-flavour" data-product-id="${productID}" data-var-id="${varID}" data-flav-price="${productPrice}">
                     <span class="jsc-summary-flavour-quantity" data-flav-quantity="${currentValue + quantityIncrement}">${currentValue + quantityIncrement}x</span>
                     <span class="jsc-summary-flavour-name">${productTitle}</span>
                     <span class="jsc-summary-flavour-remove" onclick="removeEventFlavourBundle(this, ${productID})">x</span>
                  </div>
               `;
               $('.jsc-summary-flavour-product').append(newFlavourHTML);
               $prodSelectedQTYElement.text(`${currentValue + quantityIncrement}`);
            }
      
            updateTotalQuantityEventBundle();
            updateTotalEventBundlePrice();
            checkEventBundleStatus();
            updateEventBundleAddButtons();
            updateMainButtonText();
      
            if ($input.val() >= quantityIncrement) {
               $outerProdGrid.addClass('jsc-event-flavour-selected');
            }
         }
      }
   });

   // Handle onchange event for quantity input (only validates, no rounding for typed values)
   // This fires when the value changes and user finishes typing
   $(document).on('input', '.js-quantity-wrapper-event input[data-quantity-input-event-bundle]', function () {
      var $input = $(this);
      
      // Clear previous timeout for this input
      if ($input.data('quantity-timeout')) {
         clearTimeout($input.data('quantity-timeout'));
      }
      
      // Debounce: wait 500ms after user stops typing before processing
      var timeout = setTimeout(function() {
         $input.trigger('quantity-change');
         $input.removeData('quantity-timeout');
      }, 500);
      
      $input.data('quantity-timeout', timeout);
   });
   
   $(document).on('quantity-change change', '.js-quantity-wrapper-event input[data-quantity-input-event-bundle]', function () {
      var $wrapper = $(this).closest('.js-quantity-wrapper-event');
      var $outerProdGrid = $(this).closest('.product-grid-item');
      var $prodSelectedQTYElement = $outerProdGrid.find('.jsc-bundle-product-selected-qty span');
      var $input = $(this);
      var productID = $input.attr('data-prod-id');
      var varID = $input.attr('data-var-id');
      var productTitle = $input.attr('data-prod-title');
      var productPrice = parseFloat($input.attr('data-prod-price'));
      var prodInventory = parseInt($input.attr('data-prod-inventory'), 10);
      var ignoreInventoryCap = $input.attr('data-ignore-inventory-cap') === 'true';
      var atcbutton = $wrapper.closest('.product__block__quantity').find('.jsc-atc-event-flavour');
      var eventBundleMaxTotalQty = parseInt($('.jsc-event-bundle-data').attr('data-max-total-quantity'), 10);
      
      // Get the raw input value (what user typed - allow any value, no rounding)
      var rawValue = $input.val();
      var currentValue = parseInt(rawValue, 10) || 0;
      
      // Validate the value on blur (only check limits, no rounding)
      var validatedValue = currentValue;
      
      // If value is negative, set to 0
      if (currentValue < 0) {
         validatedValue = 0;
      }

      // Enforce per-line minimum from the input's `min` (event bundle increment); 0 stays allowed as "not selected"
      var bundleMin = parseInt($input.attr('min'), 10);
      if (!isNaN(bundleMin) && bundleMin > 0 && validatedValue > 0 && validatedValue < bundleMin) {
         showBundlePrompt(`Quantity cannot be less than ${bundleMin}. Adjusted to ${bundleMin}.`);
         validatedValue = bundleMin;
      }
      
      // Check against inventory limit (unless Continue selling / untracked)
      if (!ignoreInventoryCap && validatedValue > prodInventory) {
         validatedValue = prodInventory;
         if (currentValue > prodInventory) {
            showBundlePrompt(`This product has only ${prodInventory} remaining. Kindly adjust your quantity`);
         }
      }
      
      // Check against max total quantity across all flavors
      if (validatedValue > 0) {
         // Calculate current total quantity from other inputs
         var currentTotalQuantity = 0;
         $('.js-quantity-wrapper-event input[data-quantity-input-event-bundle]').each(function() {
            var qty = parseInt($(this).val(), 10) || 0;
            // Don't include this input's current value in the total
            if ($(this)[0] !== $input[0]) {
               currentTotalQuantity += qty;
            }
         });
         
         // Check if adding this quantity would exceed max
         if ((currentTotalQuantity + validatedValue) > eventBundleMaxTotalQty) {
            var availableQty = eventBundleMaxTotalQty - currentTotalQuantity;
            if (availableQty > 0) {
               validatedValue = availableQty;
               showBundlePrompt(`You have reached the maximum total quantity of ${eventBundleMaxTotalQty} items. Adjusted to ${validatedValue}.`);
            } else {
               validatedValue = 0;
               showBundlePrompt(`You have reached the maximum total quantity of ${eventBundleMaxTotalQty} items.`);
            }
         }
      }
      
      // Update the input value with validated value (only if it changed due to validation)
      if (validatedValue !== currentValue) {
         $input.val(validatedValue);
      }
      currentValue = validatedValue;
      
      // If quantity is 0, reset to default state
      if (currentValue === 0) {
         $(`.jsc-summary-flavour[data-product-id="${productID}"], .jsc-summary-flavour[data-var-id="${varID}"]`).remove();
         $prodSelectedQTYElement.text('0');
         $wrapper.hide();
         atcbutton.css('display', 'inline-block');
         $outerProdGrid.removeClass('jsc-event-flavour-selected');
         
         updateTotalQuantityEventBundle();
         updateTotalEventBundlePrice();
         checkEventBundleStatus();
         updateEventBundleAddButtons();
         updateMainButtonText();
      } else {
         // Valid quantity (any value > 0) - update the summary
         var $summaryFlavour = $(`.jsc-summary-flavour[data-product-id="${productID}"]`);
         if ($summaryFlavour.length > 0) {
            $summaryFlavour.find('.jsc-summary-flavour-quantity').text(`${currentValue}x`).attr('data-flav-quantity', currentValue);
            $prodSelectedQTYElement.text(`${currentValue}`);
         } else {
            // Create new summary item if it doesn't exist
            var newFlavourHTML = `
               <div class="jsc-summary-flavour" data-product-id="${productID}" data-var-id="${varID}" data-flav-price="${productPrice}">
                  <span class="jsc-summary-flavour-quantity" data-flav-quantity="${currentValue}">${currentValue}x</span>
                  <span class="jsc-summary-flavour-name">${productTitle}</span>
                  <span class="jsc-summary-flavour-remove" onclick="removeEventFlavourBundle(this, ${productID})">x</span>
               </div>
            `;
            $('.jsc-summary-flavour-product').append(newFlavourHTML);
            $prodSelectedQTYElement.text(`${currentValue}`);
         }
         
         $outerProdGrid.addClass('jsc-event-flavour-selected');
         
         updateTotalQuantityEventBundle();
         updateTotalEventBundlePrice();
         checkEventBundleStatus();
         updateEventBundleAddButtons();
         updateMainButtonText();
      }
   });
}

addEventFlavourBundle = (button) => {
   var $button = $(button);
   
   // Check if button is disabled or has max flavors class
   if ($button.attr('disabled') || $button.prop('disabled') || $button.hasClass('jsc-disabled-max-flavors')) {
      // Check if it's disabled due to max flavors reached
      if ($button.hasClass('jsc-disabled-max-flavors')) {
         showBundlePrompt('To select this flavour, remove quantity from one of the selected flavours');
         return;
      }
      // For other disabled states (sold out, max quantity), do nothing
      return;
   }
   
   var flavourQtyWrapper = $button.closest('.product__block__quantity').find('.js-quantity-wrapper-event');
   var flavourQtySelectorInput = $button.closest('.product__block__quantity').find('.js-quantity-wrapper-event input[data-quantity-input-event-bundle]');
   var flavourQtyPlusButton = $button.closest('.product__block__quantity').find('.js-quantity-wrapper-event .quantity__button[data-increase-quantity-event-bundle]');
   
   // Count the number of different flavors and total quantity currently selected
   var currentSelectedFlavors = 0;
   var currentTotalQuantity = 0;
   $('.js-quantity-wrapper-event input[data-quantity-input-event-bundle]').each(function() {
      var currentValue = parseInt($(this).val(), 10) || 0;
      if (currentValue > 0) {
         currentSelectedFlavors++;
         currentTotalQuantity += currentValue;
      }
   });
   
   var eventBundleMaxQty = parseInt($('.jsc-event-bundle-data').attr('data-max-flavors'), 10);
   var eventBundleMaxTotalQty = parseInt($('.jsc-event-bundle-data').attr('data-max-total-quantity'), 10);
   
   // Check both limits: max flavors and max total quantity
   if (currentSelectedFlavors < eventBundleMaxQty && currentTotalQuantity < eventBundleMaxTotalQty) {
      $(flavourQtyWrapper).css('display', 'flex');
      $button.hide();
      flavourQtyPlusButton.click();
      
      // Update all ADD buttons after adding a flavor
      updateEventBundleAddButtons();
   } else {
      if (currentSelectedFlavors >= eventBundleMaxQty) {
         showBundlePrompt(overMaxEventBundleMsg);
      } else if (currentTotalQuantity >= eventBundleMaxTotalQty) {
         showBundlePrompt(`You have reached the maximum total quantity of ${eventBundleMaxTotalQty} items.`);
      }
   }
}

removeEventFlavourBundle = (button, product_id) => {
   var $button = $(button);
   $('.js-quantity-wrapper-event.jsc-event-flavour-selected input').each(function () {
      var $input = $(this);
      var prodId = parseInt($input.attr('data-prod-id'));
      
      if (prodId == product_id) {
         $input.val(0);
         var thisBlock = $input.closest('.product__block__quantity');
         var $wrapper = $input.closest('.js-quantity-wrapper-event');
         $wrapper.hide();
         $wrapper.removeClass('jsc-event-flavour-selected');
         thisBlock.find('.jsc-atc-event-flavour').css('display', 'inline-block');
         $('.jsc-summary-flavour').each(function () {
            var $summaryFlavour = $(this);
            var summaryFlavourID = $(this).attr('data-product-id');
            if (summaryFlavourID == product_id) {
               $summaryFlavour.remove();
            }
         });
         updateTotalQuantityEventBundle();
         updateTotalEventBundlePrice();
         checkEventBundleStatus();
         
         // Update all ADD buttons after removing a flavor
         updateEventBundleAddButtons();
      }
  });
}

updateEventFlavourChoicesIndicator = (selectedCount, maxCount) => {
   var $header = $('.prod-bundle-event .jsc-select-flavour-header-section');
   if (!$header.length) {
      return;
   }

   if (maxCount === undefined || isNaN(maxCount)) {
      maxCount = parseInt($header.attr('data-max_flavors'), 10) || 0;
   }
   if (selectedCount === undefined || isNaN(selectedCount)) {
      selectedCount = 0;
   }

   $header.find('.jsc-select-flavour-dot').each(function(index) {
      $(this).toggleClass('is-filled', index < selectedCount);
   });

   var flavourLabel = maxCount === 1 ? 'flavour' : 'flavours';
   $header.find('.jsc-select-flavour-remaining').text(
      selectedCount + ' of ' + maxCount + ' ' + flavourLabel + ' chosen'
   );

   var $event_title = $('.jsc-flavour-summary-bundle-title');
   var $event_status = $('.jsc-event-current-status');
   var flavour_text = 'flavour';
   if (selectedCount > 0) {
      $event_title.hide();
      $event_status.show();

      if (selectedCount > 1) {
         flavour_text = 'flavours';
      }
      var count_and_text = selectedCount + ' ' + flavour_text;
   } else {
      $event_title.show();
      $event_status.hide();
   }
   $('.jsc-event-total-flavours').text(count_and_text);
};

updateEventBundleAddButtons = () => {
   // Count the number of different flavors and total quantity currently selected
   var currentSelectedFlavors = 0;
   var currentTotalQuantity = 0;
   $('.js-quantity-wrapper-event input[data-quantity-input-event-bundle]').each(function() {
      var currentValue = parseInt($(this).val(), 10) || 0;
      if (currentValue > 0) {
         currentSelectedFlavors++;
         currentTotalQuantity += currentValue;
      }
   });
   
   var eventBundleMaxQty = parseInt($('.jsc-event-bundle-data').attr('data-max-flavors'), 10);
   var eventBundleMaxTotalQty = parseInt($('.jsc-event-bundle-data').attr('data-max-total-quantity'), 10);

   updateEventFlavourChoicesIndicator(currentSelectedFlavors, eventBundleMaxQty);
   
   // Update all ADD buttons
   $('.jsc-atc-event-flavour').each(function() {
      var $button = $(this);
      var $input = $button.closest('.product__block__quantity').find('input[data-quantity-input-event-bundle]');
      var currentValue = parseInt($input.val(), 10) || 0;
      var $wrapper = $input.closest('.js-quantity-wrapper-event');
      var $outerProdGrid = $input.closest('.product-grid-item');
      var isFlavourSelected = $outerProdGrid.hasClass('jsc-event-flavour-selected');
      
      // If this flavor is already selected (has quantity > 0), hide the ADD button
      if (currentValue > 0 || isFlavourSelected) {
         $button.hide();
         $wrapper.css('display', 'flex');
      } else {
         // This flavor is not selected yet
         $button.show();
         
         // Check if product is sold out first
         if ($wrapper.closest('.product__block__quantity').hasClass('jsc-out-of-stock')) {
            // Product is sold out - keep disabled state and sold out text
            $button.attr('disabled', true);
            $button.find('.jsc-event-flavour-atc-text').text('SOLD OUT');
            $button.removeAttr('onclick');
         } else if (currentSelectedFlavors >= eventBundleMaxQty) {
            // Disable button and change text for max flavors
            $button.removeAttr('disabled');
            $button.addClass('jsc-disabled-max-flavors');
            $button.find('.jsc-event-flavour-atc-text').text('Max of ' + eventBundleMaxQty + ' flavors reached');
            // Keep onclick handler for message display
         } else if (currentTotalQuantity >= eventBundleMaxTotalQty) {
            // Disable button and change text for max total quantity
            $button.attr('disabled', true);
            $button.find('.jsc-event-flavour-atc-text').text('Max quantity of ' + eventBundleMaxTotalQty + ' reached');
            $button.removeAttr('onclick');
         } else {
            // Enable button and restore original text
            $button.removeAttr('disabled');
            $button.removeClass('jsc-disabled-max-flavors');
            $button.find('.jsc-event-flavour-atc-text').text('ADD');
            $button.attr('onclick', 'addEventFlavourBundle(this)');
         }
      }
   });
}

addEventBundleToCart = (button) => {
   var $button = $(button);
   
   // Check if date and time are selected
   var eventDate = document.getElementById('event-date').value;
   var eventTime = document.getElementById('event-time').value;
   
   if (!eventDate || !eventTime) {
      // Check if overlay is enabled to show appropriate message
      const collectionDateInput = document.getElementById('collection-date');
      const collectionTimeInput = document.getElementById('collection-time');
      const enableOverlay = collectionDateInput && collectionTimeInput;
      
      if (enableOverlay) {
         showBundlePrompt('Please select both Event Date and Ready By Time before adding to cart');
      } else {
         showBundlePrompt('Please select Event Date and Delivery Time before adding to cart');
      }
      return;
   }
   
   // Calculate current total quantity to determine the correct tier
   var currentTotalQuantity = 0;
   $('.js-quantity-wrapper-event input[data-quantity-input-event-bundle]').each(function() {
      var currentValue = parseInt($(this).val(), 10) || 0;
      currentTotalQuantity += currentValue;
   });
   
   // Get the appropriate variant ID based on tier selection
   var mainProdVarID = getTierVariantId(currentTotalQuantity);
   var bindID = mainProdVarID + '-' + Date.now();
   var eventBundleMaxQty = parseInt($('.jsc-event-bundle-data').attr('data-max-flavors'), 10);
   var eventBundleMinTotalQty = parseInt($('.jsc-event-bundle-data').attr('data-min-total-quantity'), 10);
   var eventBundleTotalPrice = parseFloat($('.jsc-event-bundle-data').attr('data-event-bundle-total-price'));

   if(currentTotalQuantity < eventBundleMinTotalQty ){
      showBundlePrompt(`Please select a minimum of ${eventBundleMinTotalQty} cups`);
   }
   else if(currentTotalQuantity >= eventBundleMinTotalQty){
      $button.attr('disabled', true);
      $button.addClass('loading');
      var atcButtonText = $button.find('.jsc-atc-event-bundle-text');
      var loaderButton =  $button.find('.btn-state-loading');
      atcButtonText.hide();
      
      var jsonObjMain = [];
      var itemMain = {};
      var $objMain = {};
      var variantIDs = [];
      var variantQuantities = [];
      var variantTitle = [];
      var totalPartyCups = 0;
      
      // Add event bundle main product using the selected tier variant
      var mainProdID = parseInt(mainProdVarID, 10);
      $('.jsc-summary-flavour').each(function() {
         var $flavour = $(this);
         var flavourID = parseInt($flavour.attr('data-var-id'), 10);
         var flavName = $flavour.find('.jsc-summary-flavour-name').text();
         var flavQuantityText = $flavour.find('.jsc-summary-flavour-quantity').text();
         var flavQuantity = parseInt($flavour.find('.jsc-summary-flavour-quantity').text().replace('x', '').trim(), 10);
         var flavQuantity = parseInt($flavour.find('.jsc-summary-flavour-quantity').attr('data-flav-quantity'));
         $objMain[flavName] = flavQuantityText;

         variantIDs.push(flavourID);
         variantQuantities.push(flavQuantity);
         variantTitle.push(flavName);
         totalPartyCups += flavQuantity;
      });

      // Assign collected data as comma-separated strings
      $objMain['_variant_ids'] = variantIDs.join(',');
      $objMain['_variant_qty'] = variantQuantities.join(',');
      $objMain['_variant_title'] = variantTitle.join(',');
      $objMain['_BindID'] = bindID;
      $objMain['_Event Bundle Product'] = 'main';
      
      // Snapshot for delivery arrival offset (must be before delete below)
      var eventBundleForDeliveryArrival = window.eventBundleDetails || null;
      // Add event details from overlay if available
      if (window.eventBundleDetails) {
         $objMain['_Event Type'] = window.eventBundleDetails.eventType;
         $objMain['_Delivery Option'] = window.eventBundleDetails.deliveryOption;
         // Clear the stored details after use
         delete window.eventBundleDetails;
      }
      
      // Add formatted date and time to line item properties
      const formattedDateTime = formatDateTimeForCart(eventDate, eventTime);
      const deliveryArrivalTime = getDeliveryArrivalTimeProperty(eventDate, eventTime, eventBundleForDeliveryArrival);
      
      // Check if overlay is enabled (collection fields exist)
      const collectionDateInput = document.getElementById('collection-date');
      const collectionTimeInput = document.getElementById('collection-time');
      const enableOverlay = collectionDateInput && collectionTimeInput;

      $objMain['Total no. of party cups'] = totalPartyCups;
      
      if (enableOverlay) {
         // Overlay enabled - add Event Date/Time and Collection Date/Time properties
         $objMain['Event Date'] = formattedDateTime.date;
         $objMain['Event Start Time'] = formattedDateTime.time;
         $objMain['_Delivery Date'] = formatCartDateDdMmYyyy(eventDate);
         if (deliveryArrivalTime) {
            $objMain['Delivery arrival time'] = deliveryArrivalTime;
            $objMain['_Delivery Time'] = formatCartTime24(deliveryArrivalTime);
         }
         
         // Get collection values from overlay (auto-filled from FROM date/time, no validation needed)
         const collectionDate = collectionDateInput.value;
         const collectionTime = collectionTimeInput.value;
         
         // Note: Collection date/time are automatically filled from FROM date/time selection
         // No manual validation needed since they're read-only and auto-populated
         
         const collectionFormattedDateTime = formatDateTimeForCart(collectionDate, collectionTime);
         $objMain['Collection Date'] = collectionFormattedDateTime.date;
         $objMain['Collection Time'] = collectionFormattedDateTime.time;
      } else {
         // Overlay disabled - add as delivery properties only
         $objMain['Delivery Date'] = formattedDateTime.date;
         $objMain['Delivery Time'] = formattedDateTime.time;
         $objMain['_Delivery Date'] = formatCartDateDdMmYyyy(eventDate);
         $objMain['_Delivery Time'] = formatCartTime24(eventTime);
      }
      itemMain["id"] = mainProdID;
      itemMain["quantity"] = 1;
      itemMain["properties"] = $objMain;

      // Combine all items into a single array for faster cart addition
      var allCartItems = [];
      
      // Add event bundle child products (flavors)
      $('.jsc-summary-flavour').each(function() {
         var $flavour = $(this);
         var flavourID = parseInt($flavour.attr('data-var-id'), 10);
         var flavQuantity = parseInt($flavour.find('.jsc-summary-flavour-quantity').attr('data-flav-quantity'), 10);
         var itemChild = {};
         var $objChild = {};

         $objChild['_BindID'] = bindID;
         $objChild['_Event Bundle Product'] = 'child';
         itemChild["id"] = flavourID;
         itemChild["quantity"] = flavQuantity;
         itemChild["properties"] = $objChild;
         allCartItems.push(itemChild);
      });

      // Add premium / standard delivery addon products when configured and selected
      var eventBundleData = $('.jsc-event-bundle-data');
      var selectedDeliveryOption = $('input[name="delivery_option"]:checked').val();
      var premiumAddonVariantId = eventBundleData.attr('data-premium-addon-variant-id');

      if (selectedDeliveryOption === 'premium' && premiumAddonVariantId && premiumAddonVariantId.trim() !== '') {
         var itemAddon = {};
         var $objAddon = {};

         $objAddon['_BindID'] = bindID;
         $objAddon['_Event Bundle Product'] = 'premium-addon';
         itemAddon["id"] = parseInt(premiumAddonVariantId, 10);
         itemAddon["quantity"] = 1;
         itemAddon["properties"] = $objAddon;
         allCartItems.push(itemAddon);
      } else if (selectedDeliveryOption === 'standard') {
         // Standard delivery addon only when Standard is selected (never when Premium is selected)
         var standardAddonVariantId = eventBundleData.attr('data-standard-addon-variant-id');
         var productHasStandardDeliveryTag = eventBundleData.attr('data-product-has-standard-delivery-tag') === 'true';
         if (
            productHasStandardDeliveryTag &&
            standardAddonVariantId &&
            standardAddonVariantId.trim() !== ''
         ) {
            var itemStandardAddon = {};
            var $objStandardAddon = {};

            $objStandardAddon['_BindID'] = bindID;
            $objStandardAddon['_Event Bundle Product'] = 'standard-addon';
            itemStandardAddon['id'] = parseInt(standardAddonVariantId, 10);
            itemStandardAddon['quantity'] = 1;
            itemStandardAddon['properties'] = $objStandardAddon;
            allCartItems.push(itemStandardAddon);
         }
      }

      // Only calculate rental box and after-hour surcharge if overlay is enabled (collection fields exist)
      // Reuse collectionDateInput and collectionTimeInput from above
      if (enableOverlay && collectionDateInput && collectionTimeInput) {
         const collectionDateCheck = collectionDateInput.value;
         const collectionTimeCheck = collectionTimeInput.value;

         console.log("collectionDateCheck", collectionDateCheck);
         
         //calculate number of days between event date and collection date
         // Parse event date (format: YYYY-MM-DD)
         let eventDateObj;
         if (eventDate && eventDate.includes('-')) {
            const [year, month, day] = eventDate.split('-').map(Number);
            eventDateObj = new Date(year, month - 1, day);
            eventDateObj.setHours(0, 0, 0, 0);
         } else {
            eventDateObj = new Date(eventDate + 'T00:00:00');
         }
         
         // Parse collection date (format: YYYY-MM-DD, same as delivery-date)
         let collectionDateObj;
         if (collectionDateCheck && collectionDateCheck.includes('-')) {
            const parts = collectionDateCheck.split('-');
            if (parts.length === 3) {
               // YYYY-MM-DD format (same as delivery-date)
               const year = parseInt(parts[0], 10);
               const month = parseInt(parts[1], 10);
               const day = parseInt(parts[2], 10);
               collectionDateObj = new Date(year, month - 1, day);
               collectionDateObj.setHours(0, 0, 0, 0);
            } else {
               collectionDateObj = new Date(collectionDateCheck + 'T00:00:00');
            }
         } else {
            collectionDateObj = new Date(collectionDateCheck + 'T00:00:00');
         }
         
         // Validate dates before calculation
         if (isNaN(eventDateObj.getTime()) || isNaN(collectionDateObj.getTime())) {
            console.error('Invalid dates - eventDate:', eventDate, 'collectionDate:', collectionDateCheck);
            var qtyExtra = 0;
         } else {
            const timeDifference = collectionDateObj.getTime() - eventDateObj.getTime();
            const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            var qtyExtra = Math.floor((daysDifference - 1) / 5);
            console.log("qtyExtra", qtyExtra, "daysDifference:", daysDifference);
         }

         if(qtyExtra > 0 && $('.rental-box-product').length > 0){
            var itemAddon = {};
            var $objAddon = {};

            $objAddon['_BindID'] = bindID;
            $objAddon['_Event Bundle Product'] = 'rental-box';
            itemAddon["id"] = parseInt($('.rental-box-product').val(), 10);
            itemAddon["quantity"] = qtyExtra;
            itemAddon["properties"] = $objAddon;
            allCartItems.push(itemAddon);
         }

         // After-hour surcharge when collection is 10:30 PM or later (same calendar day)
         const surchargeAfterMinutes = 22 * 60 + 30;
         let collectionMinutesFromMidnight = null;
         if (collectionTimeCheck && collectionTimeCheck.includes(':')) {
            if (collectionTimeCheck.includes('PM') || collectionTimeCheck.includes('AM')) {
               const timeMatch = collectionTimeCheck.match(/(\d+):(\d+)\s*(AM|PM)/i);
               if (timeMatch) {
                  let hours = parseInt(timeMatch[1], 10);
                  const minutes = parseInt(timeMatch[2], 10);
                  const ampm = timeMatch[3].toUpperCase();
                  let hours24;
                  if (ampm === 'PM' && hours !== 12) hours24 = hours + 12;
                  else if (ampm === 'AM' && hours === 12) hours24 = 0;
                  else hours24 = hours;
                  collectionMinutesFromMidnight = hours24 * 60 + minutes;
               }
            } else {
               const parts = collectionTimeCheck.split(':').map(Number);
               const hours24 = parts[0];
               const minutes = parts[1] || 0;
               collectionMinutesFromMidnight = hours24 * 60 + minutes;
            }
         }
         const isSurchargeCollectionTime = collectionMinutesFromMidnight !== null &&
            collectionMinutesFromMidnight >= surchargeAfterMinutes;
         if (isSurchargeCollectionTime && $('.after-hour-surcharge-product').length > 0) {
            var itemAddon = {};
            var $objAddon = {};

            $objAddon['_BindID'] = bindID;
            $objAddon['_Event Bundle Product'] = 'after-hour-surcharge';
            itemAddon["id"] = parseInt($('.after-hour-surcharge-product').val(), 10);
            itemAddon["quantity"] = 1;
            itemAddon["properties"] = $objAddon;
            allCartItems.push(itemAddon);
         }
      }

      // Add main event bundle product
      allCartItems.push(itemMain);



      // Add all items to cart in a single call
      console.log("Adding all items to cart:", allCartItems);
      
      // Store original button text for restoration
      const confirmBtn = document.querySelector('.event-bundle-confirm-btn');
      const originalButtonText = confirmBtn ? confirmBtn.getAttribute('data-original-text') || confirmBtn.textContent.trim() : 'Confirm Details & Add to Cart';
      if (confirmBtn && !confirmBtn.getAttribute('data-original-text')) {
         confirmBtn.setAttribute('data-original-text', originalButtonText);
      }
      
      CartJS.addItems(allCartItems, {
         "success": function(data, textStatus, jqXHR) {
            console.log('Success in adding all event bundle items');
            
            // Call overlay callback if it exists (for overlay confirm button)
            if (window.eventBundleOverlayCallback) {
               window.eventBundleOverlayCallback();
               delete window.eventBundleOverlayCallback;
            }

            resetEventBundlePage();
            
            // Reset confirm button to default state after successful cart addition
            const confirmBtn = document.querySelector('.event-bundle-confirm-btn');
            if (confirmBtn) {
               const originalText = confirmBtn.getAttribute('data-original-text') || 'Confirm Details & Add to Cart';
               confirmBtn.disabled = true;
               confirmBtn.innerHTML = originalText;
            }
         },
         "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error occurred while adding event bundle items:", errorThrown, jqXHR);
            
            // Reset confirm button on error
            const confirmBtn = document.querySelector('.event-bundle-confirm-btn');
            if (confirmBtn) {
               const originalText = confirmBtn.getAttribute('data-original-text') || 'Confirm Details & Add to Cart';
               confirmBtn.disabled = false;
               confirmBtn.innerHTML = originalText;
            }
         }
      });
   }
}

toggleCollapse = () => {
   var $container = $('.jsc-bundle-summary-mobile');
   var $button = $container.find('.jsc-collapse-toggle');
   var isCollapsed = $container.hasClass('collapsed');

   // Toggle class to show or hide the full content
   if (isCollapsed) {
      $container.removeClass('collapsed');
      $button.text('+'); // Change button text
   } else {
      $container.addClass('collapsed');
      $button.text('-'); // Change button text
   }
}

updateAnchorScrollOffset = () => {
   var offset = 8;
   var headerWrapper = document.querySelector('.header__wrapper');
   var header = document.querySelector('.theme__header');
   var announcementBar = document.querySelector('.jsc-sticky-announcement-bar');

   if (announcementBar) {
      offset += announcementBar.offsetHeight;
   }

   if (headerWrapper && header) {
      var stickyType = headerWrapper.getAttribute('data-header-sticky');
      var directionalHeaderVisible = headerWrapper.classList.contains('js__header__stuck--trigger-animation');

      if (stickyType == 'sticky' || directionalHeaderVisible) {
         offset += header.offsetHeight;
      }
   }

   document.documentElement.style.setProperty('--jsc-anchor-scroll-offset', `${Math.ceil(offset)}px`);
}

checkAnnouncmentBarSticky = () => {
   var data_announcement_bar_sticky = $('.announcement').attr('data-announcement-bar-sticky');
   var parent = $('.announcement').parent();

   if (data_announcement_bar_sticky == 'sticky') {
      parent.addClass('jsc-sticky-announcement-bar');
      var parentHeight = parent.outerHeight();
      
      // console.log('Parent height:', parentHeight);
      $('.header__wrapper').css('top', `${parentHeight}px`);
   } else {
      parent.removeClass('jsc-sticky-announcement-bar');
      $('.header__wrapper').css('top', '0');
   }

   updateAnchorScrollOffset();
}

calculatedDescHeight = () => {
   var elems = document.querySelectorAll('.flickity-grid');

   elems.forEach((elem) => {
      var maxHeight = 0;
      var maxTitleHeight = 0;

      // Reset heights
      elem.querySelectorAll('.product-attributes').forEach((productAttr) => {
         productAttr.style.height = "";
      });
      elem.querySelectorAll('.product__grid__title__wrapper').forEach((titleWrapper) => {
         titleWrapper.style.height = "";
      });

      // Find max height for product-attributes
      elem.querySelectorAll('.product-attributes p').forEach((productAttr) => {
         var height = productAttr.offsetHeight
         if (height > maxHeight) {
            maxHeight = height;
         }
      });

      // Find max height for product__grid__title__wrapper
      elem.querySelectorAll('.product__grid__title__wrapper').forEach((titleWrapper) => {
         var height = titleWrapper.offsetHeight
         if (height > maxTitleHeight) {
            maxTitleHeight = height;
         }
      });

      // Use the maximum of both
      var finalHeight = Math.max(maxHeight, maxTitleHeight);

      // Apply same height to both
      elem.querySelectorAll('.product-attributes').forEach((productAttr) => {
         productAttr.style.height = finalHeight + "px";
      });
      elem.querySelectorAll('.product__grid__title__wrapper').forEach((titleWrapper) => {
         titleWrapper.style.height = finalHeight + "px";
      });

      // console.log("Processed grid:", elem, "Max height:", finalHeight);
   });
}

calculatedDescHeightNormalGrid = () => {
   var elems = document.querySelectorAll('.js-grid');

   elems.forEach((elem) => {
      var maxHeight = 0;
      var maxTitleHeight = 0;

      // Reset heights
      elem.querySelectorAll('.product-attributes').forEach((productAttr) => {
         productAttr.style.height = "";
      });
      elem.querySelectorAll('.product__grid__title__wrapper').forEach((titleWrapper) => {
         titleWrapper.style.height = "";
      });

      // Find max height for product-attributes
      elem.querySelectorAll('.product-attributes p').forEach((productAttr) => {
         var height = productAttr.offsetHeight
         if (height > maxHeight) {
            maxHeight = height;
         }
      });

      // Find max height for product__grid__title__wrapper
      elem.querySelectorAll('.product__grid__title__wrapper').forEach((titleWrapper) => {
         var height = titleWrapper.offsetHeight
         if (height > maxTitleHeight) {
            maxTitleHeight = height;
         }
      });

      // Use the maximum of both
      var finalHeight = Math.max(maxHeight, maxTitleHeight);

      // Apply same height to both
      elem.querySelectorAll('.product-attributes').forEach((productAttr) => {
         productAttr.style.height = finalHeight + "px";
      });
      elem.querySelectorAll('.product__grid__title__wrapper').forEach((titleWrapper) => {
         titleWrapper.style.height = finalHeight + "px";
      });

      // console.log("Processed grid:", elem, "Max height:", finalHeight);
   });
}

// Sync heights for product grid items on mobile (handles all containers)
syncProductGridHeights = () => {
   // Only run on mobile
   if (window.innerWidth > 798) {
      return;
   }

   // Find all product grid containers (flickity-grid, js-grid, or any container with product-grid-item)
   var containers = document.querySelectorAll('.flickity-grid, .js-grid, [data-grid]');
   
   containers.forEach((container) => {
      var maxHeight = 0;
      var maxTitleHeight = 0;

      // Reset heights
      container.querySelectorAll('.product-attributes').forEach((productAttr) => {
         productAttr.style.height = "";
      });
      container.querySelectorAll('.product__grid__title__wrapper').forEach((titleWrapper) => {
         titleWrapper.style.height = "";
      });

      // Find max height for product-attributes
      container.querySelectorAll('.product-attributes p').forEach((productAttr) => {
         var height = productAttr.offsetHeight;
         if (height > maxHeight) {
            maxHeight = height;
         }
      });

      // Find max height for product__grid__title__wrapper
      container.querySelectorAll('.product__grid__title__wrapper').forEach((titleWrapper) => {
         var height = titleWrapper.offsetHeight;
         if (height > maxTitleHeight) {
            maxTitleHeight = height;
         }
      });

      // Use the maximum of both
      var finalHeight = Math.max(maxHeight, maxTitleHeight);

      // Apply same height to both
      container.querySelectorAll('.product-attributes').forEach((productAttr) => {
         productAttr.style.height = finalHeight + "px";
      });
      container.querySelectorAll('.product__grid__title__wrapper').forEach((titleWrapper) => {
         titleWrapper.style.height = finalHeight + "px";
      });
   });
}

// Per-row title/attributes sync for small mobile (480px and below)
syncProductGridHeights480 = () => {
   if (window.innerWidth > 480) return;

   document.querySelectorAll('.flickity-grid, .js-grid, [data-grid]').forEach((container) => {
      var items = container.querySelectorAll('.product-grid-item');
      if (!items.length) return;

      container.querySelectorAll('.product-attributes, .product__grid__title__wrapper').forEach((el) => {
         el.style.height = "";
      });

      var rows = [];
      items.forEach((item) => {
         var top = Math.round(item.getBoundingClientRect().top);
         var row = rows.find((r) => Math.abs(r.top - top) <= 5);
         if (!row) rows.push(row = { top: top, items: [] });
         row.items.push(item);
      });
      rows.sort((a, b) => a.top - b.top);

      rows.forEach((row) => {
         [
            {
               sel: '.product__grid__title__wrapper',
               measure: (el) => {
                  var title = el.querySelector('.product__grid__title');
                  var rating = el.querySelector('.rating__wrapper__grid');
                  return Math.max(title ? title.offsetHeight : el.offsetHeight, rating ? rating.offsetHeight : 0);
               }
            },
            {
               sel: '.product-attributes',
               measure: (el) => {
                  var p = el.querySelector('p');
                  return p ? p.offsetHeight : 0;
               }
            }
         ].forEach(({ sel, measure }) => {
            var heights = row.items.map((item) => {
               var el = item.querySelector(sel);
               return el ? measure(el) : 0;
            }).filter((h) => h > 0);
            if (!heights.length) return;

            var max = Math.max.apply(null, heights);
            var height = max - Math.min.apply(null, heights) > 2 ? max + "px" : "";
            row.items.forEach((item) => {
               var el = item.querySelector(sel);
               if (el) el.style.height = height;
            });
         });
      });
   });
}



// var previousScreenWidth = $(window).width();
// var adjustElementsBasedOnScreenWidth = function () {
//    var $desktopElement = $('.jsc-bundle-summary-desktop');
//    var $mobileElement = $('.jsc-bundle-summary-mobile');
//    var $bundleProductSections = $('.jsc-bundle-product-section');
//    var currentScreenWidth = $(window).width();
//    var isMobileNow = currentScreenWidth <= 480;
//    var wasMobileBefore = previousScreenWidth <= 480;

//    if ($bundleProductSections.length > 0 && isMobileNow !== wasMobileBefore) {
//       location.reload();
//       return;
//    }

//    previousScreenWidth = currentScreenWidth;

//    if (isMobileNow) {
//       $desktopElement.remove();
//       $mobileElement.show();
//    } else {
//       $mobileElement.remove();
//       $desktopElement.show();
//    }
// }

checkInput = () => {
   // Check all newsletter forms and enable/disable each button based on its own input
   $('[data-newsletter-form]').each(function() {
      var $form = $(this);
      var $input = $form.find('[data-newsletter-field]');
      var $button = $form.find('.newsletter-subscribe-button');
      
      if ($input.length && $button.length) {
         var inputVal = $input.val();
         if (!inputVal || inputVal.trim() === '') {
            $button.prop('disabled', true);
         } else {
            $button.prop('disabled', false);
         }
      }
   });
}


changeTextWhenSwitchRadioButton = () => {
   $(document).on('change', '.radio__inputs input[type=radio]', function() {
      var selectedValue = $(this).val();
      $('.jsc-selected-radio-value').text(selectedValue);
   })
}

// Collection Grid Hover Underline Effect
initCollectionHoverUnderline = () => {
  const selectors = {
    wrapper: '.collection-grid-item',
    item: '.collection-grid-item__title',
    text: '.collection-grid-item__title',
    sectionOuter: '.collection-grid-item',
    isActive: 'data-hover-active',
    underlineCurrent: 'data-underline-current',
    defaultItem: '[data-default-item]'
  };

  class CollectionHoverLine {
    constructor(el) {
      this.wrapper = el;
      this.itemList = this.wrapper.querySelectorAll(selectors.item);
      this.sectionOuter = this.wrapper;
      this.underlineCurrent = this.sectionOuter.getAttribute(selectors.underlineCurrent) === 'true';
      this.defaultItem = null;
      if (this.underlineCurrent) {
        this.defaultItem = this.wrapper.querySelector(selectors.defaultItem);
      }
      this.setDefault();
      document.fonts.ready.then(() => {
        this.init();
      });
    }

    init() {
      if (this.itemList.length) {
        this.listen();
        this.listenResize();
        this.textBottom = null;
        this.setHeight();
        if (this.defaultPositions) {
          if (this.defaultItem) {
            const startingLeft = this.defaultItem.offsetLeft || 0;
            this.sectionOuter.style.setProperty('--bar-left', `${startingLeft}px`);
          }
          this.reset();
        } else {
          const startingLeft = this.sectionOuter.querySelector(selectors.item).offsetLeft;
          this.sectionOuter.style.setProperty('--bar-left', `${startingLeft}px`);
          this.sectionOuter.style.setProperty('--bar-width', '0px');
        }
        this.sectionOuter.style.setProperty('--bar-opacity', '1');
      }
    }

    unload() {
      document.removeEventListener('theme:resize', this.reset);
      this.defaultPositions = null;
    }

    listenResize() {
      document.addEventListener('theme:resize', this.reset.bind(this));
    }

    setDefault() {
      if (this.defaultItem) {
        this.defaultPositions = {
          left: this.defaultItem.offsetLeft || null,
          width: this.defaultItem.clientWidth || null
        };
      }
    }

    setHeight() {
      const height = this.wrapper.clientHeight;
      const text = this.itemList[0];
      const textHeight = text.clientHeight;
      const textBottom = Math.floor(height / 2 - textHeight / 2) - 4;
      if (this.textBottom !== textBottom) {
        this.sectionOuter.style.setProperty('--bar-text', `${textHeight}px`);
        this.sectionOuter.style.setProperty('--bar-bottom', `${textBottom}px`);
        this.textBottom = textBottom;
      }
    }

    listen() {
      this.itemList.forEach((element) => {
        element.addEventListener('pointerenter', (evt) => {
          this.startBar(evt.target);
        });
      });
      this.wrapper.addEventListener('pointerleave', this.clearBar.bind(this));
    }

    startBar(item) {
      this.setHeight();
      let active = this.sectionOuter.getAttribute(selectors.isActive) !== 'false';
      let left = item.offsetLeft;
      let width = item.clientWidth;
      if (active) {
        this.render(width, left);
      } else {
        this.sectionOuter.setAttribute(selectors.isActive, true);
        this.render(0, left);
        setTimeout(() => {
          this.render(width, left);
        }, 10);
      }
    }

    render(width, left) {
      this.sectionOuter.style.setProperty('--bar-left', `${left}px`);
      this.sectionOuter.style.setProperty('--bar-width', `${width}px`);
    }

    reset() {
      this.setDefault();
      if (this.defaultPositions && this.defaultPositions.left && this.defaultPositions.width) {
        this.sectionOuter.style.setProperty('--bar-left', `${this.defaultPositions.left}px`);
        this.sectionOuter.style.setProperty('--bar-width', `${this.defaultPositions.width}px`);
      } else {
        this.sectionOuter.style.setProperty('--bar-width', '0px');
      }
    }

    clearBar() {
      this.sectionOuter.setAttribute(selectors.isActive, false);
      setTimeout(() => {
        let active = this.sectionOuter.getAttribute(selectors.isActive) !== 'false';
        if (!active) {
          this.reset();
        }
      }, 150);
    }
  }
  
  // Initialize the hover effect
  const collectionItems = document.querySelectorAll(selectors.wrapper);
  collectionItems.forEach((el) => {
    new CollectionHoverLine(el);
  });
}

calculateBoutiqueDescHeight = () => {
   var maxHeight = 0;
   var $elements = $('.jsc-boutiques-page .index__column.grid__item .rte');
   $elements.css('height', 'auto');

   $elements.each(function () {
      var height = $(this).outerHeight();
      if (height > maxHeight) {
         maxHeight = height;
      }
   });

   $elements.css('height', maxHeight + 'px');
}

// Accordion Hover Underline Effect
initAccordionHoverUnderline = () => {
  const selectors = {
    wrapper: '.collection-grid-item',
    item: '.collection-grid-item__title',
    text: '.collection-grid-item__title',
    sectionOuter: '.collection-grid-item',
    isActive: 'data-hover-active',
    underlineCurrent: 'data-underline-current',
    defaultItem: '[data-default-item]'
  };

  class CollectionHoverLine {
    constructor(el) {
      this.wrapper = el;
      this.itemList = this.wrapper.querySelectorAll(selectors.item);
      this.sectionOuter = this.wrapper;
      this.underlineCurrent = this.sectionOuter.getAttribute(selectors.underlineCurrent) === 'true';
      this.defaultItem = null;
      if (this.underlineCurrent) {
        this.defaultItem = this.wrapper.querySelector(selectors.defaultItem);
      }
      this.setDefault();
      document.fonts.ready.then(() => {
        this.init();
      });
    }

    init() {
      if (this.itemList.length) {
        this.listen();
        this.listenResize();
        this.textBottom = null;
        this.setHeight();
        if (this.defaultPositions) {
          if (this.defaultItem) {
            const startingLeft = this.defaultItem.offsetLeft || 0;
            this.sectionOuter.style.setProperty('--bar-left', `${startingLeft}px`);
          }
          this.reset();
        } else {
          const startingLeft = this.sectionOuter.querySelector(selectors.item).offsetLeft;
          this.sectionOuter.style.setProperty('--bar-left', `${startingLeft}px`);
          this.sectionOuter.style.setProperty('--bar-width', '0px');
        }
        this.sectionOuter.style.setProperty('--bar-opacity', '1');
      }
    }

    unload() {
      document.removeEventListener('theme:resize', this.reset);
      this.defaultPositions = null;
    }

    listenResize() {
      document.addEventListener('theme:resize', this.reset.bind(this));
    }

    setDefault() {
      if (this.defaultItem) {
        this.defaultPositions = {
          left: this.defaultItem.offsetLeft || null,
          width: this.defaultItem.clientWidth || null
        };
      }
    }

    setHeight() {
      const height = this.wrapper.clientHeight;
      const text = this.itemList[0];
      const textHeight = text.clientHeight;
      const textBottom = Math.floor(height / 2 - textHeight / 2) - 4;
      if (this.textBottom !== textBottom) {
        this.sectionOuter.style.setProperty('--bar-text', `${textHeight}px`);
        this.sectionOuter.style.setProperty('--bar-bottom', `${textBottom}px`);
        this.textBottom = textBottom;
      }
    }

    listen() {
      this.itemList.forEach((element) => {
        element.addEventListener('pointerenter', (evt) => {
          this.startBar(evt.target);
        });
      });
      this.wrapper.addEventListener('pointerleave', this.clearBar.bind(this));
    }

    startBar(item) {
      this.setHeight();
      let active = this.sectionOuter.getAttribute(selectors.isActive) !== 'false';
      let left = item.offsetLeft;
      let width = item.clientWidth;
      if (active) {
        this.render(width, left);
      } else {
        this.sectionOuter.setAttribute(selectors.isActive, true);
        this.render(0, left);
        setTimeout(() => {
          this.render(width, left);
        }, 10);
      }
    }

    render(width, left) {
      this.sectionOuter.style.setProperty('--bar-left', `${left}px`);
      this.sectionOuter.style.setProperty('--bar-width', `${width}px`);
    }

    reset() {
      this.setDefault();
      if (this.defaultPositions && this.defaultPositions.left && this.defaultPositions.width) {
        this.sectionOuter.style.setProperty('--bar-left', `${this.defaultPositions.left}px`);
        this.sectionOuter.style.setProperty('--bar-width', `${this.defaultPositions.width}px`);
      } else {
        this.sectionOuter.style.setProperty('--bar-width', '0px');
      }
    }

    clearBar() {
      this.sectionOuter.setAttribute(selectors.isActive, false);
      setTimeout(() => {
        let active = this.sectionOuter.getAttribute(selectors.isActive) !== 'false';
        if (!active) {
          this.reset();
        }
      }, 150);
    }
  }
  
  // Initialize the hover effect
  const collectionItems = document.querySelectorAll(selectors.wrapper);
  collectionItems.forEach((el) => {
    new CollectionHoverLine(el);
  });
}

initAccordionSmoothScroll = () => {
   var offset = 73;
   var selector = '.accordion-menu-link'
   $(document).off('click', selector); // prevent duplicate bindings

   $(document).on('click', selector, function (e) {
      e.preventDefault();

      const targetSelector = $(this).data('target');
      const $target = $(targetSelector);

      if ($target.length) {
         const scrollToPos = $target.offset().top - offset;

         $('html, body').animate({
         scrollTop: scrollToPos
         }, 100);
      }
   });
}

initListCollectionsGridCarousel = () => {
  const section = document.querySelector('.section-list-collections.jsc-list-list__collections');
  if (!section) return;

  const buttonSection = section.querySelector('.jsc-show-element-button-section');
  const gridElement = buttonSection ? buttonSection.querySelector('[data-grid-offset]') : null;

  updateGridAttribute = () => {
    if (window.innerWidth <= 480 && buttonSection && gridElement) {
      gridElement.setAttribute('data-carousel', '');
      gridElement.removeAttribute('data-grid-offset');
    } else if (buttonSection && gridElement) {
      gridElement.setAttribute('data-grid-offset', '');
      gridElement.removeAttribute('data-carousel');
    }
  }

  updateGridAttribute();

  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      updateGridAttribute();
    }, 250);
  });
}

initComplementarySectionHeight = () => {
   $(window).on('load resize', function () {
      var imageHeight = $('.product__block__upsell .product-clip__image').outerHeight();
      $('.product__block__upsell .product-clip__content').css({ height: 'auto', minHeight: imageHeight });
   });
}


initBundleAddOnSectionHeight = () => {
   $(window).on('load resize', function () {
      var imageHeight = $('.product__block__addon_bundle .product-clip__image').outerHeight();
      $('.product__block__addon_bundle .product-clip__content').height(imageHeight);
   });
}

// Start - Seal Subcription Fake variant

onchangevarsubscription = (evt) => {
   $(evt).parents('product-form').find('.subscription-variant').removeClass('active');
   $(evt).addClass('active');
   var datainterval = $(evt).attr('data-month-sub');
   var dataintervaltype = $(evt).attr('data-interval-type-sub');
   if (dataintervaltype == 'd') {
      var dataMonthSub = datainterval + ' day';
      var dataMonthSubintervalpro = datainterval + ' days';
      if (datainterval == '1') {
         dataMonthSubintervalpro = 'day';
      }
      var dataMonthSubProp = 'properties[_sealsub_interval_' + datainterval + '-day';
   }else if (dataintervaltype == 'y') {
      var dataMonthSub = datainterval + ' year';
      var dataMonthSubintervalpro = datainterval + ' years';
      if (datainterval == '1') {
         dataMonthSubintervalpro = 'year';
      }
      var dataMonthSubProp = 'properties[_sealsub_interval_' + datainterval + '-year';
   }else {
      var dataMonthSub = datainterval + ' month';
      var dataMonthSubintervalpro = datainterval + ' months';
      if (datainterval == '1') {
         dataMonthSubintervalpro = 'month';
      }
      var dataMonthSubProp = 'properties[_sealsub_interval_' + datainterval + '-month';
   }

   if ($('.prepaidsubs').length > 0) {
      var sellingPlanId;
      $(evt).parents('product-form').find('.sls-select').find('option').each(function() {
         if ($(this).text().includes(dataMonthSub)) {
            console.log('select',$(this).text());
            $(evt).parents('product-form').find('.sls-select').val($(this).val());
            sellingPlanId = $(this).val();
         }
      });
      $(evt).parents('product-form').find('input[name="selling_plan"]').val(sellingPlanId);
      $(evt).parents('product-form').find('.seal-money').text($('.subscription-variant.active .moneysubprice').text() + " / " + dataMonthSub);
   }else {
   // var dataMonthSub = $(evt).attr('data-month-sub') + ' month';
   // var dataMonthSubintervalpro = $(evt).attr('data-month-sub') + ' months';
   // var dataMonthSubProp = 'properties[_sealsub_interval_' + $(evt).attr('data-month-sub') + '-month';
   $(evt).parents('product-form').find('.sls-select').val(dataMonthSub);
   $(evt).parents('product-form').find('.sls-cart-attribute.sls-input-subscription-visible').val(dataMonthSubintervalpro);
   $(evt).parents('product-form').find('.sls-cart-attribute.sls-hidden.sls-input-interval').attr('name',dataMonthSubProp);
   // console.log(olddataMonthSubProp);
   // console.log(dataMonthSubProp);
   }
}


swapvariant = (evt) => {
   setTimeout(function () {
      $(evt).parents('.product__main__content').find(".pdp-variant-list").each(function () {
         if ($(evt).parents('.product__main__content').find(".singlesubs").length > 0) {
            var datavarid = $(this).val();
            if (datavarid == $(evt).parents('.product__main__content').find('.pdp-variant-selected').val()) {
               price = $(this).attr('data-price');
               $(evt).parents('.product__main__content').find('.btn--add-to-cart .cta__dot').next().remove();
               $(evt).parents('.product__main__content').find('.btn--add-to-cart .cta__dot').after('<span>' + price + ' / Month</span>');
            }
         }else if ($(evt).parents('.product__main__content').find(".mix-match-sub-wrap").length > 0) {
            var datavarid = $(this).val();
            if (datavarid == $(evt).parents('.product__main__content').find('.pdp-variant-selected').val()) {
               price = $(this).attr('data-price');
               $('.pickmatchatcsubs').find('span.money').text('$' + price);
               setTimeout(function () {
               var addonprice = 0;
               $('.select-popout:not(.optional-flavour):not(.duration-opt) .select-popout__toggle').each(function(index) {
                  $(this).parents('.select-popout').find('.select-popout__item--current a span:not(.price-flavour)').text();
                  if ($(this).parents('.select-popout').find('.select-popout__item--current a span:not(.price-flavour)').text().includes('$')
                     && $(this).parents('.select-popout').find('.select-popout__item--current a span.price-flavour').length < 1) {
                     var getpricetext = $(this).parents('.select-popout').find('.select-popout__item--current a span:not(.price-flavour)').text();
                     var priceArray = getpricetext.split('$');
                     var getprice = parseFloat(priceArray[priceArray.length - 1]);
                     addonprice = addonprice + getprice;
                  }
                  if ($(this).parents('.select-popout').find('.select-popout__item--current a span.price-flavour').length > 0) {
                     var getpricetext = $(this).parents('.select-popout').find('.select-popout__item--current a span.price-flavour').text();
                     var priceArray = getpricetext.split('$');
                     var getprice = parseFloat(priceArray[priceArray.length - 1]);
                     addonprice = addonprice + getprice;
                  }
               });
               var getpricetextattr = $('.pickmatchatcsubs').find('span.money').attr('data-pricemain');
               if (getpricetextattr) {
                  var getpricetext = getpricetextattr;
                  var priceArray = getpricetext.split('$');
                  var getprice = parseFloat(priceArray[priceArray.length - 1]);
                  if (isNaN(getprice)) {
                     priceArray = price.split('$');
                     getprice = parseFloat(priceArray[priceArray.length - 1]);
                  }
                  addonprice = addonprice + getprice;
                  addonprice = addonprice.toFixed(2);
               }else{
                  var getpricetext = $('.pickmatchatcsubs').find('span.money').text();
                  $('.pickmatchatcsubs').find('span.money').attr('data-pricemain',getpricetext);
                  var priceArray = getpricetext.split('$');
                  var getprice = parseFloat(priceArray[priceArray.length - 1]);
                  if (isNaN(getprice)) {
                     priceArray = price.split('$');
                     getprice = parseFloat(priceArray[priceArray.length - 1]);
                  }
                  addonprice = addonprice + getprice;
                  addonprice = addonprice.toFixed(2);
               }
               if ($('.pickmatchatcsubs').find('span.money').length > 0) {
                  $('.pickmatchatcsubs').find('span.money').text('$' + addonprice);
               }else{
                  $('.pickmatchatcsubs').find('span[data-button-price]').text('$' + addonprice);
               }
               }, 500);
            }
         }else{
            var datavarid = $(this).val();
            if (datavarid == $(evt).parents('.product__main__content').find('.pdp-variant-selected').val()) {
               price3 = $(this).attr('data-price-3');
               price6 = $(this).attr('data-price-6');
               $(evt).parents('.product__main__content').find('.subscription-variant[data-month-sub="3"] .moneysubprice').text(price3);
               $(evt).parents('.product__main__content').find('.subscription-variant[data-month-sub="6"] .moneysubprice').text(price6);
               $(evt).parents('.product__main__content').find('.subscription-variant.active').click();
            }
         }
      });
   }, 10);
}

// End - Seal Subcription Fake variant

// Start - Mix match subscription
onclickfirstvariant = () => {
   if ($('.sellingplanid').length > 0) {
      var addonprice = 0;
      $('.mix-match-sub-wrap popout-select').each(function() {
         //$(this).find('ul li').eq(1).find('a')[0].click();
         var getpricetext = $(this).find('ul li').eq(1).find('a span.price-flavour').text();
         var priceArray = getpricetext.split('$');
         var getprice = parseFloat(priceArray[priceArray.length - 1]);
         addonprice = addonprice + getprice;
      });
      var getpricetextattr = $('.pickmatchatcsubs').find('span.money').attr('data-pricemain');
      if (getpricetextattr) {
         var getpricetext = getpricetextattr;
         var priceArray = getpricetext.split('$');
         var getprice = parseFloat(priceArray[priceArray.length - 1]);
         addonprice = addonprice + getprice;
         addonprice = addonprice.toFixed(2);
      }else{
         var getpricetext = $('.pickmatchatcsubs').find('span.money').text();
         $('.pickmatchatcsubs').find('span.money').attr('data-pricemain',getpricetext);
         var priceArray = getpricetext.split('$');
         var getprice = parseFloat(priceArray[priceArray.length - 1]);
         var getpricemain;
         $('.product__main__content').find(".pdp-variant-list").each(function () {
            var datavarid = $(this).val();
            if (datavarid == $('.product__main__content').find('.pdp-variant-selected').val()) {
               getpricemain = $(this).attr('data-price');
            }
         });
         if (isNaN(getprice)) {
            priceArray = getpricemain.split('$');
            getprice = parseFloat(priceArray[priceArray.length - 1]);
         }
         addonprice = addonprice + getprice;
         addonprice = addonprice.toFixed(2);
      }
      if ($('.pickmatchatcsubs').find('span.money').length > 0) {
         $('.pickmatchatcsubs').find('span.money').text('$' + addonprice + " / month");
      }else{
         $('.pickmatchatcsubs').find('span[data-button-price]').text('$' + addonprice + " / month");
         if (firstload) {
            $('.pickmatchatcsubs').find('span[data-button-price]').addClass('data-button-price').removeAttr('data-button-price').text('$' + addonprice + " / month");
            setTimeout(() => {               
               $('.pickmatchatcsubs').find('span.data-button-price').removeClass('data-button-price').attr('data-button-price','');
            }, 3000);
            firstload = false;
         }
      }
   }
}
swapflavour = (evt) => {
   setTimeout(function () {
      if ($(evt).attr('data-value-list') == 'default') {
         $(evt).parents('.select-popout').find(".select-popout__toggle").removeClass('active-flavour');
      }else{
         $(evt).parents('.select-popout').find(".select-popout__toggle").addClass('active-flavour');
         $(evt).parents('.select-popout').find(".select-popout__toggle")
         var selectedIndex;
         var selectedOption;
         $('.select-popout:not(.optional-flavour):not(.duration-opt) .select-popout__toggle').each(function(index) {
            if (this == $(evt).parents('.select-popout').find(".select-popout__toggle")[0]) {
               console.log('Index using each parameter:', index);
               selectedIndex = index;
               selectedOption = $(this).parents('.select-popout').find('.select-popout__item--current .select-popout__option').attr('data-value-list');
               return false;
            }
         });
         $('.select-popout.optional-flavour .select-popout__toggle').each(function(index) {
            if (selectedIndex == index) {
               if ($(this).hasClass('active-flavour')) {
                  $(this).siblings('ul').find('.select-popout__item--current').hasClass('free_flavour');
                  if ($(evt).hasClass('free_flavour') == $(this).siblings('ul').find('.select-popout__item--current').hasClass('free_flavour')) {
                     console.log('dont default');
                  }else if ($(evt).hasClass('premium_flavour') == $(this).siblings('ul').find('.select-popout__item--current').hasClass('premium_flavour')) {
                     console.log('dont default');
                  }else{
                     var $svg = $(this).find('svg').clone();
                     var newText = 'Select your flavour';
                     $(this).text(newText).append($svg);
                     $(this).siblings('input').val('Select your flavour');
                     $(this).siblings('ul').find('[data-value-list="default"]').click();
                     $(this).siblings('ul').find('[data-value-list="default"]').parent().addClass('select-popout__item--current').click();
                  }
               }
               $(this).siblings('ul').find('.select-popout__option').each(function(index) {
                  $(this).parent().show();
               });
               if ($(evt).hasClass('free_flavour')) {
                  $(this).parents('.select-popout').find('.premium_flavour').removeClass('select-popout__item--current');
                  $(this).parents('.select-popout').find('.premium_flavour').hide();
                  $(this).parents('.select-popout').find('.free_flavour').show();
               }else{
                  $(this).parents('.select-popout').find('.premium_flavour').show();
                  $(this).parents('.select-popout').find('.free_flavour').removeClass('select-popout__item--current');
                  $(this).parents('.select-popout').find('.free_flavour').hide();
               }
               $(this).siblings('ul').find('.select-popout__option').each(function(index) {
                  var varflavour = $(this).attr('data-value-list');
                  if (varflavour == selectedOption) {
                     $(this).parent().hide();
                  }
               });
               return false;
            }
         });
      }
      var addonprice = 0;
      $('.select-popout:not(.optional-flavour):not(.duration-opt) .select-popout__toggle').each(function(index) {
         $(this).parents('.select-popout').find('.select-popout__item--current a span:not(.price-flavour)').text();
         if ($(this).parents('.select-popout').find('.select-popout__item--current a span:not(.price-flavour)').text().includes('$')
            && $(this).parents('.select-popout').find('.select-popout__item--current a span.price-flavour').length < 1) {
            var getpricetext = $(this).parents('.select-popout').find('.select-popout__item--current a span:not(.price-flavour)').text();
            var priceArray = getpricetext.split('$');
            var getprice = parseFloat(priceArray[priceArray.length - 1]);
            addonprice = addonprice + getprice;
         }
         if ($(this).parents('.select-popout').find('.select-popout__item--current a span.price-flavour').length > 0) {
            var getpricetext = $(this).parents('.select-popout').find('.select-popout__item--current a span.price-flavour').text();
            var priceArray = getpricetext.split('$');
            var getprice = parseFloat(priceArray[priceArray.length - 1]);
            addonprice = addonprice + getprice;
         }
      });
      var getpricetextattr = $('.pickmatchatcsubs').find('span.money').attr('data-pricemain');
      if (getpricetextattr) {
         var getpricetext = getpricetextattr;
         var priceArray = getpricetext.split('$');
         var getprice = parseFloat(priceArray[priceArray.length - 1]);
         addonprice = addonprice + getprice;
         addonprice = addonprice.toFixed(2);
      }else{
         var getpricetext = $('.pickmatchatcsubs').find('span.money').text();
         $('.pickmatchatcsubs').find('span.money').attr('data-pricemain',getpricetext);
         var priceArray = getpricetext.split('$');
         var getprice = parseFloat(priceArray[priceArray.length - 1]);
         var getpricemain;
         $(evt).parents('.product__main__content').find(".pdp-variant-list").each(function () {
            var datavarid = $(this).val();
            if (datavarid == $(evt).parents('.product__main__content').find('.pdp-variant-selected').val()) {
               getpricemain = $(this).attr('data-price');
            }
         });
         if (isNaN(getprice)) {
            priceArray = getpricemain.split('$');
            getprice = parseFloat(priceArray[priceArray.length - 1]);
         }
         addonprice = addonprice + getprice;
         addonprice = addonprice.toFixed(2);
      }

      if ($('.sellingplanid').length > 0) {
         var getpricetext = $('.sellingplanid').attr('data-price');
         var priceArray = getpricetext.split('$');
         var getprice = parseFloat(priceArray[priceArray.length - 1]);
         var addonpricemain = getprice;
         addonpricemain = addonpricemain.toFixed(2);
         console.log(addonpricemain,'addonpricemain');
         if (addonpricemain > addonprice) {
            addonprice = addonpricemain;
         }
      }
      
      if ($('.pickmatchatcsubs').find('span.money').length > 0) {
         if ($('.sellingplanid').length > 0) {
            $('.pickmatchatcsubs').find('span.money').text('$' + addonprice + " / month");
         }else{
            $('.pickmatchatcsubs').find('span.money').text('$' + addonprice);
         }
      }else{
         if ($('.sellingplanid').length > 0) {
            $('.pickmatchatcsubs').find('span[data-button-price]').text('$' + addonprice + " / month");
         }else{
            $('.pickmatchatcsubs').find('span[data-button-price]').text('$' + addonprice);
         }  
         if (firstload) {
            if ($('.sellingplanid').length > 0) {
               $('.pickmatchatcsubs').find('span[data-button-price]').addClass('data-button-price').removeAttr('data-button-price').text('$' + addonprice + " / month");
            }else{
               $('.pickmatchatcsubs').find('span[data-button-price]').addClass('data-button-price').removeAttr('data-button-price').text('$' + addonprice);
            }
            setTimeout(() => {               
               $('.pickmatchatcsubs').find('span.data-button-price').removeClass('data-button-price').attr('data-button-price','');
            }, 3000);
            firstload = false;
         }
      }
      if ($('.select-popout:not(.optional-flavour):not(.duration-opt) .select-popout__toggle.active-flavour').length >= 3) {
         if ($('.select-popout.duration-opt-int.duration-opt').length > 0) {
            if ($('.select-popout.duration-opt-int.duration-opt .select-popout__toggle.active-flavour').length > 0) {
               $('.pickmatchatcsubs').removeClass('disabled');
               $('.pickmatchatcsubs').removeAttr('disabled');
            }else{
               $('.pickmatchatcsubs').addClass('disabled');
               $('.pickmatchatcsubs').attr('disabled');
            }
         }else{
            $('.pickmatchatcsubs').removeClass('disabled');
            $('.pickmatchatcsubs').removeAttr('disabled');
         }
      }else{
         $('.pickmatchatcsubs').addClass('disabled');
         $('.pickmatchatcsubs').attr('disabled');
      }
   }, 10);
}
swapduration = (evt) => {
   setTimeout(function () {
      // Get the duration from data attribute
      var duration = $(evt).attr('data-value-list');

      if ($(evt).attr('data-value-list') == 'default') {
         $(evt).parents('.select-popout').find(".select-popout__toggle").removeClass('active-flavour');
      } else {
         $(evt).parents('.select-popout').find(".select-popout__toggle").addClass('active-flavour');
      }

      var datapricemain = null;
      $('input[type="hidden"]').each(function() {
         var className = $(this).attr('class');
         if (className && className.includes('current_var' + duration + 'm')) {
            datapricemain = $(this).attr('data-price');
            return false; // break the loop
         }
      });
      if ($('.current_var3mlist').length > 0) {
         $(evt).parents('.product__main__content').find('.pdp-variant-selected').val()
         $('input[type="hidden"]').each(function() {
            var className = $(this).attr('class');
            var datavarid = $(this).val();
            if (className && className.includes('current_var' + duration + 'mlist') && datavarid == $(evt).parents('.product__main__content').find('.pdp-variant-selected').val()) {
               datapricemain = $(this).attr('data-price');
               console.log(datapricemain);
               return false; // break the loop
            }
         });
      }
      $('.pickmatchatcsubs').find('span.money').text(datapricemain);

      var dataid = null;
      var dataprice = null;
      $('input[type="hidden"]').each(function() {
         var className = $(this).attr('class');
         if (className && className.includes('premium' + duration + 'm')) {
            dataid = $(this).val();
            dataprice = $(this).attr('data-price');
            return false; // break the loop
         }
     });
      $('.select-popout:not(.optional-flavour):not(.duration-opt) .select-popout__item.premium_flavour').each(function(index) {
         $(this).find('a').attr('data-id',dataid);
         var datalabel = $(this).find('a').attr('data-value-list') + ' + ' + dataprice;
         $(this).find('a').attr('data-value',datalabel);
         $(this).find('a span').text(datalabel);
      });

      $('.select-popout:not(.optional-flavour):not(.duration-opt) .select-popout__toggle.active-flavour').each(function(index) {
         var $svg = $(this).find('svg').clone();
         var newText = $(this).siblings('ul').find('.select-popout__item--current a span').text();
         $(this).text(newText).append($svg);
      });

      // Function to find option by duration in the label text
      function findOptionByDuration(duration) {
         var foundOption = null;
         var selectedValue = null; // ✅ Properly declared
         
         $('select[name="subs_interval"] option').each(function() {
            var optionText = $(this).text().toLowerCase();
            if (optionText.includes(duration + ' month') || 
                  optionText.includes('prepay for ' + duration)) {
                  foundOption = $(this);
                  selectedValue = $(this).val();
                  
                  // ✅ Fixed selector with proper class dot
                  var sellingPlanInput = $(evt).parents('.product__main__content').find('input[name="selling_plan"]');
                  
                  // ✅ Added safety check
                  if (sellingPlanInput.length > 0) {
                     sellingPlanInput.val(selectedValue);
                     console.log('Updated selling_plan input with value:', selectedValue);
                  } else {
                     console.log('selling_plan input not found');
                  }
                  
                  return false; // break the loop
            }
         });
         return foundOption;
      }
        
      // Find the option that matches this duration
      var matchingOption = findOptionByDuration(duration);
      console.log('Matching Option:', matchingOption, 'Duration:', duration);
      
      if (matchingOption && matchingOption.val()) {
          $('select[name="subs_interval"]').val(matchingOption.val()).trigger('change');
          console.log('Selected value:', matchingOption.val(), 'Option text:', matchingOption.text());
      } else {
          console.log('No matching option found for duration:', duration);
      }

      var addonprice = 0;
      $('.select-popout:not(.optional-flavour):not(.duration-opt) .select-popout__toggle').each(function(index) {
         $(this).parents('.select-popout').find('.select-popout__item--current a span:not(.price-flavour)').text();
         if ($(this).parents('.select-popout').find('.select-popout__item--current a span:not(.price-flavour)').text().includes('$')
            && $(this).parents('.select-popout').find('.select-popout__item--current a span.price-flavour').length < 1) {
            var getpricetext = $(this).parents('.select-popout').find('.select-popout__item--current a span:not(.price-flavour)').text();
            var priceArray = getpricetext.split('$');
            var getprice = parseFloat(priceArray[priceArray.length - 1]);
            addonprice = addonprice + getprice;
         }
         if ($(this).parents('.select-popout').find('.select-popout__item--current a span.price-flavour').length > 0) {
            var getpricetext = $(this).parents('.select-popout').find('.select-popout__item--current a span.price-flavour').text();
            var priceArray = getpricetext.split('$');
            var getprice = parseFloat(priceArray[priceArray.length - 1]);
            addonprice = addonprice + getprice;
         }
      });
      if (addonprice > 0) {
         var getpricetext = $('.pickmatchatcsubs').find('span.money').text();
         var priceArray = getpricetext.split('$');
         var getprice = parseFloat(priceArray[priceArray.length - 1]);
         addonprice = addonprice + getprice;
         addonprice = addonprice.toFixed(2);
         $('.pickmatchatcsubs').find('span.money').text('$' + addonprice);
      }
      
      // Your existing validation logic
      if ($('.select-popout:not(.optional-flavour):not(.duration-opt) .select-popout__toggle.active-flavour').length >= 3 && 
         $('.select-popout.duration-opt-int.duration-opt .select-popout__toggle.active-flavour').length > 0) {
         $('.pickmatchatcsubs').removeClass('disabled');
         $('.pickmatchatcsubs').removeAttr('disabled');
      } else {
         $('.pickmatchatcsubs').addClass('disabled');
         $('.pickmatchatcsubs').attr('disabled');
      }
   }, 10);
}
addPickmatchToCart = (evt) => {
   if ($(evt).hasClass('disabled')) {
      console.log('atc disabled');
      return
   }else{
      const _thisatc = $(evt);
      const _productPDPcontent = _thisatc.closest('.product__main__content');
      const _addOnsVidEl = _productPDPcontent.find('.select-popout__toggle.active-flavour:not(.duration-opt)');
      const _mainID = _productPDPcontent.find('.pdp-variant-selected').val();
      const _productForm = _thisatc.closest('form[action="/cart/add"]');
      const formData = _productForm.serializeArray(); // serialize form data and convert it to JSON
      const formJson = {};
      var sealSubsType = '';
      formData.forEach(function(field) {
         var key = field.name;
         if (key.startsWith("subs_type")) {
               sealSubsType = key
         }
         formJson[key] = field.value;
      });
      console.log('formJson: ', formJson);
      var itemsArray = [];
      var addOnsFlavour = '';
      var addOnsId = '';
      const currentTime = Date.now();

      _addOnsVidEl.each(function() {
         const selectedVid = $(this).parent().find('a[aria-current="true"]').attr('data-id');
         const selectedflavour = $(this).parent().find('a[aria-current="true"]').attr('data-value-list');
         console.log($(this).parent().find('a[aria-current="true"]'));

         addOnsFlavour != '' ? addOnsFlavour = addOnsFlavour + ',' + selectedflavour : addOnsFlavour = addOnsFlavour + selectedflavour

         if (selectedVid) {
             addOnsId != '' ? addOnsId = addOnsId + '_' + selectedVid : addOnsId = addOnsId + selectedVid

             var _addOnObjs = {
                 id: selectedVid,
                 quantity: formJson.quantity,
                 properties: {
                     "_BindID": "blank",
                     "_Add_ons": true
                 }
             }
             if (formJson.selling_plan && formJson.selling_plan != ''){
                  console.log('sealSubsType',sealSubsType);
                  console.log('formJson.selling_plan',formJson.selling_plan);
                  console.log('formJson.subs_interval',formJson.subs_interval);
                 if (sealSubsType != '') {
                     _addOnObjs['selling_plan'] = formJson.selling_plan;
                     _addOnObjs[sealSubsType] = formJson[sealSubsType];
                     _addOnObjs['subs_interval'] = formJson.subs_interval;
                 } else {
                     _addOnObjs['selling_plan'] = formJson.selling_plan;
                 }
             }
             if ($('.sellingplanid').length > 0 && $('.sellingplanid').val() != '') {
               _addOnObjs['selling_plan'] = $('.sellingplanid').val();
             }
             itemsArray.push(_addOnObjs);
         }
      });

      var _mainObjs = {
         id: _mainID,
         quantity: formJson.quantity,
         properties: {
             "_BindID": `${formJson.id}-${addOnsId}-${currentTime}`,
             "Flavour": `${addOnsFlavour}`,
             "_main": true
         }
      }
      if (formJson.selling_plan && formJson.selling_plan != ''){
         console.log('sealSubsType',sealSubsType);
         console.log('formJson.selling_plan',formJson.selling_plan);
         console.log('formJson.subs_interval',formJson.subs_interval);

         if (sealSubsType != '') {
               _mainObjs['selling_plan'] = formJson.selling_plan;
               _mainObjs[sealSubsType] = formJson[sealSubsType];
               _mainObjs['subs_interval'] = formJson.subs_interval;
         } else {
               _mainObjs['selling_plan'] = formJson.selling_plan;
         }
     }
     itemsArray.push(_mainObjs);
     
      if (itemsArray.length > 0) {
         $.each(itemsArray, function(index, item) {
            item.properties['_BindID'] = `${formJson.id}-${addOnsId}-${currentTime}`;
         });
         console.log('itemsArray: ', itemsArray)
         CartJS.addItems(itemsArray, {
            "success": function(data, textStatus, jqXHR) {
               console.log('Success: ', data);
            },
            "error": function(jqXHR, textStatus, errorThrown) {
               console.log('Error: ' + errorThrown + '!');
            }
         });
      }

   }
}
// Read More Scroll Function
readmoreTab = (evt) => {
   const $target = $('#readmore');
   if (!$target.length) {
      return;
   }

   const offset = 100;
   const scrollToPos = $target.offset().top - offset;
   
   $('html, body').animate({
      scrollTop: scrollToPos
   }, 500, function() {
   });
   setTimeout(() => {
      $target.trigger('click');
   }, 501);
}
// End - Mix match subscription

// Start - Addon Products (Products that can be added together with main product)
// Handle checkbox change - show/hide quantity selector
handleAddonCheckboxChange = function(checkbox) {
   var $checkbox = $(checkbox);
   var productId = parseInt($checkbox.attr('data-product-id'), 10);
   var variantId = parseInt($checkbox.attr('data-variant-id'), 10);
   var productTitle = $checkbox.attr('data-product-title');
   var productPrice = parseInt($checkbox.attr('data-product-price'), 10);
   var isChecked = $checkbox.is(':checked');

   // Find the quantity wrapper for this product
   var $quantityWrapper = $checkbox.closest('.product-clip').find('.jsc-addon-quantity-wrapper');
   
   if (isChecked) {
      // Show quantity selector
      $quantityWrapper.slideDown(200, function() {
         // Small delay to ensure DOM is ready
         setTimeout(function() {
            initAddonQuantitySelector($quantityWrapper);
         }, 50);
      });
      
      // Add product to selected list with quantity 1
      var productExists = -1;
      for (var i = 0; i < selectedAddonProducts.length; i++) {
         if (selectedAddonProducts[i].productId === productId && selectedAddonProducts[i].variantId === variantId) {
            productExists = i;
            break;
         }
      }
      if (productExists === -1) {
         selectedAddonProducts.push({
            productId: productId,
            variantId: variantId,
            productTitle: productTitle,
            productPrice: productPrice,
            quantity: 1
         });
      }
   } else {
      // Hide quantity selector
      $quantityWrapper.slideUp(200);
      
      // Remove product from selected list
      var filteredProducts = [];
      for (var i = 0; i < selectedAddonProducts.length; i++) {
         if (!(selectedAddonProducts[i].productId === productId && selectedAddonProducts[i].variantId === variantId)) {
            filteredProducts.push(selectedAddonProducts[i]);
         }
      }
      selectedAddonProducts = filteredProducts;
   }
   console.log("selectedAddonProducts", selectedAddonProducts);
}

// Handle quantity change for individual addon product
handleAddonQuantityChange = function(input) {
   var $input = $(input);
   var productId = parseInt($input.attr('data-product-id'), 10);
   var variantId = parseInt($input.attr('data-variant-id'), 10);
   var quantity = parseInt($input.val(), 10);
   
   if (isNaN(quantity) || quantity < 1) {
      quantity = 1;
      $input.val(1);
   }
   
   // Update quantity in selected products array
   for (var i = 0; i < selectedAddonProducts.length; i++) {
      if (selectedAddonProducts[i].productId === productId && selectedAddonProducts[i].variantId === variantId) {
         selectedAddonProducts[i].quantity = quantity;
         break;
      }
   }
   console.log("Updated addon quantity:", productId, variantId, quantity);
}

syncAddonStateFromCheckboxes = function() {
   // Rebuild selectedAddonProducts array from checked checkboxes and their quantities
   selectedAddonProducts = [];
   
   $('.jsc-addon-checkbox:checked').each(function() {
      var $checkbox = $(this);
      var productId = parseInt($checkbox.attr('data-product-id'), 10);
      var variantId = parseInt($checkbox.attr('data-variant-id'), 10);
      var productTitle = $checkbox.attr('data-product-title');
      var productPrice = parseInt($checkbox.attr('data-product-price'), 10);
      
      // Get quantity from the quantity input for this product
      // Find the input using data attributes
      var $quantityInput = $checkbox.closest('.product-clip').find('[data-addon-quantity-input][data-product-id="' + productId + '"][data-variant-id="' + variantId + '"]');
      var quantity = 1;
      if ($quantityInput.length > 0) {
         quantity = parseInt($quantityInput.val(), 10);
         if (isNaN(quantity) || quantity < 1) {
            quantity = 1;
         }
      }
      
      selectedAddonProducts.push({
         productId: productId,
         variantId: variantId,
         productTitle: productTitle,
         productPrice: productPrice,
         quantity: quantity
      });
   });
   
   console.log("Synced addon products from checkboxes:", selectedAddonProducts);
}

initAddonToggle = function() {
   // Sync state from checkboxes first to ensure consistency
   syncAddonStateFromCheckboxes();
   
   // Initialize quantity selectors for checked checkboxes on page load
   $('.jsc-addon-checkbox:checked').each(function() {
      var $checkbox = $(this);
      var $quantityWrapper = $checkbox.closest('.product-clip').find('.jsc-addon-quantity-wrapper');
      if ($quantityWrapper.length) {
         $quantityWrapper.show();
         setTimeout(function() {
            initAddonQuantitySelector($quantityWrapper);
         }, 100);
      }
   });
   
   // Initialize quantity selectors when checkbox is checked
   $(document).on('change', '.jsc-addon-checkbox', function() {
      var $checkbox = $(this);
      var $quantityWrapper = $checkbox.closest('.product-clip').find('.jsc-addon-quantity-wrapper');
      
      if ($checkbox.is(':checked') && $quantityWrapper.length) {
         $quantityWrapper.slideDown(200, function() {
            setTimeout(function() {
               initAddonQuantitySelector($quantityWrapper);
            }, 50);
         });
      }
   });
}

// Helper function to get current cart quantity for a variant
getCartQuantityForVariant = function(variantId) {
   var cartQuantity = 0;
   try {
      // Try to get cart from CartJS if available
      if (typeof CartJS !== 'undefined' && CartJS.cart && CartJS.cart.items) {
         for (var i = 0; i < CartJS.cart.items.length; i++) {
            var item = CartJS.cart.items[i];
            // Check if this item matches the variant
            if (item.variant_id === variantId) {
               // Only count regular cart items (not addon items with special properties)
               // For addon products, we want to check what's already in cart
               if (!item.properties || !item.properties['_addon']) {
                  cartQuantity += item.quantity || 0;
               }
            }
         }
      }
   } catch (e) {
      console.log('Error getting cart quantity:', e);
   }
   return cartQuantity;
}

// Update max values for all addon quantity inputs based on current cart
updateAddonQuantityMaxValues = function() {
   $('[data-addon-quantity-input]').each(function() {
      var $input = $(this);
      var variantId = parseInt($input.attr('data-variant-id'), 10);
      var variantInventory = parseInt($input.attr('data-variant-inventory'), 10);
      
      if (variantId && variantInventory !== null && !isNaN(variantInventory)) {
         var cartQuantity = getCartQuantityForVariant(variantId);
         var maxAvailable = Math.max(1, variantInventory - cartQuantity);
         $input.attr('max', maxAvailable);
         
         // If current value exceeds new max, adjust it
         var currentValue = parseInt($input.val(), 10);
         if (currentValue > maxAvailable) {
            $input.val(maxAvailable);
            $input.trigger('change');
         }
      }
   });
}

// Initialize quantity selector for addon products - simplified and prevents duplicates
initAddonQuantitySelector = function($wrapper) {
   if (!$wrapper || $wrapper.length === 0) return;
   
   var quantityWrapperElement = $wrapper.find('[data-quantity-selector]')[0];
   if (!quantityWrapperElement) return;
   
   // Check if already initialized - use attribute for more reliable check
   if (quantityWrapperElement.hasAttribute('data-addon-initialized')) {
      return;
   }
   
   var increase = quantityWrapperElement.querySelector('[data-increase-quantity]');
   var decrease = quantityWrapperElement.querySelector('[data-decrease-quantity]');
   var input = quantityWrapperElement.querySelector('[data-quantity-input]');
   
   if (!increase || !decrease || !input) {
      return;
   }
   
   // Ensure input value is set and visible first
   var currentValue = parseInt(input.value, 10);
   if (isNaN(currentValue) || currentValue < 1) {
      input.value = 1;
      input.setAttribute('value', '1');
   }
   
   var min = parseInt(input.getAttribute('min'), 10) || 1;
   
   // Get variant ID and inventory to set max value based on cart quantity
   var variantId = parseInt(input.getAttribute('data-variant-id'), 10);
   var variantInventory = parseInt(input.getAttribute('data-variant-inventory'), 10);
   
   // Update max attribute based on available inventory minus cart quantity
   if (variantId && variantInventory !== null && !isNaN(variantInventory)) {
      var cartQuantity = getCartQuantityForVariant(variantId);
      var maxAvailable = Math.max(1, variantInventory - cartQuantity);
      input.setAttribute('max', maxAvailable);
   }
   
   // Remove any existing event listeners by cloning and replacing
   // This prevents duplicate listeners that cause double increment
   var increaseClone = increase.cloneNode(true);
   var decreaseClone = decrease.cloneNode(true);
   increase.parentNode.replaceChild(increaseClone, increase);
   decrease.parentNode.replaceChild(decreaseClone, decrease);
   
   // Get fresh references
   increase = quantityWrapperElement.querySelector('[data-increase-quantity]');
   decrease = quantityWrapperElement.querySelector('[data-decrease-quantity]');
   
   // Add single click handler - increment by 1 with stock check (including cart quantity)
   increase.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation(); // Prevent other handlers
      
      var currentValue = parseInt(input.value, 10);
      currentValue = isNaN(currentValue) ? 1 : currentValue;
      var newValue = currentValue + 1;
      
      // Check inventory/stock including what's already in cart
      var variantInventory = parseInt(input.getAttribute('data-variant-inventory'), 10);
      var variantAvailable = input.getAttribute('data-variant-available') === 'true';
      var variantId = parseInt(input.getAttribute('data-variant-id'), 10);
      
      // If inventory tracking is enabled and we have inventory data
      if (variantInventory !== null && !isNaN(variantInventory) && variantId) {
         // Get current cart quantity for this variant
         var cartQuantity = getCartQuantityForVariant(variantId);
         var totalQuantity = cartQuantity + newValue;
         var maxAvailable = variantInventory - cartQuantity;
         
         if (newValue > maxAvailable) {
            // Show stock message using bundle prompt styling
            if (cartQuantity > 0) {
               showBundlePrompt(`This product has only ${variantInventory} remaining in stock. You have ${cartQuantity} in your cart. You can add up to ${maxAvailable} more.`);
            } else {
               showBundlePrompt(`This product has only ${variantInventory} remaining. Kindly adjust your quantity`);
            }
            return; // Don't increment
         }
      } else if (!variantAvailable) {
         // Product is not available
         showBundlePrompt('This product is currently out of stock.');
         return;
      }
      
      input.value = newValue;
      input.dispatchEvent(new Event('change', { bubbles: true }));
   }, true); // Use capture phase to run first
   
   // Add single click handler - decrement by 1
   decrease.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation(); // Prevent other handlers
      var v = parseInt(input.value, 10);
      v = isNaN(v) ? 1 : v;
      v = v - 1;
      v = Math.max(min, v);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
   }, true); // Use capture phase to run first
   
   // Listen for quantity changes to update our addon products array and validate stock (including cart quantity)
   input.addEventListener('change', function() {
      var productId = parseInt(this.getAttribute('data-product-id'), 10);
      var variantId = parseInt(this.getAttribute('data-variant-id'), 10);
      var quantity = parseInt(this.value, 10);
      
      if (isNaN(quantity) || quantity < 1) {
         quantity = 1;
         this.value = 1;
      }
      
      // Check inventory/stock including what's already in cart
      var variantInventory = parseInt(this.getAttribute('data-variant-inventory'), 10);
      var variantAvailable = this.getAttribute('data-variant-available') === 'true';
      
      // If inventory tracking is enabled and we have inventory data
      if (variantInventory !== null && !isNaN(variantInventory) && variantId) {
         // Get current cart quantity for this variant
         var cartQuantity = getCartQuantityForVariant(variantId);
         var totalQuantity = cartQuantity + quantity;
         var maxAvailable = variantInventory - cartQuantity;
         
         if (quantity > maxAvailable) {
            // Reset to max available
            quantity = Math.max(1, maxAvailable);
            this.value = quantity;
            if (cartQuantity > 0) {
               showBundlePrompt(`This product has only ${variantInventory} remaining in stock. You have ${cartQuantity} in your cart. You can add up to ${maxAvailable} more.`);
            } else {
               showBundlePrompt(`This product has only ${variantInventory} remaining. Kindly adjust your quantity`);
            }
         }
      } else if (!variantAvailable) {
         // Product is not available
         quantity = 0;
         this.value = 0;
         showBundlePrompt('This product is currently out of stock.');
      }
      
      // Update max attribute if inventory is tracked
      if (variantInventory !== null && !isNaN(variantInventory) && variantId) {
         var cartQty = getCartQuantityForVariant(variantId);
         var maxAvail = Math.max(1, variantInventory - cartQty);
         this.setAttribute('max', maxAvail);
      }
      
      // Update quantity in selected products array
      for (var i = 0; i < selectedAddonProducts.length; i++) {
         if (selectedAddonProducts[i].productId === productId && selectedAddonProducts[i].variantId === variantId) {
            selectedAddonProducts[i].quantity = quantity;
            console.log("Updated addon quantity from input:", productId, variantId, quantity);
            break;
         }
      }
   });
   
   // Mark as initialized to prevent duplicates
   quantityWrapperElement.setAttribute('data-addon-initialized', 'true');
}

addProductWithAddonsToCart = function(button) {
   var $button = $(button);
   // Try multiple selectors to find the form
   var $productForm = $button.closest('form[data-product-form]');
   if ($productForm.length === 0) {
      $productForm = $button.closest('form[action="/cart/add"]');
   }
   if ($productForm.length === 0) {
      $productForm = $button.closest('form');
   }
   
   // Get variant ID - try multiple selectors
   var mainVariantId = null;
   var $variantSelect = $productForm.find('.pdp-variant-selected');
   if ($variantSelect.length > 0) {
      mainVariantId = parseInt($variantSelect.val(), 10);
   } else {
      // Fallback: try to find variant selector in the document
      $variantSelect = $('.pdp-variant-selected');
      if ($variantSelect.length > 0) {
         mainVariantId = parseInt($variantSelect.val(), 10);
      }
   }

   if (!mainVariantId || isNaN(mainVariantId)) {
      console.log('Error: Could not find main variant ID');
      return;
   }

   // Get main product quantity
   var $mainQuantityInput = $('.qty-atc-container [data-quantity-input]');
   var mainQuantity = 1;
   if ($mainQuantityInput.length > 0) {
      mainQuantity = parseInt($mainQuantityInput.val(), 10);
      if (isNaN(mainQuantity) || mainQuantity < 1) {
         mainQuantity = 1;
      }
   }

   // Disable button and show loading state
   $button.attr('disabled', true).addClass('loading');

   // Prepare all items to add (main product + addon products, no bundle properties)
   var allItems = [];
   
   // Validate main variant ID
   if (!mainVariantId || isNaN(mainVariantId)) {
      console.error('Invalid main variant ID:', mainVariantId);
      $button.attr('disabled', false).removeClass('loading');
      return;
   }
   
   // Add main product (no bundle properties)
   var itemMain = {
      "id": mainVariantId,
      "quantity": mainQuantity
   };
   // Only add properties if it's not empty (CartJS might not like empty properties)
   allItems.push(itemMain);

   // Add addon products (regular products added together with main product)
   // Skip addons that exceed stock limits, but still add valid ones
   var skippedProducts = [];
   if (selectedAddonProducts.length > 0) {
      // Sync quantities from inputs before adding
      syncAddonStateFromCheckboxes();
      
      for (var i = 0; i < selectedAddonProducts.length; i++) {
         var product = selectedAddonProducts[i];
         var variantId = parseInt(product.variantId, 10);
         var quantity = parseInt(product.quantity, 10);
         
         // Validate variant ID and quantity
         if (!variantId || isNaN(variantId)) {
            console.error('Invalid addon variant ID:', product.variantId);
            continue;
         }
         if (!quantity || isNaN(quantity) || quantity < 1) {
            console.error('Invalid addon quantity:', product.quantity);
            continue;
         }
         
         var shouldSkip = false;
         var skipReason = '';
         
         // Check stock/inventory before adding (including cart quantity)
         var $addonInput = $('[data-addon-quantity-input][data-variant-id="' + variantId + '"]');
         if ($addonInput.length > 0) {
            var variantInventory = parseInt($addonInput.attr('data-variant-inventory'), 10);
            var variantAvailable = $addonInput.attr('data-variant-available') === 'true';
            
            // Check if product is available
            if (!variantAvailable) {
               shouldSkip = true;
               skipReason = product.productTitle + ' is currently out of stock.';
            }
            // Check if quantity exceeds inventory (including what's already in cart)
            else if (variantInventory !== null && !isNaN(variantInventory)) {
               // Get current cart quantity for this variant
               var cartQuantity = getCartQuantityForVariant(variantId);
               var totalQuantity = cartQuantity + quantity;
               var maxAvailable = variantInventory - cartQuantity;
               
               if (quantity > maxAvailable) {
                  shouldSkip = true;
                  if (cartQuantity > 0) {
                     skipReason = product.productTitle + ' has only ' + variantInventory + ' remaining in stock. You have ' + cartQuantity + ' in your cart. You can add up to ' + maxAvailable + ' more.';
                  } else {
                     skipReason = product.productTitle + ' has only ' + variantInventory + ' remaining.';
                  }
               }
            }
         }
         
         // Skip this product if it exceeds stock limits
         if (shouldSkip) {
            skippedProducts.push({
               title: product.productTitle,
               reason: skipReason
            });
            console.log('Skipping addon product due to stock:', product.productTitle, skipReason);
            continue; // Skip this product, but continue with others
         }
         
         // Add valid product to cart
         var itemAddon = {
            "id": variantId,
            "quantity": quantity
         };
         allItems.push(itemAddon);
      }
   }

   console.log("Items to add to cart (main + addons, no bundle):", allItems);
   
   // Validate we have at least one item
   if (allItems.length === 0) {
      console.error('No valid items to add to cart');
      $button.attr('disabled', false).removeClass('loading');
      return;
   }

   // Add all items to cart in a single call
   CartJS.addItems(allItems, {
      "success": function(data, textStatus, jqXHR) {
         console.log('Success in adding products to cart', jqXHR);
         console.log('Cart response data:', data);
         
         // Show success state briefly, then reset
         $button.removeClass('loading').addClass('has-success');
         
         // Reset button state after success animation
         setTimeout(function() {
            $button.attr('disabled', false).removeClass('has-success');
         }, 1000);
         
         // Update max values for quantity selectors since cart has changed
         updateAddonQuantityMaxValues();
         
         // Show message about skipped products if any were skipped
         if (skippedProducts.length > 0) {
            var skippedMessage = 'Some items could not be added due to stock limits:<br><br>';
            for (var i = 0; i < skippedProducts.length; i++) {
               skippedMessage += '• ' + skippedProducts[i].title + ': ' + skippedProducts[i].reason;
               if (i < skippedProducts.length - 1) {
                  skippedMessage += '<br>';
               }
            }
            // Show message after a short delay to let success animation show first
            setTimeout(function() {
               showBundlePrompt(skippedMessage);
            }, 1200);
         }
         
         // Keep checkboxes and quantity selectors as they are - don't clear them
      },
      "error": function(jqXHR, textStatus, errorThrown) {
         console.error("Error occurred while adding products:", errorThrown, jqXHR);
         console.error("Response:", jqXHR.responseText);
         console.error("Status:", jqXHR.status);
         console.error("Items that failed:", allItems);
         $button.attr('disabled', false).removeClass('loading');
         
         // Show error message using bundle prompt styling
         var errorMessage = 'There was an error adding items to cart. Please try again.';
         if (jqXHR.responseJSON && jqXHR.responseJSON.description) {
            errorMessage = jqXHR.responseJSON.description;
         }
         showBundlePrompt(errorMessage);
      }
   });
}
// End - Addon Products

// Event Bundle Overlay Functionality
let eventBundleOverlay = null;
let eventBundleOverlayData = null;

// Initialize event bundle overlay (Always available)
initEventBundleOverlay = () => {
   const overlayElement = document.getElementById('event-bundle-overlay');
   if (!overlayElement) return;
   
   eventBundleOverlay = overlayElement;
   eventBundleOverlayData = document.querySelector('.jsc-event-bundle-data');
   
   if (!eventBundleOverlayData) return;
   
   // Always initialize overlay (no setting check needed)
   // Update main button text
   updateMainButtonText();
   
   // Add event listeners
   setupEventBundleOverlayListeners();
}

// Update main button text when min quantity is reached (overlay always available)
updateMainButtonText = () => {
   const addToCartBtn = document.querySelector('.jsc-atc-event-bundle');
   if (!addToCartBtn) return;
   
   const buttonText = addToCartBtn.querySelector('.jsc-bundle-atc-text');
   if (!buttonText) return;
   
   // Store original text if not already stored
   if (!buttonText.dataset.originalText) {
      buttonText.dataset.originalText = buttonText.textContent;
   }
   
   const eventBundleData = document.querySelector('.jsc-event-bundle-data');
   console.log('Event bundle data found:', eventBundleData);
   if (!eventBundleData) return;
   
   // Check if minimum quantity is reached
   const minTotalQuantity = parseInt(eventBundleData.getAttribute('data-min-total-quantity'), 10) || 0;
   let currentTotalQuantity = 0;
   
   $('.js-quantity-wrapper-event input[data-quantity-input-event-bundle]').each(function() {
      const quantity = parseInt($(this).val(), 10) || 0;
      if (quantity > 0) {
         currentTotalQuantity += quantity;
      }
   });
   
   // Update button text based on quantity
   if (currentTotalQuantity >= minTotalQuantity) {
      buttonText.textContent = 'Go to next step';
      console.log('Button text changed to: Go to next step');
   } else {
      buttonText.textContent = buttonText.dataset.originalText;
      console.log('Button text changed to:', buttonText.dataset.originalText);
   }
}

// Restore original button text when overlay is disabled
restoreMainButtonText = () => {
   const addToCartBtn = document.querySelector('.jsc-atc-event-bundle');
   if (addToCartBtn) {
      const buttonText = addToCartBtn.querySelector('.jsc-bundle-atc-text');
      if (buttonText && buttonText.dataset.originalText) {
         buttonText.textContent = buttonText.dataset.originalText;
      }
   }
}

initEventBundleDeliveryOpts = () => {
   if (!eventBundleOverlay) return;

   const syncDeliveryOptSelected = () => {
      eventBundleOverlay.querySelectorAll('.eb-delivery-opt').forEach(function (opt) {
         const radio = opt.querySelector('input[name="delivery_option"]');
         opt.classList.toggle('is-selected', radio && radio.checked);
      });
   };

   eventBundleOverlay.querySelectorAll('.eb-delivery-opt input[name="delivery_option"]').forEach(function (radio) {
      radio.addEventListener('change', syncDeliveryOptSelected);
   });

   syncDeliveryOptSelected();
};

setupEventBundleOverlayListeners = () => {
   if (!eventBundleOverlay) return;
   
   // Close button
   const closeBtn = eventBundleOverlay.querySelector('.event-bundle-overlay-close');
   if (closeBtn) {
      closeBtn.addEventListener('click', hideEventBundleOverlay);
   }
   
   // Edit selection button
   const editBtn = eventBundleOverlay.querySelector('.event-bundle-edit-selection-btn');
   if (editBtn) {
      editBtn.addEventListener('click', hideEventBundleOverlay);
   }

   initEventBundleDeliveryOpts();
   
   // Form validation
   const eventTypeSelect = eventBundleOverlay.querySelector('#event-type-select');
   const confirmBtn = eventBundleOverlay.querySelector('.event-bundle-confirm-btn');
   
   // Store original button text on initialization
   if (confirmBtn && !confirmBtn.getAttribute('data-original-text')) {
      const originalText = confirmBtn.textContent.trim();
      confirmBtn.setAttribute('data-original-text', originalText);
   }
   
   if (eventTypeSelect && confirmBtn) {
      eventTypeSelect.addEventListener('change', validateEventBundleForm);
      
      // Radio button changes
      const radioButtons = eventBundleOverlay.querySelectorAll('input[name="delivery_option"]');
      radioButtons.forEach(radio => {
         radio.addEventListener('change', validateEventBundleForm);
      });
   }
   
   // Confirm button
   if (confirmBtn) {
      confirmBtn.addEventListener('click', handleEventBundleConfirm);
   }
}

showEventBundleOverlay = () => {
   if (!eventBundleOverlay) return;
   
   // Update summary before showing
   updateEventBundleSummary();
   
   // Try to get values from the date range display first (most reliable)
   const displayFrom = document.getElementById('jsc-display-from');
   const displayTo = document.getElementById('jsc-display-to');
   
   const deliveryDateInput = document.getElementById('delivery-date');
   const deliveryTimeInput = document.getElementById('delivery-time');
   const collectionDateInput = document.getElementById('collection-date');
   const collectionTimeInput = document.getElementById('collection-time');
   
   // Helper function to convert 24-hour to 12-hour format
   function convert24To12Hour(time24) {
      if (!time24 || !time24.includes(':')) return time24;
      const [hours24, minutes] = time24.split(':').map(Number);
      const hours12 = hours24 === 0 ? 12 : hours24 > 12 ? hours24 - 12 : hours24;
      const ampm = hours24 >= 12 ? 'PM' : 'AM';
      return `${hours12}:${minutes.toString().padStart(2, '0')} ${ampm}`;
   }
   
   // Populate delivery fields from FROM date/time
   if (displayFrom && displayFrom.hasAttribute('data-date')) {
      // Use data attributes from display element
      const fromDateStr = displayFrom.getAttribute('data-date'); // YYYY-MM-DD format
      const fromTimeStr = displayFrom.getAttribute('data-time'); // 12-hour format like "9:00 AM"
      
      if (deliveryDateInput && fromDateStr) {
         deliveryDateInput.value = fromDateStr;
      }
      if (deliveryTimeInput && fromTimeStr && fromTimeStr !== 'Time') {
         deliveryTimeInput.value = fromTimeStr; // Already in 12-hour format
      }
   } else if (window.selectedEventDateTime) {
      // Fallback to window.selectedEventDateTime
      if (deliveryDateInput) {
         deliveryDateInput.value = window.selectedEventDateTime.fromDate || window.selectedEventDateTime.date;
      }
      if (deliveryTimeInput) {
         deliveryTimeInput.value = window.selectedEventDateTime.fromTimeDisplay || 
                                   (window.selectedEventDateTime.fromTime ? 
                                    convert24To12Hour(window.selectedEventDateTime.fromTime) : 
                                    window.selectedEventDateTime.time ? 
                                    convert24To12Hour(window.selectedEventDateTime.time) : '');
      }
   }
   
   // Populate collection fields from TO date/time
   if (displayTo && displayTo.hasAttribute('data-date')) {
      // Use data attributes from display element
      const toDateStr = displayTo.getAttribute('data-date'); // YYYY-MM-DD format
      const toTimeStr = displayTo.getAttribute('data-time'); // 12-hour format like "9:00 AM"
      
      if (collectionDateInput && toDateStr) {
         collectionDateInput.value = toDateStr;
      }
      if (collectionTimeInput && toTimeStr && toTimeStr !== 'Time') {
         collectionTimeInput.value = toTimeStr; // Already in 12-hour format
      }
   } else if (window.selectedEventDateTime) {
      // Fallback to window.selectedEventDateTime
      if (collectionDateInput) {
         collectionDateInput.value = window.selectedEventDateTime.toDate || window.selectedEventDateTime.fromDate || window.selectedEventDateTime.date;
      }
      if (collectionTimeInput) {
         collectionTimeInput.value = window.selectedEventDateTime.toTimeDisplay || 
                                     (window.selectedEventDateTime.toTime ? 
                                      convert24To12Hour(window.selectedEventDateTime.toTime) : 
                                      window.selectedEventDateTime.fromTimeDisplay || '');
      }
   }
   
   // Initialize collection date/time pickers
   // initCollectionPickers();
   
   // Add event listeners for collection fields validation
   if (collectionDateInput) {
      collectionDateInput.addEventListener('change', validateEventBundleForm);
   }
   if (collectionTimeInput) {
      collectionTimeInput.addEventListener('change', validateEventBundleForm);
   }
   
   // Show overlay
   eventBundleOverlay.style.display = 'block';
   eventBundleOverlay.setAttribute('aria-hidden', 'false');
   document.body.style.overflow = 'hidden';
   
   // Validate form
   validateEventBundleForm();
}

hideEventBundleOverlay = () => {
   if (!eventBundleOverlay) return;
   
   eventBundleOverlay.style.display = 'none';
   eventBundleOverlay.setAttribute('aria-hidden', 'true');
   document.body.style.overflow = '';
}

updateEventBundleOverlayFooter = () => {
   if (!eventBundleOverlay) return;

   var selectedFlavorsCount = 0;
   var totalQuantity = 0;

   $('.js-quantity-wrapper-event input[data-quantity-input-event-bundle]').each(function () {
      var currentValue = parseInt($(this).val(), 10) || 0;
      if (currentValue > 0) {
         selectedFlavorsCount++;
         totalQuantity += currentValue;
      }
   });

   var flavourText = selectedFlavorsCount === 1 ? 'flavour' : 'flavours';
   var flavoursLabel = selectedFlavorsCount + ' ' + flavourText;

   var cupsCountEl = eventBundleOverlay.querySelector('.eb-overlay-footer-cups-count');
   var flavoursEl = eventBundleOverlay.querySelector('.eb-overlay-footer-flavours');
   var priceEl = eventBundleOverlay.querySelector('.eb-overlay-footer-price-value');

   if (cupsCountEl) {
      cupsCountEl.textContent = totalQuantity;
   }
   if (flavoursEl) {
      flavoursEl.textContent = flavoursLabel;
   }
   if (priceEl) {
      var eventBundleData = document.querySelector('.jsc-event-bundle-data');
      var totalPrice = eventBundleData
         ? parseFloat(eventBundleData.getAttribute('data-event-bundle-total-price')) || 0
         : 0;
      priceEl.textContent = '$' + totalPrice.toFixed(2);
   }
}

updateEventBundleSummary = () => {
   if (!eventBundleOverlay) return;
   
   // Count selected flavors and total quantity
   let selectedFlavors = 0;
   let totalQuantity = 0;
   const selectedFlavorsList = [];
   
   $('.js-quantity-wrapper-event input[data-quantity-input-event-bundle]').each(function() {
      const quantity = parseInt($(this).val(), 10) || 0;
      if (quantity > 0) {
         selectedFlavors++;
         totalQuantity += quantity;
         
         // Get flavor details
         const productId = $(this).attr('data-prod-id');
         const productTitle = $(this).attr('data-prod-title');
         const productPrice = $(this).attr('data-prod-price');
         const productImage = $(this).attr('data-prod-image');
         
         selectedFlavorsList.push({
            id: productId,
            title: productTitle,
            price: productPrice,
            image: productImage,
            quantity: quantity
         });
      }
   });
   
   const totalFlavorsSpan = eventBundleOverlay.querySelector('.event-bundle-total-flavors');
   if (totalFlavorsSpan) {
      totalFlavorsSpan.textContent = totalQuantity;
   }

   const eventBundleData = document.querySelector('.jsc-event-bundle-data');
   const totalPrice = eventBundleData
      ? parseFloat(eventBundleData.getAttribute('data-event-bundle-total-price')) || 0
      : 0;

   const selectedFlavorsContainer = eventBundleOverlay.querySelector('.event-bundle-selected-flavors');
   if (selectedFlavorsContainer) {
      if (selectedFlavorsList.length === 0) {
         selectedFlavorsContainer.innerHTML = '<div class="event-bundle-no-flavors">No flavors selected</div>';
      } else {
         const rowsHtml = selectedFlavorsList.map(function (flavor) {
            return (
               '<div class="eb-summary-row">' +
                  '<div class="eb-summary-flavor-dot"></div>' +
                  '<span class="eb-summary-flavor-name">' + flavor.title + '</span>' +
                  '<span class="eb-summary-flavor-count">' + flavor.quantity + ' cups</span>' +
               '</div>'
            );
         }).join('');

         const totalRowHtml =
            '<div class="eb-summary-total-row">' +
               '<span>Total</span>' +
               '<span class="eb-summary-total-price">' + totalQuantity + ' cups <span class="eb-summary-flavor-dot"></span> $' + totalPrice.toFixed(2) + '</span>' +
            '</div>';

         selectedFlavorsContainer.innerHTML = rowsHtml + totalRowHtml;
      }
   }

   updateEventBundleOverlayFooter();
}

handleEventBundleConfirm = () => {
   if (!eventBundleOverlay) return;
   
   const eventTypeSelect = eventBundleOverlay.querySelector('#event-type-select');
   const deliveryOption = eventBundleOverlay.querySelector('input[name="delivery_option"]:checked');
   const confirmBtn = eventBundleOverlay.querySelector('.event-bundle-confirm-btn');
   
   if (!eventTypeSelect || !deliveryOption || !confirmBtn) return;
   
   const eventType = eventTypeSelect.value;
   const deliveryType = deliveryOption.value;
   
   // Add delivery option to line item properties
   const deliveryProperty = deliveryType === 'premium' ? 'Delivery to Sentosa / CBD / Tuas (+$30)' : 'Standard Delivery';
   
   // Store the event details for cart addition
   window.eventBundleDetails = {
      eventType: eventType,
      deliveryOption: deliveryProperty,
      deliveryType: deliveryType
   };
   
   // Store original button text if not already stored
   if (!confirmBtn.getAttribute('data-original-text')) {
      const originalText = confirmBtn.textContent.trim();
      confirmBtn.setAttribute('data-original-text', originalText);
   }
   
   // Show spinner on confirm button
   confirmBtn.disabled = true;
   confirmBtn.innerHTML = `
      <svg height="18" width="18" class="svg-loader" style="--border: rgb(var(--rgb-button-contrast) / 50%); --text: rgb(var(--rgb-button-contrast));">
        <circle r="7" cx="9" cy="9"></circle>
        <circle stroke-dasharray="87.96459430051421 87.96459430051421" r="7" cx="9" cy="9"></circle>
      </svg>
      Adding to cart...
   `;
   
   // Add flavors to cart using the original addEventBundleToCart function
   const addToCartBtn = document.querySelector('.jsc-atc-event-bundle');
   if (addToCartBtn) {
      // Set flag to skip overlay (we're already in the overlay)
      window.skipOverlayForCartAdd = true;
      
      // Store callback to hide overlay after successful cart addition
      window.eventBundleOverlayCallback = () => {
         // Hide overlay after successful cart addition
         hideEventBundleOverlay();
         // Clear the flag
         delete window.skipOverlayForCartAdd;
      };
      
      // Call the original function directly (will skip overlay due to flag)
      if (originalAddEventBundleToCart) {
         originalAddEventBundleToCart(addToCartBtn);
      } else {
         // Fallback: clear flag if original function doesn't exist
         delete window.skipOverlayForCartAdd;
      }
   }
}

// Override the original addEventBundleToCart function to show overlay (unless flag is set)
const originalAddEventBundleToCart = window.addEventBundleToCart;
window.addEventBundleToCart = function(button) {
   const $button = $(button);
   
   // Check if we should skip overlay (e.g., when called from overlay confirm button)
   if (window.skipOverlayForCartAdd) {
      // Call original function directly to add to cart
      if (originalAddEventBundleToCart) {
         originalAddEventBundleToCart(button);
      }
      return;
   }
   
   // Always show overlay when button is clicked (no setting check needed)
   showEventBundleOverlay();
};

// Initialize overlay when DOM is ready (always available)
$(document).ready(function() {
   initEventBundleOverlay();
   initCustomSelect();
   initFormValidation();
   initFlatpickrPickers(); // Initialize for default structure
   initDateRangePicker(); // Initialize for date range picker
   
   // Always update button text (overlay always available)
   // Update button text on initial load
   setTimeout(() => {
      updateMainButtonText();
   }, 100);
   
   // Add manual trigger for testing
   window.testButtonText = updateMainButtonText;
});

// Custom Select Functionality
initCustomSelect = () => {
   const customSelects = document.querySelectorAll('.event-bundle-custom-select');
   
   customSelects.forEach(select => {
      const trigger = select.querySelector('.event-bundle-select-trigger');
      const dropdown = select.querySelector('.event-bundle-select-dropdown');
      const options = select.querySelectorAll('.event-bundle-select-option');
      const hiddenInput = select.querySelector('input[type="hidden"]');
      const valueSpan = select.querySelector('.event-bundle-select-value');
      
      // Toggle dropdown
      trigger.addEventListener('click', function(e) {
         e.stopPropagation();
         select.classList.toggle('open');
      });
      
      // Handle option selection
      options.forEach(option => {
         option.addEventListener('click', function(e) {
            e.stopPropagation();
            
            // Remove selected class from all options
            options.forEach(opt => opt.classList.remove('selected'));
            
            // Add selected class to clicked option
            option.classList.add('selected');
            
            // Update display value and hidden input
            const value = option.getAttribute('data-value');
            const text = option.textContent;
            
            valueSpan.textContent = text;
            hiddenInput.value = value;
            
            // Close dropdown
            select.classList.remove('open');
            
            // Validate form after selection
            validateEventBundleForm();
         });
      });
      
      // Close dropdown when clicking outside
      document.addEventListener('click', function(e) {
         if (!select.contains(e.target)) {
            select.classList.remove('open');
         }
      });
      
      // Handle keyboard navigation
      trigger.addEventListener('keydown', function(e) {
         if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            select.classList.toggle('open');
         } else if (e.key === 'Escape') {
            select.classList.remove('open');
         }
      });
   });
}

// Form Validation Function
validateEventBundleForm = () => {
   const eventTypeSelect = document.getElementById('event-type-select');
   const deliveryOptions = document.querySelectorAll('input[name="delivery_option"]');
   const warningMessage = document.querySelector('.event-bundle-form-warning-message');
   const confirmBtn = document.querySelector('.event-bundle-confirm-btn');
   
   // Check if event type is selected
   const isEventTypeSelected = eventTypeSelect && eventTypeSelect.value !== '';
   
   // Check if delivery option is selected
   const isDeliveryOptionSelected = Array.from(deliveryOptions).some(option => option.checked);
   
   // Check if collection date and time are selected (only if overlay is enabled)
   const collectionDate = document.getElementById('collection-date');
   const collectionTime = document.getElementById('collection-time');
   const collectionFieldsExist = collectionDate && collectionTime;
   const isCollectionDateSelected = collectionFieldsExist ? collectionDate.value !== '' : true; // Skip validation if fields don't exist
   const isCollectionTimeSelected = collectionFieldsExist ? collectionTime.value !== '' : true; // Skip validation if fields don't exist

   const eventDateInput = document.getElementById('event-date');
   const eventTimeInput = document.getElementById('event-time');
   const isEventDateSelected = eventDateInput ? eventDateInput.value !== '' : true;
   const isEventTimeSelected = eventTimeInput ? eventTimeInput.value !== '' : true;
   
   // Check if form is complete
   const isFormComplete = isEventTypeSelected && isDeliveryOptionSelected && isEventDateSelected && isEventTimeSelected && isCollectionDateSelected && isCollectionTimeSelected;
   
   if (isFormComplete) {
      // Hide warning message
      if (warningMessage) {
         warningMessage.style.display = 'none';
      }
      // Enable confirm button
      if (confirmBtn) {
         confirmBtn.disabled = false;
      }
   } else {
      // Show warning message
      if (warningMessage) {
         warningMessage.style.display = 'block';
      }
      // Disable confirm button
      if (confirmBtn) {
         confirmBtn.disabled = true;
      }
   }
}

// Initialize collection date/time pickers for overlay
// initCollectionPickers = () => {
//    // Check if Flatpickr is available
//    if (typeof flatpickr === 'undefined') {
//       console.warn('Flatpickr is not loaded');
//       return;
//    }

//    // Get blocked dates from section settings
//    const eventBundleData = document.querySelector('.jsc-event-bundle-data');
//    const blockedDatesText = eventBundleData ? eventBundleData.getAttribute('data-blocked-dates') : '';
//    const blockedDates = parseBlockedDates(blockedDatesText);

//    // Initialize delivery date/time pickers (disabled - show main form values)
//    const deliveryDateInput = document.getElementById('delivery-date');
//    if (deliveryDateInput) {
//       const currentYear = new Date().getFullYear();
//       flatpickr(deliveryDateInput, {
//          dateFormat: "Y-m-d",
//          minDate: "today",
//          allowInput: false,
//          clickOpens: false, // Disable click to open
//          disabled: true, // Disable the picker
//          placeholder: "Select delivery date",
//          defaultDate: deliveryDateInput.value || "today",
//          yearRange: [currentYear, currentYear + 2]
//       });
//    }

//    const deliveryTimeInput = document.getElementById('delivery-time');
//    if (deliveryTimeInput) {
//       flatpickr(deliveryTimeInput, {
//          enableTime: true,
//          noCalendar: true,
//          dateFormat: "H:i",
//          time_24hr: true,
//          allowInput: false,
//          clickOpens: false, // Disable click to open
//          disabled: true, // Disable the picker
//          placeholder: "Select delivery time",
//          defaultDate: deliveryTimeInput.value || "18:00",
//          minTime: "08:00",
//          maxTime: "22:00"
//       });
//    }

//    // Initialize collection date/time pickers (enabled - user can input)
//    const collectionDateInput = document.getElementById('collection-date');
//    if (collectionDateInput) {
//       const currentYear = new Date().getFullYear();
//       // Set minimum date to the selected event date
//       const eventDateInput = document.getElementById('event-date');
//       let minDate = new Date();
      
//       if (eventDateInput && eventDateInput.value) {
//          minDate = new Date(eventDateInput.value);
//       }
      
//       flatpickr(collectionDateInput, {
//          dateFormat: "Y-m-d",
//          minDate: minDate,
//          allowInput: false,
//          clickOpens: true, // Enable click to open
//          disabled: false, // Enable the picker
//          placeholder: "Select collection date",
//          // No default date - let user select
//          yearRange: [currentYear, currentYear + 2],
//          disable: blockedDates // Apply blocked dates
//       });
//    }

//    // Collection time now uses custom dropdown like event-time
//    // No flatpickr initialization needed
// }

// Initialize form validation on page load
initFormValidation = () => {
   // Add event listeners to delivery options
   const deliveryOptions = document.querySelectorAll('input[name="delivery_option"]');
   deliveryOptions.forEach(option => {
      option.addEventListener('change', validateEventBundleForm);
   });
   
   // Initial validation
   validateEventBundleForm();
}

// Initialize Flatpickr datetime pickers
// DD/MM/YYYY for internal/metadata line item props (e.g. _Delivery Date)
formatCartDateDdMmYyyy = (dateStr) => {
   const date = new Date(dateStr);
   const day = String(date.getDate()).padStart(2, '0');
   const month = String(date.getMonth() + 1).padStart(2, '0');
   const year = date.getFullYear();
   return `${day}/${month}/${year}`;
};

// Normalize one time token to HH:MM (24h); accepts 24h or 12h with AM/PM.
normalizeTimeTo24Hour = (timeStr) => {
   if (!timeStr) return timeStr;
   const trimmed = String(timeStr).trim();
   const upper = trimmed.toUpperCase();
   if (upper.includes('AM') || upper.includes('PM')) {
      const isPM = upper.includes('PM');
      const withoutAmPm = trimmed.replace(/\s*(AM|PM|am|pm)/gi, '').trim();
      const parts = withoutAmPm.split(':');
      if (parts.length < 2) return trimmed;
      let h = parseInt(parts[0], 10);
      const m = String(parts[1].replace(/\D/g, '')).padStart(2, '0');
      if (isNaN(h)) return trimmed;
      if (isPM && h !== 12) h += 12;
      if (!isPM && h === 12) h = 0;
      return `${String(h).padStart(2, '0')}:${m}`;
   }
   const parts = trimmed.split(':');
   if (parts.length < 2) return trimmed;
   const h = parseInt(parts[0], 10);
   const m = String(parts[1].replace(/\D/g, '')).padStart(2, '0');
   if (isNaN(h)) return trimmed;
   return `${String(h).padStart(2, '0')}:${m}`;
};

// Single pick (e.g. 7:30 PM) → "19:00-19:30" (30 min window ending at that time)
singleTimeToEnding30MinWindow24 = (timeStr) => {
   const endHHMM = normalizeTimeTo24Hour(timeStr);
   const parts = endHHMM.split(':');
   if (parts.length < 2) return endHHMM;
   const eh = parseInt(parts[0], 10);
   const em = parseInt(String(parts[1]).replace(/\D/g, ''), 10) || 0;
   if (isNaN(eh)) return endHHMM;
   const end = new Date(2000, 0, 1, eh, em, 0, 0);
   const start = new Date(end.getTime() - 30 * 60 * 1000);
   const pad2 = (n) => String(n).padStart(2, '0');
   const fmt = (d) => `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
   return `${fmt(start)}-${fmt(end)}`;
};

// HH:MM-HH:MM (24h) for internal line item props (e.g. _Delivery Time); single slot → 30 min window
formatCartTime24 = (timeStr) => {
   if (!timeStr) return timeStr;
   const trimmed = String(timeStr).trim();
   if (!trimmed.includes('-')) {
      return singleTimeToEnding30MinWindow24(trimmed);
   }
   const [start, end] = trimmed.split('-').map((part) => part.trim());
   return `${normalizeTimeTo24Hour(start)}-${normalizeTimeTo24Hour(end)}`;
};

// Helper function to format date and time for line item properties
formatDateTimeForCart = (dateStr, timeStr) => {
   // Format date: 31 SEPT 2025
   const date = new Date(dateStr);
   const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEPT', 'OCT', 'NOV', 'DEC'];
   const day = date.getDate();
   const month = months[date.getMonth()];
   const year = date.getFullYear();
   const formattedDate = `${day} ${month} ${year}`;
   
   // Format time: Convert 24-hour to 12-hour format
   // Handle both single time and time range formats
   if (timeStr.includes('-')) {
      // Time range format (e.g., "18:00-20:00")
      const [startTime, endTime] = timeStr.split('-');
      const formattedStartTime = formatTimeTo12Hour(startTime);
      const formattedEndTime = formatTimeTo12Hour(endTime);
      const formattedTime = `${formattedStartTime}-${formattedEndTime}`;
      return {
         date: formattedDate,
         time: formattedTime
      };
   } else {
      // Single time format
      const formattedTime = formatTimeTo12Hour(timeStr);
      return {
         date: formattedDate,
         time: formattedTime
      };
   }
};

// Helper function to convert 24-hour time to 12-hour format
formatTimeTo12Hour = (timeStr) => {
   if (!timeStr) return timeStr;
   
   // Check if already in 12-hour format (contains AM or PM)
   const trimmedTime = timeStr.trim();
   if (trimmedTime.includes('AM') || trimmedTime.includes('PM') || 
       trimmedTime.includes('am') || trimmedTime.includes('pm')) {
      // Already in 12-hour format, return as-is (trimmed)
      return trimmedTime;
   }
   
   // Parse as 24-hour format (e.g., "09:00" or "18:30")
   const timeParts = trimmedTime.split(':');
   if (timeParts.length < 2) return trimmedTime;
   
   const hours = parseInt(timeParts[0], 10);
   let minutes = timeParts[1].trim();
   
   // Extract only numeric minutes (remove any trailing characters)
   const minutesOnly = minutes.replace(/\D/g, '');
   if (!minutesOnly) return trimmedTime;
   
   const minutesFormatted = minutesOnly.padStart(2, '0');
   const hour24 = parseInt(hours, 10);
   
   if (isNaN(hour24)) return trimmedTime;
   
   const hour12 = hour24 === 0 ? 12 : hour24 > 12 ? hour24 - 12 : hour24;
   const ampm = hour24 >= 12 ? 'PM' : 'AM';
   return `${hour12}:${minutesFormatted} ${ampm}`;
};

// 30 minutes before ready-by / event setup anchor; when overlay event details exist, subtract an additional 2 hours (single slot or end of "HH:MM-HH:MM" range)
getDeliveryArrivalTimeProperty = (dateStr, timeStr, eventBundle) => {
   if (!dateStr || !timeStr) return '';
   const trimmed = String(timeStr).trim();
   const anchorPart = trimmed.includes('-')
      ? trimmed.split('-').pop().trim()
      : trimmed;
   const timeParts = anchorPart.split(':');
   if (timeParts.length < 2) return '';
   const hours = parseInt(timeParts[0], 10);
   const minutes = parseInt(String(timeParts[1]).replace(/\D/g, ''), 10) || 0;
   if (isNaN(hours)) return '';
   var dateObj;
   if (dateStr.includes('-')) {
      var ymd = dateStr.split('-').map(Number);
      dateObj = new Date(ymd[0], ymd[1] - 1, ymd[2]);
   } else {
      dateObj = new Date(dateStr);
   }
   if (isNaN(dateObj.getTime())) return '';
   dateObj.setHours(hours, minutes, 0, 0);
   if (eventBundle) {
      dateObj.setTime(dateObj.getTime() - 2 * 60 * 60 * 1000);
   } else {
      dateObj.setTime(dateObj.getTime() - 30 * 60 * 1000);
   }
   var dh = dateObj.getHours();
   var dm = dateObj.getMinutes();
   return formatTimeTo12Hour(dh + ':' + String(dm).padStart(2, '0'));
};

// Calendar dates are local midnight; YYYY-MM-DD must use local getters — not toISOString() (UTC),
// or blocked days and submitted dates shift by one in timezones ahead of UTC.
formatDateToLocalYMD = (date) => {
   if (!date || isNaN(date.getTime())) return '';
   const y = date.getFullYear();
   const m = String(date.getMonth() + 1).padStart(2, '0');
   const d = String(date.getDate()).padStart(2, '0');
   return `${y}-${m}-${d}`;
};

// Helper function to parse blocked dates from textarea
parseBlockedDates = (blockedDatesText) => {
   if (!blockedDatesText || blockedDatesText.trim() === '') {
      return [];
   }
   
   const blockedDates = [];
   const lines = blockedDatesText.split('\n');
   
   lines.forEach(line => {
      const trimmedLine = line.trim();
      if (trimmedLine === '') return;
      
      // Check if it's a date range (contains " to ")
      if (trimmedLine.includes(' to ')) {
         const [startDate, endDate] = trimmedLine.split(' to ').map(date => date.trim());
         // Validate date format (YYYY-MM-DD)
         if (/^\d{4}-\d{2}-\d{2}$/.test(startDate) && /^\d{4}-\d{2}-\d{2}$/.test(endDate)) {
            blockedDates.push({
               from: startDate,
               to: endDate
            });
         }
      } else {
         // Single date
         if (/^\d{4}-\d{2}-\d{2}$/.test(trimmedLine)) {
            blockedDates.push(trimmedLine);
         }
      }
   });
   
   return blockedDates;
};

initFlatpickrPickers = () => {
   // Check if Flatpickr is available
   if (typeof flatpickr === 'undefined') {
      console.warn('Flatpickr is not loaded');
      return;
   }

   // Get blocked dates from section settings
   const eventBundleData = document.querySelector('.jsc-event-bundle-data');
   const blockedDatesText = eventBundleData ? eventBundleData.getAttribute('data-blocked-dates') : '';
   const blockedDates = parseBlockedDates(blockedDatesText);

   // Initialize collection date picker (main form)
   // Skip if input is hidden (using new date range picker)
   const eventDateInput = document.getElementById('event-date');
   if (eventDateInput && eventDateInput.type !== 'hidden') {
      const currentYear = new Date().getFullYear();
      // Calculate 5 days from today (including current date)
      const today = new Date();
      const minDate = new Date(today);
      minDate.setDate(today.getDate() + 4); // +4 because today counts as day 1
      
      flatpickr(eventDateInput, {
         dateFormat: "Y-m-d",
         minDate: minDate,
         allowInput: false,
         clickOpens: true,
         placeholder: "Select collection date",
         // No default date - let user select
         yearRange: [currentYear, currentYear + 2],
         disable: blockedDates, // Apply blocked dates
         onChange: function() {
            if (typeof validateEventBundleForm === 'function') {
               validateEventBundleForm();
            }
         }
      });
   }

   // Initialize event time picker (main form - single time, no range)
   const eventTimeInput = document.getElementById('event-time');
   // if (eventTimeInput) {
   //    flatpickr(eventTimeInput, {
   //       enableTime: true,
   //       noCalendar: true,
   //       dateFormat: "H:i",
   //       time_24hr: true,
   //       allowInput: false,
   //       clickOpens: true,
   //       placeholder: "Select ready by time",
   //       // No default time - let user select
   //       minTime: "09:00",
   //       maxTime: "21:30"
   //       // No range mode - just single time selection
   //    });
   // }
}

openDropdownEventTime = () => {
   $('.jsc-fake-dropdown').toggle();
}

openDropdownCollectionTime = () => {
   $('.jsc-collection-time-dropdown').toggle();
}

// Initialize Date Range Picker
initDateRangePicker = () => {
  const modal = document.getElementById('jsc-date-range-modal');
  if (!modal) return;

  const openDateRangeBtn = document.getElementById('jsc-open-date-range-btn');
  const dateRangeDisplay = document.getElementById('jsc-date-range-display');
  const fromDateBtn = document.getElementById('jsc-from-date-btn');
  const fromTimeBtn = document.getElementById('jsc-from-time-btn');
  const toDateBtn = document.getElementById('jsc-to-date-btn');
  const toTimeBtn = document.getElementById('jsc-to-time-btn');
  const modalFromDate = document.getElementById('jsc-modal-from-date');
  const modalFromTime = document.getElementById('jsc-modal-from-time');
  const modalToDate = document.getElementById('jsc-modal-to-date');
  const modalToTime = document.getElementById('jsc-modal-to-time');
  const calendarGrid1 = document.getElementById('jsc-calendar-grid-1');
  const calendarGrid2 = document.getElementById('jsc-calendar-grid-2');
  const monthYear1 = document.getElementById('jsc-month-year-1');
  const monthYear2 = document.getElementById('jsc-month-year-2');
  const monthYear1Mobile = document.getElementById('jsc-month-year-1-mobile');
  const monthYear2Mobile = document.getElementById('jsc-month-year-2-mobile');
  const monthYear1MobileHeader = document.getElementById('jsc-month-year-1-mobile-header');
  const prevMonthBtn = document.getElementById('jsc-prev-month');
  const nextMonthBtn = document.getElementById('jsc-next-month');
  const clearDatesBtn = document.getElementById('jsc-clear-dates');
  const confirmDatesBtn = document.getElementById('jsc-confirm-dates');
  const timePopup = document.getElementById('jsc-time-popup');
  const timeList = document.getElementById('jsc-time-list');
  const overlay = modal.querySelector('.jsc-modal-overlay');

      const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  // Calculate minimum date (5 days from today)
      const minDate = new Date(today);
      minDate.setDate(today.getDate() + 4); // +4 because today counts as day 1
      
  // Start calendar at minimum date month
  let currentMonth = minDate.getMonth();
  let currentYear = minDate.getFullYear();
  let startDate = null;
  let endDate = null;
  let selectingFor = null; // 'from' or 'to'
  let activeTimePicker = null; // 'from' or 'to'

  const monthNames = ["January", "February", "March", "April", "May", "June", 
                      "July", "August", "September", "October", "November", "December"];

  // Get blocked dates
  const eventBundleData = document.querySelector('.jsc-event-bundle-data');
  const blockedDatesText = eventBundleData ? eventBundleData.getAttribute('data-blocked-dates') : '';
  const blockedDates = parseBlockedDates(blockedDatesText);

  function isDateBlocked(date) {
    const dateStr = formatDateToLocalYMD(date);
    for (let blocked of blockedDates) {
      if (typeof blocked === 'string') {
        if (blocked === dateStr) return true;
      } else if (blocked.from && blocked.to) {
        if (dateStr >= blocked.from && dateStr <= blocked.to) return true;
      }
    }
    return false;
  }

  function formatDate(date) {
    if (!date) return 'Select date';
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  function formatDateForDisplay(date, timeText) {
    if (!date || !timeText || timeText === 'Time') return 'Select date and time';
    
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
                       "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    
    // Format time: already in 12-hour format from formatTime function
    const formattedTime = timeText === 'Time' ? '' : timeText;
    
    return `${month} ${day} ${year}, ${formattedTime}`;
  }

  function formatTime(date) {
    if (!date) return 'Time';
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const displayHours = hours > 12 ? hours - 12 : (hours === 0 ? 12 : hours);
    const ampm = hours >= 12 ? 'PM' : 'AM';
    return `${displayHours}:${minutes.toString().padStart(2, '0')} ${ampm}`;
  }

  function datesAreSameCalendarDay(d1, d2) {
    if (!d1 || !d2) return false;
    return d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();
  }

  function getMinutesFromMidnight(timeText) {
    if (!timeText || timeText === 'Time') return null;
    const match = String(timeText).match(/(\d+):(\d+)\s*(AM|PM)/i);
    if (!match) return null;
    let hours = parseInt(match[1], 10);
    const minutes = parseInt(match[2], 10);
    const ampm = match[3].toUpperCase();
    if (ampm === 'PM' && hours !== 12) hours += 12;
    if (ampm === 'AM' && hours === 12) hours = 0;
    return hours * 60 + minutes;
  }

  /** Picker end-of-day slot displays as "12:00 AM" but is 24:00, not 00:00. */
  function isEndOfDayMidnightLabel(timeText) {
    return /^12:00\s*AM$/i.test(String(timeText || '').trim());
  }

  /** Same as getMinutesFromMidnight except "12:00 AM" means end of that calendar day (not 00:00 start). */
  function getMinutesFromMidnightForSameDayTo(timeText) {
    if (!timeText || timeText === 'Time') return null;
    if (isEndOfDayMidnightLabel(timeText)) return 24 * 60;
    return getMinutesFromMidnight(timeText);
  }

  /** Same end-of-day rule for FROM (only "12:00 AM" option in the picker is the end-of-day slot). */
  function getMinutesFromMidnightForSameDayFrom(timeText) {
    if (!timeText || timeText === 'Time') return null;
    if (isEndOfDayMidnightLabel(timeText)) return 24 * 60;
    return getMinutesFromMidnight(timeText);
  }

  /** When FROM and TO share a date, TO time must be at least +3h after FROM (minutes from midnight). */
  function getMinSameDayToMinutesFromFromTime() {
    if (!startDate || !endDate || !datesAreSameCalendarDay(startDate, endDate)) return null;
    const fromStr = modalFromTime && modalFromTime.querySelector('span')
      ? modalFromTime.querySelector('span').textContent
      : 'Time';
    const fromMin = getMinutesFromMidnightForSameDayFrom(fromStr);
    if (fromMin === null) return null;
    return fromMin + 3 * 60;
  }

  function clearToTimeUi() {
    if (modalToTime && modalToTime.querySelector('span')) {
      modalToTime.querySelector('span').textContent = 'Time';
      modalToTime.querySelector('span').classList.remove('font-medium');
    }
    if (toTimeBtn && toTimeBtn.querySelector('span')) {
      toTimeBtn.querySelector('span').textContent = 'Time';
      toTimeBtn.querySelector('span').classList.remove('font-medium');
    }
  }

  function invalidateToTimeIfBeforeSameDayMinimum() {
    const minToMin = getMinSameDayToMinutesFromFromTime();
    if (minToMin === null) return;
    const toStr = modalToTime && modalToTime.querySelector('span')
      ? modalToTime.querySelector('span').textContent
      : 'Time';
    const toMin = getMinutesFromMidnightForSameDayTo(toStr);
    if (toMin === null) return;
    if (toMin < minToMin) {
      clearToTimeUi();
      if (modalToTime) modalToTime.classList.remove('active');
    }
  }

  function renderCalendar(month, year, gridElement, monthYearElement) {
    gridElement.innerHTML = '';
    monthYearElement.textContent = `${monthNames[month]} ${year}`;
    
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    // Empty cells for days before month start
    for (let i = 0; i < firstDay; i++) {
      const emptyDiv = document.createElement('div');
      gridElement.appendChild(emptyDiv);
    }

    // Calendar days
    for (let day = 1; day <= daysInMonth; day++) {
      const dayEl = document.createElement('button');
      dayEl.textContent = day;
      dayEl.className = 'jsc-calendar-day';
      
      const date = new Date(year, month, day);
      date.setHours(0, 0, 0, 0);
      // Store date as data attribute for easier retrieval
      dayEl.setAttribute('data-date', date.getTime().toString());

      // Disable dates before minimum date, or dates before startDate when selecting 'to', or blocked dates
      if (date < minDate || (selectingFor === 'to' && startDate && date < startDate) || isDateBlocked(date)) {
        dayEl.classList.add('disabled');
        dayEl.disabled = true;
      }

      // Highlight today
      if (date.getTime() === today.getTime()) {
        dayEl.classList.add('today');
      }

      // Highlight selected range - only show ONE range at a time
      if (startDate && endDate) {
        const dateTime = date.getTime();
        const startTime = startDate.getTime();
        const endTime = endDate.getTime();
        
        // Check if FROM and TO are the same date
        if (startTime === endTime && dateTime === startTime) {
          // Same date selected - show full border
          dayEl.classList.add('selected-same-date');
        } else if (dateTime >= startTime && dateTime <= endTime) {
          // Only highlight if this date is within the current valid range
          if (dateTime === startTime) {
            dayEl.classList.add('selected-start');
            if (endTime > startTime) dayEl.classList.add('in-range');
          } else if (dateTime === endTime) {
            dayEl.classList.add('selected-end');
            if (startTime < endTime) dayEl.classList.add('in-range');
          } else if (dateTime > startTime && dateTime < endTime) {
            dayEl.classList.add('in-range');
          }
        }
      } else if (startDate && !endDate && date.getTime() === startDate.getTime()) {
        // Only highlight FROM date if TO date hasn't been selected yet
        dayEl.classList.add('selected-start');
      }

      dayEl.addEventListener('click', (e) => {
        e.stopPropagation(); // Prevent event from bubbling to document
        if (!dayEl.disabled) {
          handleDateClick(date);
        }
      });

      // Add hover preview for range selection when selecting TO
      if (selectingFor === 'to' && startDate && !dayEl.disabled && date >= startDate) {
        dayEl.addEventListener('mouseenter', () => {
          // Get the hovered date from the element
          const hoveredDate = getDateFromDayElement(dayEl);
          if (!hoveredDate || hoveredDate < startDate) return;
          
          // Add preview classes to all dates in the potential range
          const allDays = document.querySelectorAll('.jsc-calendar-day');
          const hoverTime = hoveredDate.getTime();
          const startTime = startDate.getTime();
          
          allDays.forEach((day) => {
            if (day.classList.contains('disabled')) return;
            
            const dayDate = getDateFromDayElement(day);
            if (!dayDate) return;
            
            const dayTime = dayDate.getTime();
            
            // Remove existing preview classes
            day.classList.remove('preview-start', 'preview-end', 'preview-in-range', 'preview-same-date');
            
            if (dayTime >= startTime && dayTime <= hoverTime) {
              if (dayTime === startTime && startTime === hoverTime) {
                // Same date - full border preview
                day.classList.add('preview-same-date');
              } else if (dayTime === startTime) {
                day.classList.add('preview-start');
                if (hoverTime > startTime) day.classList.add('preview-in-range');
              } else if (dayTime === hoverTime) {
                day.classList.add('preview-end');
                if (startTime < hoverTime) day.classList.add('preview-in-range');
              } else if (dayTime > startTime && dayTime < hoverTime) {
                day.classList.add('preview-in-range');
              }
            }
          });
        });

        dayEl.addEventListener('mouseleave', () => {
          // Remove preview classes from all days
          const allDays = document.querySelectorAll('.jsc-calendar-day');
          allDays.forEach((day) => {
            day.classList.remove('preview-start', 'preview-end', 'preview-in-range', 'preview-same-date');
          });
        });
      }

      gridElement.appendChild(dayEl);
    }
  }

  function renderCalendars() {
    renderCalendar(currentMonth, currentYear, calendarGrid1, monthYear1);
    if (monthYear1Mobile) {
      monthYear1Mobile.textContent = monthYear1 ? monthYear1.textContent : '';
    }
    // Update mobile header month title (shows current month)
    if (monthYear1MobileHeader) {
      monthYear1MobileHeader.textContent = monthYear1 ? monthYear1.textContent : '';
    }
    
    let nextMonth = currentMonth + 1;
    let nextYear = currentYear;
    if (nextMonth > 11) {
      nextMonth = 0;
      nextYear++;
    }
    renderCalendar(nextMonth, nextYear, calendarGrid2, monthYear2);
    if (monthYear2Mobile) {
      monthYear2Mobile.textContent = monthYear2 ? monthYear2.textContent : '';
    }
  }

  function handleDateClick(date) {
    // If both dates are already selected, allow direct reselection from calendar
    if (startDate && endDate && selectingFor === null) {
      // Store current time selections to preserve them
      const fromTimeValue = modalFromTime ? modalFromTime.querySelector('span').textContent : 'Time';
      const toTimeValue = modalToTime ? modalToTime.querySelector('span').textContent : 'Time';
      const fromTimeWasSelected = fromTimeValue !== 'Time';
      const toTimeWasSelected = toTimeValue !== 'Time';
      
      // Reset date selections and start fresh with clicked date as FROM
      startDate = new Date(date);
      startDate.setHours(0, 0, 0, 0);
      endDate = null;
      
      // Clear TO date display
      if (modalToDate) {
        modalToDate.querySelector('span').textContent = 'Select date';
        modalToDate.classList.remove('jsc-modal-date-active');
      }
      if (toDateBtn) {
        toDateBtn.querySelector('span').textContent = 'Select date';
      }
      
      // Remove active states from date inputs
      if (modalFromDate) {
        modalFromDate.classList.remove('jsc-modal-date-active');
      }
      if (modalToDate) {
        modalToDate.classList.remove('jsc-modal-date-active');
      }
      
      // Preserve FROM time if it was selected
      if (fromTimeWasSelected) {
        // Keep FROM time selected
        if (modalFromTime) {
          modalFromTime.disabled = false;
          modalFromTime.classList.remove('active'); // Remove active class but keep value
        }
        if (fromTimeBtn) {
          fromTimeBtn.disabled = false;
        }
      } else {
        // Clear FROM time if it wasn't selected
        if (modalFromTime) {
          modalFromTime.querySelector('span').textContent = 'Time';
          modalFromTime.querySelector('span').classList.remove('font-medium');
          modalFromTime.disabled = true;
          modalFromTime.classList.remove('active');
        }
        if (fromTimeBtn && fromTimeBtn.querySelector('span')) {
          fromTimeBtn.querySelector('span').textContent = 'Time';
          fromTimeBtn.querySelector('span').classList.remove('font-medium');
          fromTimeBtn.disabled = true;
        }
      }
      
      // Preserve TO time if it was selected (will be restored when TO date is selected)
      // For now, keep it disabled but don't clear the value visually
      // We'll restore it when TO date is selected again
      if (!toTimeWasSelected) {
        // Clear TO time if it wasn't selected
        if (modalToTime) {
          modalToTime.querySelector('span').textContent = 'Time';
          modalToTime.querySelector('span').classList.remove('font-medium');
          modalToTime.disabled = true;
          modalToTime.classList.remove('active');
        }
        if (toTimeBtn && toTimeBtn.querySelector('span')) {
          toTimeBtn.querySelector('span').textContent = 'Time';
          toTimeBtn.querySelector('span').classList.remove('font-medium');
          toTimeBtn.disabled = true;
        }
      }
      
      // Store TO time value to restore later
      window.preservedToTime = toTimeWasSelected ? toTimeValue : null;
      
      updateDateDisplay('from', startDate);
      if (fromTimeBtn) {
        fromTimeBtn.disabled = false;
      }
      if (modalFromTime) {
        modalFromTime.disabled = false;
      }
      // Update delivery time if FROM time is already selected
      if (fromTimeWasSelected) {
        updateDeliveryTimeInFootnote();
      }
      selectingFor = 'to';
      updateSelectionMode('to');
      highlightActiveDate('to');
      renderCalendars();
      return;
    }
    
    if (selectingFor === 'from') {
      // Store current FROM time selection to preserve it
      const fromTimeValue = modalFromTime ? modalFromTime.querySelector('span').textContent : 'Time';
      const fromTimeWasSelected = fromTimeValue !== 'Time';
      
      // Reset date selections when starting a new range
      startDate = new Date(date);
      startDate.setHours(0, 0, 0, 0);
      endDate = null;
      
      // Clear TO date display
      if (modalToDate) {
        modalToDate.querySelector('span').textContent = 'Select date';
        modalToDate.classList.remove('jsc-modal-date-active');
      }
      if (toDateBtn) {
        toDateBtn.querySelector('span').textContent = 'Select date';
      }
      
      // Preserve TO time if it was selected (will be restored when TO date is selected)
      const toTimeValue = modalToTime ? modalToTime.querySelector('span').textContent : 'Time';
      const toTimeWasSelected = toTimeValue !== 'Time';
      
      if (!toTimeWasSelected) {
        // Clear TO time if it wasn't selected
        if (modalToTime) {
          modalToTime.querySelector('span').textContent = 'Time';
          modalToTime.querySelector('span').classList.remove('font-medium');
          modalToTime.disabled = true;
          modalToTime.classList.remove('active');
        }
        if (toTimeBtn && toTimeBtn.querySelector('span')) {
          toTimeBtn.querySelector('span').textContent = 'Time';
          toTimeBtn.querySelector('span').classList.remove('font-medium');
          toTimeBtn.disabled = true;
        }
      }
      
      // Store TO time value to restore later
      window.preservedToTime = toTimeWasSelected ? toTimeValue : null;
      
      // Preserve FROM time if it was already selected
      if (!fromTimeWasSelected) {
        // Clear FROM time if it wasn't selected
        if (modalFromTime) {
          modalFromTime.querySelector('span').textContent = 'Time';
          modalFromTime.querySelector('span').classList.remove('font-medium');
          modalFromTime.disabled = true;
        }
        if (fromTimeBtn && fromTimeBtn.querySelector('span')) {
          fromTimeBtn.querySelector('span').textContent = 'Time';
          fromTimeBtn.querySelector('span').classList.remove('font-medium');
          fromTimeBtn.disabled = true;
        }
      }
      
      updateDateDisplay('from', startDate);
      if (fromTimeBtn) {
        fromTimeBtn.disabled = false;
      }
      if (modalFromTime) {
        modalFromTime.disabled = false;
      }
      // Update delivery time if FROM time is already selected
      if (fromTimeWasSelected) {
        updateDeliveryTimeInFootnote();
      }
      selectingFor = 'to';
      updateSelectionMode('to');
      highlightActiveDate('to'); // This will remove active from FROM and add to TO
    } else if (selectingFor === 'to') {
      if (date >= startDate) {
        endDate = new Date(date);
        endDate.setHours(0, 0, 0, 0);
        updateDateDisplay('to', endDate);
        if (toTimeBtn) {
          toTimeBtn.disabled = false;
        }
        if (modalToTime) {
          modalToTime.disabled = false;
        }
        
        // Restore preserved TO time if available
        if (window.preservedToTime) {
          if (modalToTime && modalToTime.querySelector('span')) {
            modalToTime.querySelector('span').textContent = window.preservedToTime;
            modalToTime.querySelector('span').classList.add('font-medium');
          }
          if (toTimeBtn && toTimeBtn.querySelector('span')) {
            toTimeBtn.querySelector('span').textContent = window.preservedToTime;
            toTimeBtn.querySelector('span').classList.add('font-medium');
          }
          window.preservedToTime = null; // Clear preserved value
        }
        invalidateToTimeIfBeforeSameDayMinimum();
        
        // Remove active states from date inputs after TO date is selected
        if (modalFromDate) {
          modalFromDate.classList.remove('jsc-modal-date-active');
        }
        if (modalToDate) {
          modalToDate.classList.remove('jsc-modal-date-active');
        }
        selectingFor = null; // Clear selection mode
        updateSelectionMode(null);
        
        // Automatically prompt for FROM time selection after TO date is selected (only if not already selected)
        setTimeout(() => {
          if (modalFromTime && modalFromTime.querySelector('span').textContent === 'Time') {
            openTimePicker(modalFromTime, 'from');
          }
        }, 100);
      }
    }
    renderCalendars();
  }

  function getDateFromDayElement(dayEl) {
    // Get date from data attribute
    const dateTime = dayEl.getAttribute('data-date');
    if (!dateTime) return null;
    
    const date = new Date(parseInt(dateTime));
    date.setHours(0, 0, 0, 0);
    return date;
  }

  function updateSelectionMode(mode) {
    // Update modal class to show appropriate hover effects
    if (modal) {
      modal.classList.remove('selecting-from', 'selecting-to');
      if (mode === 'from') {
        modal.classList.add('selecting-from');
      } else if (mode === 'to') {
        modal.classList.add('selecting-to');
      }
    }
  }

  function updateDateDisplay(target, date) {
    const display = formatDate(date);
    if (target === 'from') {
      if (fromDateBtn) {
        fromDateBtn.querySelector('span').textContent = display;
        fromDateBtn.classList.add('jsc-date-btn-active');
      }
      if (modalFromDate) {
        modalFromDate.querySelector('span').textContent = display;
        modalFromDate.classList.add('jsc-modal-date-active');
      }
    } else {
      if (toDateBtn) {
        toDateBtn.querySelector('span').textContent = display;
      }
      if (modalToDate) {
        modalToDate.querySelector('span').textContent = display;
      }
    }
  }

  function highlightActiveDate(target) {
    if (modalFromDate) modalFromDate.classList.remove('jsc-modal-date-active');
    if (modalToDate) modalToDate.classList.remove('jsc-modal-date-active');
    if (target === 'from') {
      if (modalFromDate) modalFromDate.classList.add('jsc-modal-date-active');
    } else if (target === 'to') {
      if (modalToDate) modalToDate.classList.add('jsc-modal-date-active');
    }
    // If target is null/undefined, both dates are selected, so no active state needed
  }

  function openCalendar() {
    modal.classList.add('active');
    document.body.classList.add('jsc-date-modal-active'); // Add class to hide sticky ATC
    document.body.style.overflow = 'hidden'; // Prevent body scrolling when modal is open
    
    // Hide header and announcement bar when modal opens
    const headerWrapper = document.querySelector('.header__wrapper');
    const themeHeader = document.querySelector('.theme__header');
    const announcementBar = document.querySelector('.jsc-sticky-announcement-bar');
    
    if (headerWrapper) {
      headerWrapper.style.display = 'none';
      headerWrapper.style.visibility = 'hidden';
      headerWrapper.setAttribute('data-modal-hidden', 'true');
    }
    if (themeHeader) {
      themeHeader.style.display = 'none';
      themeHeader.style.visibility = 'hidden';
      themeHeader.setAttribute('data-modal-hidden', 'true');
    }
    if (announcementBar) {
      announcementBar.style.display = 'none';
      announcementBar.style.visibility = 'hidden';
      announcementBar.setAttribute('data-modal-hidden', 'true');
    }
    
    // If reopening with existing dates, keep them; otherwise reset
    // If user wants to select new dates, they'll click a FROM date which will reset everything
    if (!startDate) {
      selectingFor = 'from';
    } else if (startDate && !endDate) {
      selectingFor = 'to';
    } else {
      // If both dates are selected, allow user to select new FROM date to reset
      selectingFor = null; // Don't force selection mode when both dates are selected
    }
    
    updateSelectionMode(selectingFor);
    highlightActiveDate(selectingFor);
    renderCalendars(); // Always render calendars to show selected dates
  }

  function closeCalendar() {
    modal.classList.remove('active');
    document.body.classList.remove('jsc-date-modal-active'); // Remove class to show sticky ATC
    document.body.style.overflow = ''; // Restore body scrolling
    
    // Show header and announcement bar when modal closes
    const headerWrapper = document.querySelector('.header__wrapper[data-modal-hidden="true"]');
    const themeHeader = document.querySelector('.theme__header[data-modal-hidden="true"]');
    const announcementBar = document.querySelector('.jsc-sticky-announcement-bar[data-modal-hidden="true"]');
    
    if (headerWrapper) {
      headerWrapper.style.display = '';
      headerWrapper.style.visibility = '';
      headerWrapper.removeAttribute('data-modal-hidden');
    }
    if (themeHeader) {
      themeHeader.style.display = '';
      themeHeader.style.visibility = '';
      themeHeader.removeAttribute('data-modal-hidden');
    }
    if (announcementBar) {
      announcementBar.style.display = '';
      announcementBar.style.visibility = '';
      announcementBar.removeAttribute('data-modal-hidden');
    }
    
    selectingFor = null;
    updateSelectionMode(null);
    timePopup.classList.remove('active');
  }

  function openTimePicker(targetBtn, target) {
    activeTimePicker = target;
    timeList.innerHTML = '';
    
    // Add active class to the button being clicked
    const modalTimeBtn = target === 'from' ? modalFromTime : modalToTime;
    if (modalTimeBtn) {
      modalTimeBtn.classList.add('active');
      modalTimeBtn.focus();
    }

    // Determine which date is selected and check if it's Sunday
    const selectedDate = target === 'from' ? startDate : endDate;
    const isSunday = selectedDate && selectedDate.getDay() === 0;
    
    // Set start time: 10:30 AM for most days, 12:00 PM for Sunday
    let startHour = 10;
    let startMinute = 30;
    if (isSunday) {
      startHour = 12;
      startMinute = 0;
    }

    // Generate time slots (start time through 11:30 PM, plus 12:00 AM end-of-day, in 30-minute intervals)
    let times = [];
    for (let h = startHour; h <= 23; h++) {
      for (let m = (h === startHour ? startMinute : 0); m < 60; m += 30) {
        const time = new Date();
        time.setHours(h, m, 0, 0);
        times.push({ time, dayMinutes: h * 60 + m });
      }
    }
    const endOfDay = new Date();
    endOfDay.setHours(24, 0, 0, 0);
    times.push({ time: endOfDay, dayMinutes: 24 * 60 });

    const minSameDayToMin = getMinSameDayToMinutesFromFromTime();
    if (target === 'to' && minSameDayToMin !== null) {
      times = times.filter((entry) => entry.dayMinutes >= minSameDayToMin);
    }

    times.forEach(({ time }) => {
      const timeSlot = document.createElement('button');
      timeSlot.className = 'jsc-time-slot';
      timeSlot.textContent = formatTime(time);
      timeSlot.dataset.hours = time.getHours();
      timeSlot.dataset.minutes = time.getMinutes();
      
      timeSlot.addEventListener('click', () => {
        // Update modal time input
        const modalTimeBtn = target === 'from' ? modalFromTime : modalToTime;
        // Update external display button (shown after confirmation)
        const externalTimeBtn = target === 'from' ? fromTimeBtn : toTimeBtn;
        
        // Update modal time input
        if (modalTimeBtn && modalTimeBtn.querySelector('span')) {
          modalTimeBtn.querySelector('span').textContent = formatTime(time);
          modalTimeBtn.querySelector('span').classList.add('font-medium');
          modalTimeBtn.disabled = false;
          modalTimeBtn.classList.add('active');
        }
        
        // Update external display button
        if (externalTimeBtn && externalTimeBtn.querySelector('span')) {
          externalTimeBtn.querySelector('span').textContent = formatTime(time);
          externalTimeBtn.querySelector('span').classList.add('font-medium');
          externalTimeBtn.disabled = false;
        }
        
        // Update delivery time calculation if FROM time is selected
        if (target === 'from') {
          updateDeliveryTimeInFootnote();
          invalidateToTimeIfBeforeSameDayMinimum();
        }
        
        closeTimePicker();
        
        // After selecting FROM time, automatically prompt for TO time if TO date is selected
        if (target === 'from' && endDate && modalToTime && modalToTime.querySelector('span').textContent === 'Time') {
          setTimeout(() => {
            openTimePicker(modalToTime, 'to');
          }, 100);
        }
      });
      
      timeList.appendChild(timeSlot);
    });

    const btnRect = targetBtn.getBoundingClientRect();
    const modalRect = modal.querySelector('.jsc-modal-content').getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    
    // Calculate position relative to modal
    let leftPos = btnRect.left - modalRect.left;
    let topPos = btnRect.bottom - modalRect.top + 4;
    
    // Check if popup would overflow bottom of viewport, if so, position above button
    const popupHeight = 240; // max-height from CSS
    const spaceBelow = viewportHeight - btnRect.bottom;
    const spaceAbove = btnRect.top;
    
    if (spaceBelow < popupHeight && spaceAbove > spaceBelow) {
      // Position above the button if there's more space above
      topPos = btnRect.top - modalRect.top - popupHeight - 4;
      timePopup.classList.add('jsc-time-popup-above');
    } else {
      timePopup.classList.remove('jsc-time-popup-above');
    }
    
    // Check if popup would overflow right edge, adjust if needed
    const popupWidth = 160; // min-width from CSS
    const spaceRight = modalRect.right - btnRect.right;
    if (spaceRight < popupWidth) {
      leftPos = modalRect.width - popupWidth - 16; // Align to right with padding
    }
    
    timePopup.style.left = `${leftPos}px`;
    timePopup.style.top = `${topPos}px`;
    timePopup.classList.add('active');
  }

  function closeTimePicker() {
    timePopup.classList.remove('active');
    activeTimePicker = null;
    
    // Remove active class from time inputs
    if (modalFromTime) {
      modalFromTime.classList.remove('active');
      modalFromTime.blur();
    }
    if (modalToTime) {
      modalToTime.classList.remove('active');
      modalToTime.blur();
    }
    
    // Also remove active states from date inputs when time picker closes
    // (This ensures date inputs don't stay highlighted after time selection)
    if (modalFromDate && startDate && endDate) {
      modalFromDate.classList.remove('jsc-modal-date-active');
    }
    if (modalToDate && startDate && endDate) {
      modalToDate.classList.remove('jsc-modal-date-active');
    }
  }

  function clearDates() {
    startDate = null;
    endDate = null;
    if (fromDateBtn && fromDateBtn.querySelector('span')) fromDateBtn.querySelector('span').textContent = 'Select date';
    if (toDateBtn && toDateBtn.querySelector('span')) toDateBtn.querySelector('span').textContent = 'Select date';
    if (modalFromDate) modalFromDate.querySelector('span').textContent = 'Select date';
    if (modalToDate) modalToDate.querySelector('span').textContent = 'Select date';
    if (fromTimeBtn && fromTimeBtn.querySelector('span')) {
      fromTimeBtn.querySelector('span').textContent = 'Time';
      fromTimeBtn.querySelector('span').classList.remove('font-medium');
      fromTimeBtn.disabled = true;
    }
    if (toTimeBtn && toTimeBtn.querySelector('span')) {
      toTimeBtn.querySelector('span').textContent = 'Time';
      toTimeBtn.querySelector('span').classList.remove('font-medium');
      toTimeBtn.disabled = true;
    }
    if (modalFromTime) {
      modalFromTime.querySelector('span').textContent = 'Time';
      modalFromTime.querySelector('span').classList.remove('font-medium');
      modalFromTime.disabled = true;
    }
    if (modalToTime) {
      modalToTime.querySelector('span').textContent = 'Time';
      modalToTime.querySelector('span').classList.remove('font-medium');
      modalToTime.disabled = true;
    }
    
    if (fromDateBtn) fromDateBtn.classList.remove('jsc-date-btn-active');
    
    const eventDateInput = document.getElementById('event-date');
   const eventTimeInput = document.getElementById('event-time');
    if (eventDateInput) eventDateInput.value = '';
    if (eventTimeInput) eventTimeInput.value = '';
    
    // Reset display values
    const displayFromDatetime = document.getElementById('jsc-display-from-datetime');
    const displayToDatetime = document.getElementById('jsc-display-to-datetime');
    if (displayFromDatetime) displayFromDatetime.textContent = 'Select date and time';
    if (displayToDatetime) displayToDatetime.textContent = 'Select date and time';
    const displayFrom = document.getElementById('jsc-display-from');
    const displayTo = document.getElementById('jsc-display-to');
    if (displayFrom) {
      displayFrom.textContent = 'Select date and time';
      displayFrom.removeAttribute('data-date');
      displayFrom.removeAttribute('data-time');
    }
    if (displayTo) {
      displayTo.textContent = 'Select date and time';
      displayTo.removeAttribute('data-date');
      displayTo.removeAttribute('data-time');
    }
    
    // Show initial button and hide display
    if (openDateRangeBtn) {
      openDateRangeBtn.style.display = 'flex';
    }
    if (dateRangeDisplay) {
      dateRangeDisplay.style.display = 'none';
    }
    
    selectingFor = 'from';
    updateSelectionMode('from');
    renderCalendars();

    if (typeof validateEventBundleForm === 'function') {
      validateEventBundleForm();
    }
  }

  function confirmDates() {
    if (startDate && endDate) {
      // Check if FROM time is selected
      if (modalFromTime.querySelector('span').textContent === 'Time') {
        // Prompt for FROM time selection
        openTimePicker(modalFromTime, 'from');
        return;
      }
      
      // Check if TO time is selected
      if (modalToTime.querySelector('span').textContent === 'Time') {
        // Prompt for TO time selection
        openTimePicker(modalToTime, 'to');
        return;
      }

      const minSameDayTo = getMinSameDayToMinutesFromFromTime();
      const toMinConfirm = getMinutesFromMidnightForSameDayTo(modalToTime.querySelector('span').textContent);
      if (minSameDayTo !== null && toMinConfirm !== null && toMinConfirm < minSameDayTo) {
        alert('When delivery and collection are on the same date, collection time must be at least 3 hours after delivery time.');
        openTimePicker(modalToTime, 'to');
        return;
      }
      
      // Both dates and times are selected, proceed with confirmation
      // Update hidden inputs with FROM date/time
      const eventDateInput = document.getElementById('event-date');
      const eventTimeInput = document.getElementById('event-time');
      
      if (eventDateInput && startDate) {
        eventDateInput.value = formatDateToLocalYMD(startDate);
      }
      
      // Parse FROM time
      if (eventTimeInput && modalFromTime.querySelector('span').textContent !== 'Time') {
        const timeText = modalFromTime.querySelector('span').textContent;
        const match = timeText.match(/(\d+):(\d+)\s*(AM|PM)/i);
        if (match) {
          let hours = parseInt(match[1]);
          const minutes = parseInt(match[2]);
          const ampm = match[3].toUpperCase();
          if (ampm === 'PM' && hours !== 12) hours += 12;
          if (ampm === 'AM' && hours === 12) hours = 0;
          eventTimeInput.value = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
        }
      }
      
      // Get time texts
      const fromTimeText = modalFromTime.querySelector('span').textContent;
      const toTimeText = modalToTime.querySelector('span').textContent;
      
      // Format FROM date/time for delivery fields
      const fromDateFormatted = formatDateToLocalYMD(startDate); // YYYY-MM-DD (local calendar)
      let fromTimeFormatted = '00:00'; // Default to midnight
      if (fromTimeText && fromTimeText !== 'Time') {
        const timeMatch = fromTimeText.match(/(\d+):(\d+)\s*(AM|PM)/i);
        if (timeMatch) {
          let hours = parseInt(timeMatch[1]);
          const minutes = parseInt(timeMatch[2]);
          const ampm = timeMatch[3].toUpperCase();
          if (ampm === 'PM' && hours !== 12) hours += 12;
          if (ampm === 'AM' && hours === 12) hours = 0;
          fromTimeFormatted = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
        }
      }
      
      // Format TO date/time for collection fields
      const toDateFormatted = formatDateToLocalYMD(endDate); // YYYY-MM-DD (local calendar)
      let toTimeFormatted = '00:00'; // Default to midnight
      if (toTimeText && toTimeText !== 'Time') {
        const timeMatch = toTimeText.match(/(\d+):(\d+)\s*(AM|PM)/i);
        if (timeMatch) {
          let hours = parseInt(timeMatch[1]);
          const minutes = parseInt(timeMatch[2]);
          const ampm = timeMatch[3].toUpperCase();
          if (ampm === 'PM' && hours !== 12) hours += 12;
          if (ampm === 'AM' && hours === 12) hours = 0;
          toTimeFormatted = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
        }
      }
      
      // Store both FROM and TO in window.selectedEventDateTime
      window.selectedEventDateTime = {
        fromDate: fromDateFormatted,
        fromTime: fromTimeFormatted,
        fromTimeDisplay: fromTimeText, // Keep 12-hour format for display
        toDate: toDateFormatted,
        toTime: toTimeFormatted,
        toTimeDisplay: toTimeText, // Keep 12-hour format for display
        // Legacy support: use FROM for backward compatibility
        date: fromDateFormatted,
        time: fromTimeFormatted
      };
      
      // Update Delivery Date and Time fields with FROM date/time
      const deliveryDateInput = document.getElementById('delivery-date');
      const deliveryTimeInput = document.getElementById('delivery-time');
      
      if (deliveryDateInput) {
        deliveryDateInput.value = fromDateFormatted;
      }
      if (deliveryTimeInput && fromTimeText && fromTimeText !== 'Time') {
        deliveryTimeInput.value = fromTimeText; // Already in 12-hour format
      }
      
      // Update Collection Date and Time with TO date/time (auto-filled, read-only)
      const collectionDateInput = document.getElementById('collection-date');
      const collectionTimeInput = document.getElementById('collection-time');
      
      if (collectionDateInput && endDate) {
        collectionDateInput.value = toDateFormatted; // Use TO date
      }
      
      if (collectionTimeInput && toTimeText && toTimeText !== 'Time') {
        collectionTimeInput.value = toTimeText; // Use TO time (already in 12-hour format)
      }
      
      // Hide the initial button and show the date range display
      if (openDateRangeBtn) {
        openDateRangeBtn.style.display = 'none';
      }
      if (dateRangeDisplay) {
        dateRangeDisplay.style.display = dateRangeDisplay.classList.contains('eb-form-grid') ? 'grid' : 'block';
      }
      
      // Update the date and time displays in the date range display section
      // Format dates for display (e.g., "Nov 14 2025, 11:00AM")
      const formatDateForDisplay = (date, timeText) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const month = months[date.getMonth()];
        const day = date.getDate();
        const year = date.getFullYear();
        return `${month} ${day} ${year}, ${timeText}`;
      };
      
      // Update FROM display
      const displayFrom = document.getElementById('jsc-display-from');
      if (displayFrom) {
        const displayText = formatDateForDisplay(startDate, fromTimeText);
        displayFrom.textContent = displayText;
        // Store date as data attribute for easy restoration (use local date to avoid timezone issues)
        const fromYear = startDate.getFullYear();
        const fromMonth = String(startDate.getMonth() + 1).padStart(2, '0');
        const fromDay = String(startDate.getDate()).padStart(2, '0');
        displayFrom.setAttribute('data-date', `${fromYear}-${fromMonth}-${fromDay}`);
        displayFrom.setAttribute('data-time', fromTimeText);
      }
      
      // Update TO display
      const displayTo = document.getElementById('jsc-display-to');
      if (displayTo) {
        const displayText = formatDateForDisplay(endDate, toTimeText);
        displayTo.textContent = displayText;
        // Store date as data attribute for easy restoration (use local date to avoid timezone issues)
        const toYear = endDate.getFullYear();
        const toMonth = String(endDate.getMonth() + 1).padStart(2, '0');
        const toDay = String(endDate.getDate()).padStart(2, '0');
        displayTo.setAttribute('data-date', `${toYear}-${toMonth}-${toDay}`);
        displayTo.setAttribute('data-time', toTimeText);
      }
      
      closeCalendar();
      
      // Update delivery time calculation in footnote
      updateDeliveryTimeInFootnote();

      if (typeof validateEventBundleForm === 'function') {
        validateEventBundleForm();
      }
    } else if (startDate && !endDate) {
      // Only FROM date selected, still need TO date
      alert('Please select both FROM and TO dates');
    } else {
      alert('Please select both FROM and TO dates');
    }
  }

  // Function to calculate and update delivery time in footnote (T-2 hours)
  function updateDeliveryTimeInFootnote() {
    const deliveryTimeElement = document.getElementById('jsc-calculated-delivery-time');
    if (!deliveryTimeElement) return;
    
    // Get FROM date and time
    if (!startDate || !modalFromTime) {
      deliveryTimeElement.textContent = '8:30 AM';
      return;
    }
    
    const fromTimeText = modalFromTime.querySelector('span').textContent;
    if (!fromTimeText || fromTimeText === 'Time') {
      deliveryTimeElement.textContent = '8:30 AM';
      return;
    }
    
    // Parse FROM time (format: "9:00 AM" or "1:30 PM")
    const timeMatch = fromTimeText.match(/(\d+):(\d+)\s*(AM|PM)/i);
    if (!timeMatch) {
      deliveryTimeElement.textContent = '8:30 AM';
      return;
    }
    
    let hours = parseInt(timeMatch[1]);
    const minutes = parseInt(timeMatch[2]);
    const ampm = timeMatch[3].toUpperCase();
    
    // Convert to 24-hour format
    if (ampm === 'PM' && hours !== 12) hours += 12;
    if (ampm === 'AM' && hours === 12) hours = 0;
    
    // Create date object with FROM date and time
    const eventDateTime = new Date(startDate);
    eventDateTime.setHours(hours, minutes, 0, 0);
    
    // Calculate delivery time (2 hours before event start)
    const deliveryDateTime = new Date(eventDateTime.getTime() - (2 * 60 * 60 * 1000));
    
    // Format delivery time for display (12-hour format)
    const deliveryHours = deliveryDateTime.getHours();
    const deliveryMinutes = deliveryDateTime.getMinutes();
    const displayHours = deliveryHours > 12 ? deliveryHours - 12 : (deliveryHours === 0 ? 12 : deliveryHours);
    const deliveryAmpm = deliveryHours >= 12 ? 'PM' : 'AM';
    const deliveryTimeDisplay = `${displayHours}:${deliveryMinutes.toString().padStart(2, '0')} ${deliveryAmpm}`;
    
    // Update the element
    deliveryTimeElement.textContent = deliveryTimeDisplay;
  }

  // Open modal when clicking initial button
  if (openDateRangeBtn) {
    openDateRangeBtn.addEventListener('click', () => {
      closeTimePicker();
      openCalendar();
    });
  }

  // Open modal when clicking date range display (for editing)
  // Attach to both the container and the inner div to ensure clicks work
  const dateRangeInputs = dateRangeDisplay ? dateRangeDisplay.querySelector('.jsc-date-range-inputs') : null;
  
  const handleDateRangeDisplayClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    closeTimePicker();
      
      // Restore selected dates and times when reopening calendar from data attributes
      const displayFrom = document.getElementById('jsc-display-from');
      const displayTo = document.getElementById('jsc-display-to');
      
      if (displayFrom && displayFrom.hasAttribute('data-date')) {
        // Restore FROM date from data attribute
        const fromDateStr = displayFrom.getAttribute('data-date');
        const fromTimeStr = displayFrom.getAttribute('data-time') || 'Time';
        
        if (fromDateStr) {
          // Parse date string (YYYY-MM-DD) as local date to avoid timezone issues
          const [year, month, day] = fromDateStr.split('-').map(Number);
          startDate = new Date(year, month - 1, day); // month is 0-indexed
          startDate.setHours(0, 0, 0, 0);
          
          // Restore time in modal
          if (modalFromTime) {
            if (fromTimeStr !== 'Time') {
              modalFromTime.querySelector('span').textContent = fromTimeStr;
              modalFromTime.querySelector('span').classList.add('font-medium');
              modalFromTime.disabled = false;
            } else {
              // Reset time if it wasn't selected
              modalFromTime.querySelector('span').textContent = 'Time';
              modalFromTime.querySelector('span').classList.remove('font-medium');
              modalFromTime.disabled = true;
            }
          }
          
          // Update modal header
          if (modalFromDate) {
            modalFromDate.querySelector('span').textContent = formatDate(startDate);
            // Remove active state when reopening - dates are already selected
            modalFromDate.classList.remove('jsc-modal-date-active');
          }
        }
      }
      
      if (displayTo && displayTo.hasAttribute('data-date')) {
        // Restore TO date from data attribute
        const toDateStr = displayTo.getAttribute('data-date');
        const toTimeStr = displayTo.getAttribute('data-time') || 'Time';
        
        if (toDateStr) {
          // Parse date string (YYYY-MM-DD) as local date to avoid timezone issues
          const [year, month, day] = toDateStr.split('-').map(Number);
          endDate = new Date(year, month - 1, day); // month is 0-indexed
          endDate.setHours(0, 0, 0, 0);
          
          // Restore time in modal
          if (modalToTime) {
            if (toTimeStr !== 'Time') {
              modalToTime.querySelector('span').textContent = toTimeStr;
              modalToTime.querySelector('span').classList.add('font-medium');
              modalToTime.disabled = false;
            } else {
              // Reset time if it wasn't selected
              modalToTime.querySelector('span').textContent = 'Time';
              modalToTime.querySelector('span').classList.remove('font-medium');
              modalToTime.disabled = true;
            }
          }
          
          // Update modal header
          if (modalToDate) {
            modalToDate.querySelector('span').textContent = formatDate(endDate);
            // Remove active state when reopening - dates are already selected
            modalToDate.classList.remove('jsc-modal-date-active');
          }
        }
      }

      invalidateToTimeIfBeforeSameDayMinimum();
      
      // Set selection mode and render calendars
      if (startDate && endDate) {
        selectingFor = null; // Both selected, allow direct reselection
      } else if (startDate) {
        selectingFor = 'to';
      } else {
        selectingFor = 'from';
      }
      
      // Update calendar month to show the selected dates
      if (startDate) {
        currentMonth = startDate.getMonth();
        currentYear = startDate.getFullYear();
      }
      
      // Re-render calendars first to show selected dates
      renderCalendars();
      
      // Then open the modal
      openCalendar();
    };
  
  const dateRangeEditBtns = dateRangeDisplay
    ? dateRangeDisplay.querySelectorAll('.jsc-date-range-edit-btn')
    : [];

  if (dateRangeDisplay && !dateRangeDisplay.classList.contains('eb-form-grid')) {
    dateRangeDisplay.addEventListener('click', handleDateRangeDisplayClick);
  }
  if (dateRangeInputs) {
    dateRangeInputs.addEventListener('click', handleDateRangeDisplayClick);
  }
  dateRangeEditBtns.forEach((editBtn) => {
    editBtn.addEventListener('click', handleDateRangeDisplayClick);
  });

  // Event listeners for date/time buttons (if they exist - they may not be in the HTML anymore)
  if (fromDateBtn) {
    fromDateBtn.addEventListener('click', () => {
      closeTimePicker();
      // Clicking FROM date resets to allow new selection
      if (startDate && endDate) {
        // Preserve FROM time selection
        const fromTimeValue = modalFromTime ? modalFromTime.querySelector('span').textContent : 'Time';
        const fromTimeWasSelected = fromTimeValue !== 'Time';
        
        // Reset all selections if both dates were already selected
        startDate = null;
        endDate = null;
        
        // Preserve TO time if it was selected (will be restored when TO date is selected)
        const toTimeValue = modalToTime ? modalToTime.querySelector('span').textContent : 'Time';
        const toTimeWasSelected = toTimeValue !== 'Time';
        
        if (!toTimeWasSelected) {
          // Clear TO time if it wasn't selected
          if (modalToTime) {
            modalToTime.querySelector('span').textContent = 'Time';
            modalToTime.querySelector('span').classList.remove('font-medium');
            modalToTime.disabled = true;
            modalToTime.classList.remove('active');
          }
          if (toTimeBtn && toTimeBtn.querySelector('span')) {
            toTimeBtn.querySelector('span').textContent = 'Time';
            toTimeBtn.querySelector('span').classList.remove('font-medium');
            toTimeBtn.disabled = true;
          }
        }
        
        // Store TO time value to restore later
        window.preservedToTime = toTimeWasSelected ? toTimeValue : null;
        
        // Preserve FROM time if it was selected
        if (!fromTimeWasSelected) {
          if (modalFromTime) {
            modalFromTime.querySelector('span').textContent = 'Time';
            modalFromTime.querySelector('span').classList.remove('font-medium');
            modalFromTime.disabled = true;
            modalFromTime.classList.remove('active');
          }
          if (fromTimeBtn && fromTimeBtn.querySelector('span')) {
            fromTimeBtn.querySelector('span').textContent = 'Time';
            fromTimeBtn.querySelector('span').classList.remove('font-medium');
            fromTimeBtn.disabled = true;
          }
        }
      }
      selectingFor = 'from';
      updateSelectionMode('from');
      openCalendar();
    });
  }

  if (toDateBtn) {
    toDateBtn.addEventListener('click', () => {
      closeTimePicker();
      if (startDate) {
        openCalendar();
        selectingFor = 'to';
        updateSelectionMode('to');
        highlightActiveDate('to');
      }
    });
  }

  if (fromTimeBtn) {
    fromTimeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      if (!startDate) {
        openCalendar();
        return;
      }
      closeTimePicker();
      openTimePicker(fromTimeBtn, 'from');
    });
  }

  if (toTimeBtn) {
    toTimeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      if (!endDate) {
        if (!startDate) openCalendar();
        return;
      }
      closeTimePicker();
      openTimePicker(toTimeBtn, 'to');
    });
  }

  modalFromDate.addEventListener('click', () => {
    closeTimePicker();
    // Clicking FROM date resets to allow new selection
    if (startDate && endDate) {
      // Preserve FROM time selection
      const fromTimeValue = modalFromTime ? modalFromTime.querySelector('span').textContent : 'Time';
      const fromTimeWasSelected = fromTimeValue !== 'Time';
      
      // Reset all selections if both dates were already selected
      startDate = null;
      endDate = null;
      
      // Preserve TO time if it was selected (will be restored when TO date is selected)
      const toTimeValue = modalToTime ? modalToTime.querySelector('span').textContent : 'Time';
      const toTimeWasSelected = toTimeValue !== 'Time';
      
      if (!toTimeWasSelected) {
        // Clear TO time if it wasn't selected
        if (modalToTime) {
          modalToTime.querySelector('span').textContent = 'Time';
          modalToTime.querySelector('span').classList.remove('font-medium');
          modalToTime.disabled = true;
          modalToTime.classList.remove('active');
        }
        if (toTimeBtn && toTimeBtn.querySelector('span')) {
          toTimeBtn.querySelector('span').textContent = 'Time';
          toTimeBtn.querySelector('span').classList.remove('font-medium');
          toTimeBtn.disabled = true;
        }
      }
      
      // Store TO time value to restore later
      window.preservedToTime = toTimeWasSelected ? toTimeValue : null;
      
      // Preserve FROM time if it was selected
      if (!fromTimeWasSelected) {
        if (modalFromTime) {
          modalFromTime.querySelector('span').textContent = 'Time';
          modalFromTime.querySelector('span').classList.remove('font-medium');
          modalFromTime.disabled = true;
          modalFromTime.classList.remove('active');
        }
        if (fromTimeBtn && fromTimeBtn.querySelector('span')) {
          fromTimeBtn.querySelector('span').textContent = 'Time';
          fromTimeBtn.querySelector('span').classList.remove('font-medium');
          fromTimeBtn.disabled = true;
        }
      }
      
      // Clear TO date display
      if (modalToDate) {
        modalToDate.querySelector('span').textContent = 'Select date';
        modalToDate.classList.remove('jsc-modal-date-active');
      }
      if (toDateBtn) {
        toDateBtn.querySelector('span').textContent = 'Select date';
      }
    }
    selectingFor = 'from';
    updateSelectionMode('from');
    highlightActiveDate('from');
    renderCalendars();
  });

  modalToDate.addEventListener('click', () => {
    closeTimePicker();
    if (startDate) {
      selectingFor = 'to';
      updateSelectionMode('to');
      highlightActiveDate('to');
    }
  });

  modalFromTime.addEventListener('click', (e) => {
    e.stopPropagation();
    if (!startDate) return;
    openTimePicker(modalFromTime, 'from');
  });

  modalToTime.addEventListener('click', (e) => {
    e.stopPropagation();
    if (!endDate) return;
    openTimePicker(modalToTime, 'to');
  });

  prevMonthBtn.addEventListener('click', () => {
    currentMonth--;
    if (currentMonth < 0) {
      currentMonth = 11;
      currentYear--;
    }
    renderCalendars();
  });

  nextMonthBtn.addEventListener('click', () => {
    currentMonth++;
    if (currentMonth > 11) {
      currentMonth = 0;
      currentYear++;
    }
    renderCalendars();
  });

  clearDatesBtn.addEventListener('click', clearDates);
  confirmDatesBtn.addEventListener('click', confirmDates);

  overlay.addEventListener('click', closeCalendar);

  document.addEventListener('click', (e) => {
    const isClickInsideModal = modal.contains(e.target);
    const isClickOnCalendarDay = e.target.classList.contains('jsc-calendar-day') || e.target.closest('.jsc-calendar-day');
    const isClickInsideTime = timePopup.contains(e.target) || (modalFromTime && modalFromTime.contains(e.target)) || (modalToTime && modalToTime.contains(e.target));
    const isClickOnOpenBtn = openDateRangeBtn && openDateRangeBtn.contains(e.target);
    
    // Don't close modal if clicking on calendar days or inside modal
    if (!isClickInsideModal && !isClickOnCalendarDay && !isClickOnOpenBtn && !(fromDateBtn && fromDateBtn.contains(e.target)) && !(toDateBtn && toDateBtn.contains(e.target))) {
      closeCalendar();
    }
    
    // Don't close time picker if clicking on time slots
    const isClickOnTimeSlot = e.target.classList.contains('jsc-time-slot') || e.target.closest('.jsc-time-slot');
    if (!isClickInsideTime && !isClickOnTimeSlot) {
      closeTimePicker();
    }
  });

  // Initialize calendar on load
  renderCalendars();
};
selectEventTimeOption = (option) => {
  const eventTimeInput = document.getElementById('event-time');
  if (eventTimeInput) {
    eventTimeInput.value = option.getAttribute('data-value');
    
    // Calculate delivery time (30 minutes before selected time)
    const selectedTime = option.getAttribute('data-value');
    const [hours, minutes] = selectedTime.split(':').map(Number);
    const selectedDateTime = new Date();
    selectedDateTime.setHours(hours, minutes, 0, 0);
    
    // Subtract 30 minutes
    const deliveryDateTime = new Date(selectedDateTime.getTime() - (30 * 60 * 1000));
    
    // Format delivery time
    const deliveryHours = deliveryDateTime.getHours();
    const deliveryMinutes = deliveryDateTime.getMinutes();
    const deliveryTimeStr = `${deliveryHours.toString().padStart(2, '0')}:${deliveryMinutes.toString().padStart(2, '0')}`;
    
    // Format selected time for display
    const displayHours = hours > 12 ? hours - 12 : (hours === 0 ? 12 : hours);
    const ampm = hours >= 12 ? 'pm' : 'am';
    const selectedTimeStr = `${displayHours}:${minutes.toString().padStart(2, '0')}${ampm}`;
    
    // Format delivery time for display
    const deliveryDisplayHours = deliveryHours > 12 ? deliveryHours - 12 : (deliveryHours === 0 ? 12 : deliveryHours);
    const deliveryAmpm = deliveryHours >= 12 ? 'pm' : 'am';
    const deliveryTimeDisplay = `${deliveryDisplayHours}:${deliveryMinutes.toString().padStart(2, '0')}${deliveryAmpm}`;
    
    $('.timeSelectNotify').text(`Items will be delivered between ${deliveryTimeDisplay} - ${selectedTimeStr}`);
  }
  $('.jsc-fake-dropdown').hide();

  if (typeof validateEventBundleForm === 'function') {
    validateEventBundleForm();
  }
}

selectCollectionTimeOption = (option) => {
  const collectionTimeInput = document.getElementById('collection-time');
  if (collectionTimeInput) {
    collectionTimeInput.value = option.getAttribute('data-value');
    // Validate form after collection time selection
    validateEventBundleForm();
  }
  $('.jsc-collection-time-dropdown').hide();
}

// start: bundle event product mobile image drawer
function jscInitDrawerProductGallery($drawer) {
   var slideshow = $drawer.find('[data-drawer-native-scroll]')[0];
   if (!slideshow) {
      return;
   }

   window.setTimeout(function () {
      slideshow.scrollLeft = 0;
   }, 0);
}

function jscOpenProductImageDrawer($trigger) {
   var drawerId = $trigger.attr('aria-controls');
   if (!drawerId) {
      return;
   }

   var $drawer = $('#' + drawerId);
   if (!$drawer.length) {
      return;
   }

   $drawer.addClass('is-open is-ready').attr('aria-hidden', 'false');
   $trigger.attr('aria-expanded', 'true');
   document.body.classList.add('product__title__image-drawer-open');

   if ($drawer.find('[data-product-drawer-gallery]').length) {
      window.setTimeout(function () {
         jscInitDrawerProductGallery($drawer);
      }, 50);
   }
}

function jscCloseProductImageDrawer($drawer) {
   if (!$drawer || !$drawer.length) {
      return;
   }

   var drawerId = $drawer.attr('id');
   $drawer.removeClass('is-open').attr('aria-hidden', 'true');

   if (drawerId) {
      $('[aria-controls="' + drawerId + '"]').attr('aria-expanded', 'false');
   }

   if (!$('.product__title__image-drawer.is-open').length) {
      document.body.classList.remove('product__title__image-drawer-open');
   }
}

function initProductImageDrawer() {
   $('.product__title__image-drawer').each(function () {
      var drawer = this;
      if (drawer.parentNode && drawer.parentNode !== document.body) {
         document.body.appendChild(drawer);
      }
   });

   $(document).on('click', '[data-product-image-drawer-open]', function (e) {
      e.preventDefault();
      jscOpenProductImageDrawer($(this));
   });

   $(document).on('click', '[data-product-image-drawer-close]', function (e) {
      e.preventDefault();
      jscCloseProductImageDrawer($(this).closest('.product__title__image-drawer'));
   });
}
// end: bundle event product mobile image drawer

// start: reset bundle page after ATC is completed
resetEventBundlePage = () => {
   if (!$('.jsc-event-bundle-data').length) return;

   $('.js-quantity-wrapper-event input[data-quantity-input-event-bundle]').each(function() {
      var $input = $(this);
      $input.val(0);
      var $wrapper = $input.closest('.js-quantity-wrapper-event');
      var $outerProdGrid = $input.closest('.product-grid-item');
      var thisBlock = $input.closest('.product__block__quantity');
      $wrapper.hide().removeClass('jsc-event-flavour-selected');
      $outerProdGrid.removeClass('jsc-event-flavour-selected');
      $outerProdGrid.find('.jsc-bundle-product-selected-qty span').text('0');
      thisBlock.find('.jsc-atc-event-flavour').css('display', 'inline-block');
   });

   $('.jsc-summary-flavour').remove();

   var eventBundleData = $('.jsc-event-bundle-data');
   var eventBundleMinTotalQty = parseInt(eventBundleData.attr('data-min-total-quantity'), 10);
   eventBundleData.attr('data-event-bundle-total-price', '0.00');
   eventBundleData.attr('data-below-min', 'true');
   $('.jsc-flavour-summary-bundle-msg').text(`Please select a minimum of ${eventBundleMinTotalQty} cups`);

   var eventTypeSelect = document.getElementById('event-type-select');
   if (eventTypeSelect) {
      eventTypeSelect.value = '';
      eventTypeSelect.dispatchEvent(new Event('change', { bubbles: true }));
   }
   var eventTypeValue = document.querySelector('#event-type-select-trigger .event-bundle-select-value');
   if (eventTypeValue) eventTypeValue.textContent = 'Select event type';
   document.querySelectorAll('#event-type-select-dropdown .event-bundle-select-option').forEach(function(option) {
      option.classList.remove('selected');
   });

   var standardDelivery = document.querySelector('input[name="delivery_option"][value="standard"]');
   if (standardDelivery) standardDelivery.checked = true;

   var clearDatesBtn = document.getElementById('jsc-clear-dates');
   if (clearDatesBtn) {
      clearDatesBtn.click();
   } else {
      var eventDateInput = document.getElementById('event-date');
      var eventTimeInput = document.getElementById('event-time');
      if (eventDateInput) {
         eventDateInput.value = '';
         if (eventDateInput._flatpickr) eventDateInput._flatpickr.clear();
      }
      if (eventTimeInput) eventTimeInput.value = '';
   }

   ['delivery-date', 'delivery-time', 'collection-date', 'collection-time'].forEach(function(fieldId) {
      var field = document.getElementById(fieldId);
      if (field) field.value = '';
   });

   delete window.selectedEventDateTime;
   delete window.eventBundleDetails;
   $('.timeSelectNotify').text('');

   updateTotalQuantityEventBundle();
   updateTotalEventBundlePrice();
   $('.jsc-summary-total-price .jsc-summary-price').text('$0');
   $('.jsc-summary-price-details .jsc-summary-price').text('$0');
   eventBundleData.attr('data-event-bundle-total-price', '0.00');
   checkEventBundleStatus();
   updateEventBundleAddButtons();
   updateMainButtonText();

   if (typeof updateEventBundleSummary === 'function') {
      updateEventBundleSummary();
   }

   var addToCartBtn = document.querySelector('.jsc-atc-event-bundle');
   if (addToCartBtn) {
      var $addToCartBtn = $(addToCartBtn);
      $addToCartBtn.removeClass('loading').attr('disabled', true);
      $addToCartBtn.find('.jsc-bundle-atc-text').show();
      $addToCartBtn.find('.btn-state-loading').hide();
   }

   if (typeof validateEventBundleForm === 'function') {
      validateEventBundleForm();
   }
}
// end: reset bundle page after ATC is completed

document.addEventListener('theme:sliderule:close', function () {
   var drawer = document.querySelector('[data-drawer="hamburger"]');
   if (!drawer) return;
   drawer.querySelectorAll('[data-accordion-body]').forEach(function (body) {
      body.dispatchEvent(new CustomEvent('theme:accordion:close', { bubbles: false }));
   });
});
